<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <section class="inet-page">
    <header class="hero-card panel">
      <div class="hero-top">
        <div class="hero-control-row">
          <div class="office-filter-row hero-office-row">
            <div ref="officeFilterRef" class="office-filter-wrap">
              <button
                type="button"
                class="office-filter-btn"
                @click="officeMenuOpen = !officeMenuOpen"
              >
                <span class="office-filter-label">국사 <strong>{{ selectedOfficeLabel }}</strong></span>
              </button>

              <div v-if="officeMenuOpen" class="office-menu">
                <button type="button" class="office-option" @click="handleOfficeSelect(null)">전체</button>
                <button
                  v-for="office in officeOptions"
                  :key="office"
                  type="button"
                  class="office-option"
                  :class="{ 'default-office-option': office === defaultOfficeName }"
                  @click="handleOfficeSelect(office)"
                >
                  {{ office }}
                </button>
              </div>
            </div>

          </div>

          <button type="button" class="score-open-btn" @click="openScoreboard">스코어</button>

          <div ref="accountMenuRef" class="auth-pill" :class="{ offline: !isLoggedIn }">
            <button
              type="button"
              class="auth-account-btn"
              @click="toggleAccountMenu"
            >
              <div class="auth-avatar">{{ userInitial }}</div>
              <div class="auth-meta">
                <strong>{{ currentUserLabel }}님</strong>
                <span>{{ isLoggedIn ? "로그인됨" : "로그인이 필요합니다" }}</span>
              </div>
              <span class="auth-caret">{{ accountMenuOpen ? "▴" : "▾" }}</span>
            </button>
            <button
              type="button"
              class="btn btn-ghost btn-mini"
              @click="isLoggedIn ? logoutFromInet() : goToSunghoLogin()"
            >
              {{ isLoggedIn ? "나가기" : "로그인" }}
            </button>
            <div v-if="accountMenuOpen && isLoggedIn" class="account-menu">
              <button type="button" class="account-menu-item" @click="openAccountPanel('profile')">내 계정</button>
              <button
                v-if="isInetAdmin"
                type="button"
                class="account-menu-item"
                @click="openAccountPanel('admin')"
              >
                관리자 모드
              </button>
              <button
                v-if="isInetAdmin"
                type="button"
                class="account-menu-item"
                @click="openAdminFacilityPanel"
              >
                시설수정
              </button>
            </div>
          </div>
        </div>

        <div class="hero-brand-block">
          <p class="hero-eyebrow">시설 위치정보</p>
          <div class="hero-brand">
            <img :src="sunghoMark" alt="성호넷 마크" class="hero-brand-mark" />
            <span class="hero-brand-name">성호넷</span>
            <span class="hero-brand-by">By Hwan</span>
          </div>
        </div>
      </div>
    </header>

    <section class="search-card panel">
      <div class="search-line">
        <input
          v-model="query"
          type="text"
          name="inet-search-query"
          autocomplete="off"
          autocapitalize="off"
          autocorrect="off"
          spellcheck="false"
          placeholder="시설 검색"
          @keyup.enter="fetchItems"
        />
        <button type="button" class="btn btn-primary" @click="fetchItems">검색</button>
      </div>

      <div class="search-actions">
        <button type="button" class="btn btn-secondary" @click="refresh">새로고침</button>
        <button type="button" class="btn btn-primary" @click="openCreate">건물등록</button>
      </div>

      <button
        v-if="query.trim()"
        type="button"
        class="btn btn-ghost"
        @click="clearQueryAndFetch"
      >
        필터해제
      </button>

      <p v-if="listError" class="error-text">{{ listError }}</p>
    </section>

    <transition name="notice-fade">
      <div v-if="noticeMessage" class="inet-notice" :class="`inet-notice-${noticeTone}`">
        <span>{{ noticeMessage }}</span>
        <button type="button" class="inet-notice-close" @click="clearNotice">닫기</button>
      </div>
    </transition>

    <teleport to="body">
      <div v-if="accountPanelOpen" class="modal-backdrop" @click.self="closeAccountPanel">
        <article class="modal-shell account-shell">
          <header class="modal-header account-header">
            <div class="account-title-wrap">
              <h3>{{ accountPanelTab === "admin" ? "관리자 모드" : accountPanelTab === "facility" ? "시설수정" : "내 계정" }}</h3>
              <p v-if="accountProfile && accountPanelTab !== 'facility'" class="account-subtitle">
                {{ accountProfile.display_name }} · {{ accountProfile.login_id }}
              </p>
            </div>
            <button type="button" class="close-btn" @click="closeAccountPanel">닫기</button>
          </header>

          <div v-if="accountPanelTab !== 'facility'" class="account-tab-row">
            <button
              type="button"
              class="account-tab-btn"
              :class="{ active: accountPanelTab === 'profile' }"
              @click="accountPanelTab = 'profile'"
            >
              내 계정
            </button>
            <button
              v-if="isInetAdmin"
              type="button"
              class="account-tab-btn"
              :class="{ active: accountPanelTab === 'admin' }"
              @click="openAccountPanel('admin')"
            >
              관리자
            </button>
          </div>

          <div class="detail-content-scroll account-content-scroll">
            <p v-if="accountError" class="error-text">{{ accountError }}</p>

            <template v-if="accountPanelTab === 'profile'">
              <section class="account-card">
                <div class="account-card-head">
                  <h4>계정 정보</h4>
                </div>
                <div v-if="accountProfile" class="account-info-grid">
                  <div><strong>로그인 아이디</strong><span>{{ accountProfile.login_id }}</span></div>
                  <div><strong>이름</strong><span>{{ accountProfile.display_name }}</span></div>
                  <div><strong>아이디 변경 잔여</strong><span>{{ accountProfile.login_change_remaining }}회</span></div>
                </div>
              </section>

              <section class="account-card">
                <div class="account-card-head">
                  <h4>비밀번호 변경</h4>
                </div>
                <div class="account-form-grid">
                  <input v-model="accountPasswordForm.current_password" type="password" placeholder="현재 비밀번호" autocomplete="current-password" />
                  <input v-model="accountPasswordForm.new_password" type="password" placeholder="새 비밀번호" autocomplete="new-password" />
                  <input v-model="accountPasswordForm.confirm_password" type="password" placeholder="새 비밀번호 확인" autocomplete="new-password" />
                </div>
                <div class="account-card-actions">
                  <button type="button" class="btn btn-primary" :disabled="accountSubmitting" @click="submitAccountPasswordChange">
                    {{ accountSubmitting ? "처리중..." : "비밀번호 변경" }}
                  </button>
                </div>
              </section>

              <section class="account-card">
                <div class="account-card-head">
                  <h4>아이디 변경</h4>
                  <span class="muted">1회만 가능합니다. (남은횟수 {{ accountProfile ? accountProfile.login_change_remaining : 0 }}회)</span>
                </div>
                <div class="account-form-grid">
                  <input v-model="accountLoginIdForm.current_password" type="password" placeholder="현재 비밀번호" autocomplete="current-password" />
                  <input
                    v-model="accountLoginIdForm.new_login_id"
                    type="text"
                    placeholder="새 로그인 아이디"
                    autocomplete="off"
                    :disabled="!accountProfile || accountProfile.login_change_remaining <= 0"
                  />
                </div>
                <div class="account-card-actions">
                  <button
                    type="button"
                    class="btn btn-primary"
                    :disabled="accountSubmitting || !accountProfile || accountProfile.login_change_remaining <= 0"
                    @click="submitAccountLoginIdChange"
                  >
                    {{ accountSubmitting ? "처리중..." : "아이디 변경" }}
                  </button>
                </div>
              </section>
            </template>

            <template v-else-if="accountPanelTab === 'facility' && isInetAdmin">
              <section class="account-card">
                <div class="account-card-head">
                  <h4>시설수정 목록</h4>
                  <button type="button" class="btn btn-ghost btn-mini" :disabled="facilityAdminLoading" @click="loadFacilityAdminLists">
                    새로고침
                  </button>
                </div>
                <p v-if="facilityAdminLoading" class="muted">목록을 불러오는 중입니다.</p>
                <div v-else class="account-form-grid">
                  <select v-model="selectedAdminOfficeId">
                    <option value="">국사를 선택하세요</option>
                    <option v-for="office in adminOfficeItems" :key="`office-${office.office_id || office.office_name}`" :value="String(office.office_id || '')">
                      {{ office.office_name }} ({{ office.building_count }}건)
                    </option>
                  </select>
                </div>
                <p v-if="selectedAdminOfficeItem" class="muted">
                  선택 국사: {{ selectedAdminOfficeItem.office_name }} / {{ selectedAdminOfficeItem.building_count }}건
                </p>
                <div class="account-card-actions option-list-actions">
                  <button type="button" class="btn btn-primary" :disabled="!selectedAdminOfficeItem" @click="renameFacilityField('office', selectedAdminOfficeItem)">
                    수정
                  </button>
                  <button type="button" class="btn btn-ghost" :disabled="!selectedAdminOfficeItem || Number(selectedAdminOfficeItem.building_count || 0) > 0" @click="deleteFacilityField('office', selectedAdminOfficeItem)">
                    삭제
                  </button>
                </div>
                <p v-if="selectedAdminOfficeItem && Number(selectedAdminOfficeItem.building_count || 0) > 0" class="muted">
                  건물 데이터가 있으면 국사는 삭제할 수 없습니다.
                </p>
              </section>

              <section class="account-card">
                <div class="account-card-head">
                  <h4>행정동 목록</h4>
                </div>
                <p v-if="facilityAdminLoading" class="muted">목록을 불러오는 중입니다.</p>
                <div v-else class="account-form-grid">
                  <select v-model="selectedAdminDongKey">
                    <option value="">행정동을 선택하세요</option>
                    <option
                      v-for="dong in filteredAdminDongItems"
                      :key="`dong-${dong.admin_dong_id || `${dong.office_name}-${dong.admin_dong}`}`"
                      :value="buildAdminDongKey(dong)"
                    >
                      {{ dong.admin_dong }} ({{ dong.office_name }} / {{ dong.building_count }}건)
                    </option>
                  </select>
                </div>
                <p v-if="selectedAdminDongItem" class="muted">
                  선택 행정동: {{ selectedAdminDongItem.admin_dong }} / {{ selectedAdminDongItem.office_name }} / {{ selectedAdminDongItem.building_count }}건
                </p>
                <div class="account-card-actions option-list-actions">
                  <button type="button" class="btn btn-secondary" :disabled="!selectedAdminDongItem" @click="renameFacilityField('admin_dong', selectedAdminDongItem)">
                    수정
                  </button>
                  <button type="button" class="btn btn-ghost" :disabled="!selectedAdminDongItem || Number(selectedAdminDongItem.building_count || 0) > 0" @click="deleteFacilityField('admin_dong', selectedAdminDongItem)">
                    삭제
                  </button>
                </div>
                <p v-if="selectedAdminDongItem && Number(selectedAdminDongItem.building_count || 0) > 0" class="muted">
                  건물 데이터가 있으면 행정동은 삭제할 수 없습니다.
                </p>
                <p class="muted">
                  건물명은 기존 건물수정에서 업로더/관리자가 계속 수정할 수 있으므로 여기서는 제외했습니다.
                </p>
              </section>
            </template>

            <template v-else-if="isInetAdmin">
              <section class="account-card">
                <div class="account-card-head">
                  <h4>사용자 계정 관리</h4>
                  <button type="button" class="btn btn-ghost btn-mini" @click="loadAdminAccountUsers">새로고침</button>
                </div>
                <div class="account-form-grid">
                  <select v-model.number="adminAccountForm.target_user_id">
                    <option :value="0">대상 사용자 선택</option>
                    <option v-for="user in adminAccountUsers" :key="user.id" :value="user.id">
                      #{{ user.id }} · {{ user.login_id }} · {{ user.display_name }}
                    </option>
                  </select>
                  <select v-model.number="adminAccountForm.login_change_remaining">
                    <option v-for="count in [0,1,2,3,4,5]" :key="`remain-${count}`" :value="count">
                      아이디 변경 잔여 {{ count }}회
                    </option>
                  </select>
                </div>
                <p v-if="selectedAdminUser" class="muted">
                  선택 사용자: {{ selectedAdminUser.display_name }} / {{ selectedAdminUser.login_id }} / 아이디 변경 잔여 {{ selectedAdminUser.login_change_remaining }}회
                </p>
                <p v-if="selectedAdminUser" class="muted">
                  비밀번호 초기화: {{ selectedAdminUser.login_id }}1234@
                </p>
                <div class="account-card-actions">
                  <button type="button" class="btn btn-primary" :disabled="accountSubmitting" @click="submitAdminLoginChangeRemaining">
                    잔여 횟수 설정
                  </button>
                  <button type="button" class="btn btn-secondary" :disabled="accountSubmitting" @click="submitAdminPasswordReset">
                    비밀번호 재설정
                  </button>
                </div>
              </section>

              <section class="account-card">
                <div class="account-card-head">
                  <h4>사용자 생성</h4>
                </div>
                <div class="account-form-grid">
                  <input v-model="adminCreateUserForm.login_id" type="text" placeholder="새 로그인 아이디" autocomplete="off" />
                  <input v-model="adminCreateUserForm.display_name" type="text" placeholder="이름" autocomplete="off" />
                </div>
                <p class="muted" v-if="adminCreateUserForm.login_id.trim()">
                  기본 비밀번호: {{ adminCreateUserForm.login_id.trim() }}1234@
                </p>
                <div class="account-card-actions">
                  <button type="button" class="btn btn-primary" :disabled="accountSubmitting" @click="submitAdminCreateUser">
                    사용자 생성
                  </button>
                </div>
              </section>

            </template>
          </div>
        </article>
      </div>
    </teleport>

    <teleport to="body">
      <div v-if="facilityAdminDialog.open" class="modal-backdrop" @click.self="closeFacilityAdminDialog">
        <article class="modal-shell facility-admin-dialog-shell">
          <header class="modal-header account-header">
            <div class="account-title-wrap">
              <h3>{{ facilityAdminDialog.mode === 'rename' ? facilityAdminDialog.title : '삭제 확인' }}</h3>
            </div>
            <button type="button" class="close-btn" @click="closeFacilityAdminDialog">닫기</button>
          </header>
          <div class="detail-content-scroll account-content-scroll">
            <section class="account-card">
              <template v-if="facilityAdminDialog.mode === 'rename'">
                <div class="account-form-grid">
                  <input
                    v-model="facilityAdminDialog.inputValue"
                    type="text"
                    :placeholder="facilityAdminDialog.placeholder"
                    autocomplete="off"
                    @keyup.enter="submitFacilityAdminDialog"
                  />
                </div>
              </template>
              <template v-else>
                <p class="muted">{{ facilityAdminDialog.message }}</p>
              </template>
              <p v-if="facilityAdminDialog.error" class="error-text">{{ facilityAdminDialog.error }}</p>
              <div class="account-card-actions">
                <button type="button" class="btn btn-ghost" :disabled="facilityAdminDialog.submitting" @click="closeFacilityAdminDialog">
                  취소
                </button>
                <button
                  type="button"
                  class="btn"
                  :class="facilityAdminDialog.mode === 'rename' ? 'btn-primary' : 'btn-secondary'"
                  :disabled="facilityAdminDialog.submitting"
                  @click="submitFacilityAdminDialog"
                >
                  {{ facilityAdminDialog.submitting ? "처리중..." : facilityAdminDialog.mode === 'rename' ? "저장" : "삭제" }}
                </button>
              </div>
            </section>
          </div>
        </article>
      </div>
    </teleport>

    <section class="list-card panel">
      <div class="list-head">
        <h2>건물 목록 총 {{ totalBuildingCount }}건</h2>
      </div>

      <div v-if="!items.length" class="empty">조회된 데이터가 없습니다.</div>

      <div
        v-else
        ref="facilityListRef"
        class="facility-list"
        @scroll.passive="maybeLoadMoreOnScroll"
      >
        <article
          v-for="(group, groupIndex) in groupedItems"
          :key="group.key"
          :ref="(el) => setFacilityItemRef(group.key, el)"
          :style="facilityItemStyle(group.key)"
          class="facility-item"
          :class="{
            active: isGroupActive(group),
            'even-row': groupIndex % 2 === 1,
          }"
        >
          <div class="facility-main-group">
              <div class="facility-top-row" @click="openDetail(group.representative, { focus: 'building' })">
              <span v-if="formatAdminDongForDisplay(group.representative.admin_dong)" class="chip chip-admin">
                {{ formatAdminDongForDisplay(group.representative.admin_dong) }}
              </span>
              <span v-if="formatLot(group.representative)" class="plain-text">{{ formatLot(group.representative) }}</span>
              <span v-if="normalizeText(group.representative.building_name)" class="chip chip-building">
                {{ normalizeText(group.representative.building_name) }}
              </span>
              <span v-if="isRecentGroup(group)" class="recent-badge standalone-recent-badge" title="오늘 등록">NEW</span>
              <button
                v-if="getBuildingPhotoThumbUrl(group)"
                type="button"
                class="building-photo-thumb-btn"
                title="건물 사진 보기"
                aria-label="건물 사진 보기"
                @click.stop="openBuildingPhotoDetail(group.representative)"
              >
                <span class="building-photo-thumb-frame">
                  <img :src="normalizeInetMediaUrl(getBuildingPhotoThumbUrl(group), group?.representative?.updated_at || group?.representative?.created_at || group?.representative?.id)" alt="건물 사진 미리보기" class="building-photo-thumb-image" />
                </span>
              </button>
              <button
                v-else-if="hasBuildingPhotoInGroup(group)"
                type="button"
                class="photo-presence-btn photo-presence-btn-inline title-photo-view"
                title="건물 사진 보기"
                aria-label="건물 사진 보기"
                @click.stop="openBuildingPhotoDetail(group.representative)"
              >
                🖼
              </button>
              <span
                v-if="getExclusiveProvider(group)"
                class="supplement-flag supplement-logo-flag"
                :title="`전용건물: ${getExclusiveProvider(group)}`"
                :aria-label="`전용건물: ${getExclusiveProvider(group)}`"
              >
                <img
                  v-if="getExclusiveProviderImage(getExclusiveProvider(group))"
                  :src="getExclusiveProviderImage(getExclusiveProvider(group))"
                  :alt="`${getExclusiveProvider(group)} 로고`"
                  class="supplement-logo-image"
                />
                <span v-else>🌐</span>
              </span>
              <span
                v-if="hasGroupSupplementValue(group, 'lock_device')"
                class="supplement-flag"
                title="시건장치 있음"
                aria-label="시건장치 있음"
              >
                🔒
              </span>
              <span
                v-if="hasGroupSupplementValue(group, 'restroom')"
                class="supplement-flag"
                title="화장실 정보 있음"
                aria-label="화장실 정보 있음"
              >
                🚻
              </span>
              <div class="facility-inline-actions">
                <label class="mini-photo-upload-label" title="건물 사진 첨부" @click.stop>
                  <input type="file" accept="image/*" multiple @change="(event) => uploadPhotos('building', event, group.representative)" />
                  📎
                </label>
                <button
                  type="button"
                  class="mini-photo-upload-label mini-register-icon-btn"
                  @click.stop="openFacilityCreate(group.representative)"
                >
                  📝
                </button>
              </div>
            </div>

            <div class="facility-sub-list">
              <div
                v-for="dongGroup in groupDongItems(group.items)"
                :key="dongGroup.key"
                class="facility-dong-group"
                :class="{ active: isDongGroupActive(dongGroup) }"
              >
              <div
                v-if="dongGroup.title || hasDongPhotoInDongGroup(dongGroup)"
                class="facility-dong-head"
                @click="openDetail(dongGroup.items[0], { focus: 'dong' })"
              >
                  <span v-if="dongGroup.title" class="facility-dong-main">{{ dongGroup.title }}</span>
                  <button
                    v-if="getDongPhotoThumbUrl(dongGroup)"
                    type="button"
                    class="building-photo-thumb-btn"
                    title="동 사진 보기"
                    aria-label="동 사진 보기"
                    @click.stop="openDongPhotoDetail(dongGroup.items[0])"
                  >
                    <span class="building-photo-thumb-frame">
                      <img :src="normalizeInetMediaUrl(getDongPhotoThumbUrl(dongGroup), dongGroup?.items?.[0]?.updated_at || dongGroup?.items?.[0]?.created_at || dongGroup?.items?.[0]?.id)" alt="동 사진 미리보기" class="building-photo-thumb-image" />
                    </span>
                  </button>
                  <button
                    v-else-if="hasDongPhotoInDongGroup(dongGroup)"
                    type="button"
                    class="photo-presence-btn photo-presence-btn-inline title-photo-view"
                    title="동 사진 보기"
                    aria-label="동 사진 보기"
                    @click.stop="openDongPhotoDetail(dongGroup.items[0])"
                  >
                    🖼
                  </button>
                  <div v-if="dongGroup.title" class="facility-inline-actions">
                    <label class="mini-photo-upload-label mini-photo-upload-label-inline" title="동 사진 첨부" @click.stop>
                      <input type="file" accept="image/*" multiple @change="(event) => uploadPhotos('dong', event, dongGroup.items[0])" />
                      📎
                    </label>
                    <button
                      type="button"
                      class="mini-photo-upload-label mini-photo-upload-label-inline mini-register-icon-btn"
                      @click.stop="openFacilityCreateForDong(dongGroup.items[0])"
                    >
                      📝
                    </button>
                  </div>
                </div>

                <div
                  v-for="subGroup in dongGroup.lineGroups"
                  :key="subGroup.key"
                  class="facility-sub-group"
                  :class="{ active: isDongLineSubGroupActive(subGroup) }"
                >
                    <div
                      v-if="subGroup.title || subGroup.fallbackTitle"
                      class="facility-sub-head"
                      @click="openDetail(subGroup.items[0], { focus: 'dong' })"
                    >
                    <span class="facility-sub-main">
                      {{ subGroup.title || subGroup.fallbackTitle }}
                    </span>
                    <div v-if="subGroup.title" class="facility-inline-actions">
                      <button
                        type="button"
                        class="mini-photo-upload-label mini-photo-upload-label-inline mini-register-icon-btn"
                        @click.stop="openFacilityCreateForLine(subGroup.items[0])"
                      >
                        📝
                      </button>
                    </div>
                  </div>
                  <div
                    v-for="entry in subGroup.items"
                    :key="entry.id"
                    class="facility-sub-item"
                    :class="{ active: selected && selected.id === entry.id }"
                    @click="openDetail(entry)"
                  >
                    <div class="facility-sub-item-content">
                      <button
                        type="button"
                        class="facility-sub-item-main"
                        @click.stop="openDetail(entry)"
                      >
                        <span
                          v-if="formatFacilitySummary(entry) || formatMemoSummary(entry.memo) || formatBuildingSupplementSummary(entry) || entry.has_facility_photo || normalizeText(entry.facility_photo_thumb_url)"
                          class="facility-sub-meta"
                          :class="{ 'facility-sub-meta-muted': !formatFacilitySummary(entry) && !formatMemoSummary(entry.memo) && formatBuildingSupplementSummary(entry) }"
                        >
                          <span v-if="formatFacilitySummary(entry)">{{ formatFacilitySummary(entry) }}</span>
                          <span v-if="formatMemoSummary(entry.memo)">{{ formatMemoSummary(entry.memo) }}</span>
                          <span
                            v-if="!formatFacilitySummary(entry) && !formatMemoSummary(entry.memo) && formatBuildingSupplementSummary(entry)"
                          >
                            {{ formatBuildingSupplementSummary(entry) }}
                          </span>
                          <span
                            v-if="!formatFacilitySummary(entry) && !formatMemoSummary(entry.memo) && !formatBuildingSupplementSummary(entry) && (entry.has_facility_photo || normalizeText(entry.facility_photo_thumb_url))"
                          >
                            사진 등록됨
                          </span>
                        </span>
                        <span v-else class="facility-sub-meta"></span>
                      </button>
                      <button
                        v-if="entry.has_facility_photo"
                        type="button"
                        class="photo-presence-btn photo-presence-btn-inline facility-row-photo-view"
                        title="시설 사진 보기"
                        aria-label="시설 사진 보기"
                        @click.stop="openFacilityPhotoDetail(entry)"
                      >
                        🖼
                      </button>
                    </div>
                    <div class="facility-sub-item-actions">
                      <label class="mini-photo-upload-label mini-photo-upload-label-inline" title="시설 사진 첨부" @click.stop>
                        <input type="file" accept="image/*" multiple @change="(event) => uploadPhotos('facility', event, entry)" />
                        📎
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </article>
        <div v-if="listLoadingMore" class="list-more-status">목록을 더 불러오는 중입니다.</div>
      </div>
    </section>

    <teleport to="body">
      <div v-if="scoreModalOpen" class="modal-backdrop" @click.self="closeScoreboard">
        <article class="modal-shell score-shell">
          <header class="modal-header score-header">
            <div>
              <p class="modal-kicker">스코어보드</p>
              <h3>국사: {{ selectedOfficeLabel }}</h3>
            </div>
            <button type="button" class="close-btn" @click="closeScoreboard">닫기</button>
          </header>

          <div class="score-content">
            <p v-if="scoreLoading" class="muted">스코어를 불러오는 중입니다.</p>
            <p v-else-if="scoreError" class="error-text">{{ scoreError }}</p>

            <div v-else class="score-result">
              <div class="score-grid">
                <section class="score-card">
                  <div class="score-card-head">
                    <h4>건물 스코어</h4>
                    <span>{{ scoreboard.building_total }}건</span>
                  </div>
                  <p v-if="!topBuildingScores.length" class="muted">건물 데이터가 없습니다.</p>
                  <div v-else class="score-pie-wrap">
                    <div class="score-pie" :style="buildingPieStyle"></div>
                    <ul class="score-legend">
                      <li
                        v-for="entry in buildingPieLegend"
                        :key="`building-legend-${entry.key}`"
                        class="score-legend-item"
                      >
                        <span v-if="entry.rank" class="score-rank" :style="{ color: rankColor(entry.rank) }">
                          {{ rankFlower(entry.rank) }} {{ entry.rank }}위
                        </span>
                        <span class="score-dot" :style="{ backgroundColor: entry.color }"></span>
                        <span class="score-name">{{ entry.label }}</span>
                        <span class="score-percent">{{ formatPercent(entry.percent) }}%</span>
                        <span v-if="entry.count != null" class="score-count">{{ entry.count }}건</span>
                      </li>
                    </ul>
                  </div>
                </section>

                <section class="score-card">
                  <div class="score-card-head">
                    <h4>시설 스코어</h4>
                    <span>{{ scoreboard.facility_total }}건</span>
                  </div>
                  <p v-if="!topFacilityScores.length" class="muted">시설 데이터가 없습니다.</p>
                  <div v-else class="score-pie-wrap">
                    <div class="score-pie" :style="facilityPieStyle"></div>
                    <ul class="score-legend">
                      <li
                        v-for="entry in facilityPieLegend"
                        :key="`facility-legend-${entry.key}`"
                        class="score-legend-item"
                      >
                        <span v-if="entry.rank" class="score-rank" :style="{ color: rankColor(entry.rank) }">
                          {{ rankFlower(entry.rank) }} {{ entry.rank }}위
                        </span>
                        <span class="score-dot" :style="{ backgroundColor: entry.color }"></span>
                        <span class="score-name">{{ entry.label }}</span>
                        <span class="score-percent">{{ formatPercent(entry.percent) }}%</span>
                        <span v-if="entry.count != null" class="score-count">{{ entry.count }}건</span>
                      </li>
                    </ul>
                  </div>
                </section>

                <section class="score-card">
                  <div class="score-card-head">
                    <h4>사진 스코어</h4>
                    <span>{{ scoreboard.photo_total }}건</span>
                  </div>
                  <p v-if="!topPhotoScores.length" class="muted">사진 데이터가 없습니다.</p>
                  <div v-else class="score-pie-wrap">
                    <div class="score-pie" :style="photoPieStyle"></div>
                    <ul class="score-legend">
                      <li
                        v-for="entry in photoPieLegend"
                        :key="`photo-legend-${entry.key}`"
                        class="score-legend-item"
                      >
                        <span v-if="entry.rank" class="score-rank" :style="{ color: rankColor(entry.rank) }">
                          {{ rankFlower(entry.rank) }} {{ entry.rank }}위
                        </span>
                        <span class="score-dot" :style="{ backgroundColor: entry.color }"></span>
                        <span class="score-name">{{ entry.label }}</span>
                        <span class="score-percent">{{ formatPercent(entry.percent) }}%</span>
                        <span v-if="entry.count != null" class="score-count">{{ entry.count }}건</span>
                      </li>
                    </ul>
                  </div>
                </section>

                <section class="score-card">
                  <div class="score-card-head">
                    <h4>편집 스코어</h4>
                    <span>{{ scoreboard.edited_total }}건</span>
                  </div>
                  <p v-if="!topEditedScores.length" class="muted">편집 데이터가 없습니다.</p>
                  <div v-else class="score-pie-wrap">
                    <div class="score-pie" :style="editedPieStyle"></div>
                    <ul class="score-legend">
                      <li
                        v-for="entry in editedPieLegend"
                        :key="`edited-legend-${entry.key}`"
                        class="score-legend-item"
                      >
                        <span v-if="entry.rank" class="score-rank" :style="{ color: rankColor(entry.rank) }">
                          {{ rankFlower(entry.rank) }} {{ entry.rank }}위
                        </span>
                        <span class="score-dot" :style="{ backgroundColor: entry.color }"></span>
                        <span class="score-name">{{ entry.label }}</span>
                        <span class="score-percent">{{ formatPercent(entry.percent) }}%</span>
                        <span v-if="entry.count != null" class="score-count">{{ entry.count }}건</span>
                      </li>
                    </ul>
                  </div>
                </section>

                <section class="score-card">
                  <div class="score-card-head">
                    <h4>댓글 스코어</h4>
                    <span>{{ scoreboard.comment_total }}건</span>
                  </div>
                  <p v-if="!topCommentScores.length" class="muted">댓글 데이터가 없습니다.</p>
                  <div v-else class="score-pie-wrap">
                    <div class="score-pie" :style="commentPieStyle"></div>
                    <ul class="score-legend">
                      <li
                        v-for="entry in commentPieLegend"
                        :key="`comment-legend-${entry.key}`"
                        class="score-legend-item"
                      >
                        <span v-if="entry.rank" class="score-rank" :style="{ color: rankColor(entry.rank) }">
                          {{ rankFlower(entry.rank) }} {{ entry.rank }}위
                        </span>
                        <span class="score-dot" :style="{ backgroundColor: entry.color }"></span>
                        <span class="score-name">{{ entry.label }}</span>
                        <span class="score-percent">{{ formatPercent(entry.percent) }}%</span>
                        <span v-if="entry.count != null" class="score-count">{{ entry.count }}건</span>
                      </li>
                    </ul>
                  </div>
                </section>
              </div>

              <section class="score-card my-score-wrap">
                <h4 class="my-score-title">내 스코어</h4>
                <div class="my-score-lines">
                  <p>
                    <strong>건물</strong>
                    <span :style="{ color: rankColor(myBuildingScore?.rank || 0) }">{{ formatMyScoreLine(myBuildingScore) }}</span>
                  </p>
                  <p>
                    <strong>시설</strong>
                    <span :style="{ color: rankColor(myFacilityScore?.rank || 0) }">{{ formatMyScoreLine(myFacilityScore) }}</span>
                  </p>
                  <p>
                    <strong>사진</strong>
                    <span :style="{ color: rankColor(myPhotoScore?.rank || 0) }">{{ formatMyScoreLine(myPhotoScore) }}</span>
                  </p>
                  <p>
                    <strong>편집</strong>
                    <span :style="{ color: rankColor(myEditedScore?.rank || 0) }">{{ formatMyScoreLine(myEditedScore) }}</span>
                  </p>
                  <p>
                    <strong>댓글</strong>
                    <span :style="{ color: rankColor(myCommentScore?.rank || 0) }">{{ formatMyScoreLine(myCommentScore) }}</span>
                  </p>
                </div>
              </section>
            </div>
          </div>
        </article>
      </div>
    </teleport>

    <teleport to="body">
      <div v-if="isDetailModal && selected" class="modal-backdrop" @click.self="closeModal">
        <article class="modal-shell detail-shell">
          <header class="modal-header detail-header">
            <div class="detail-title-row">
              <span v-if="formatAdminDongForDisplay(selected.admin_dong)" class="chip chip-admin">
                {{ formatAdminDongForDisplay(selected.admin_dong) }}
              </span>
              <span v-if="formatPreviewLot(selected)" class="plain-text">
                {{ formatPreviewLot(selected) }}
              </span>
              <span v-if="normalizeText(selected.building_name)" class="chip chip-detail-building">
                {{ normalizeText(selected.building_name) }}
              </span>
              <span v-if="formatBuildingDongForDisplay(selected.building_dong)" class="detail-dong">
                {{ formatBuildingDongForDisplay(selected.building_dong) }}
              </span>
              <span
                v-if="!formatAdminDongForDisplay(selected.admin_dong) && !formatLot(selected) && !normalizeText(selected.building_name) && !formatBuildingDongForDisplay(selected.building_dong)"
                class="detail-empty"
              >
                건물 정보 없음
              </span>
              <div v-if="selectedDetailFocus === 'building'" class="detail-title-actions">
                <button type="button" class="mini-register-btn edit detail-mini-btn" @click="openBuildingEdit">
                  건물수정
                </button>
                <button
                  v-if="canDeleteSelected"
                  type="button"
                  class="mini-register-btn danger detail-mini-btn"
                  @click="removeBuildingInfo"
                >
                  건물삭제
                </button>
              </div>
            </div>
            <button type="button" class="close-btn" @click="closeModal">닫기</button>
          </header>

          <div class="detail-content-scroll">
            <section class="detail-info-grid">
              <section v-if="selectedDetailFocus === 'building' || selectedDetailFocus === 'facility'" class="detail-table-wrap">
                <div class="detail-section-head">
                  <div class="detail-section-title detail-section-title-stack">
                    <div class="detail-section-title detail-section-title-inline">
                      <h4>{{ selectedDetailFocus === 'building' ? '건물부가정보' : '건물정보' }}</h4>
                      <label v-if="selectedDetailFocus === 'facility' && canUploadBuildingPhoto" class="mini-register-btn register detail-mini-btn photo-action-btn">
                        <input type="file" accept="image/*" multiple @change="(event) => uploadPhotos('building', event)" />
                        {{ buildingPhotoUploading ? "업로드중" : "사진추가" }}
                      </label>
                    </div>
                    <span v-if="formatCreatorInfo(selected)" class="detail-section-subtitle detail-section-subtitle-block">{{ formatCreatorInfo(selected) }}</span>
                  </div>
                  <div class="detail-section-actions">
                    <button type="button" class="mini-register-btn edit detail-mini-btn" @click="openSupplementEdit">
                      건물정보
                    </button>
                  </div>
                </div>
                <table class="detail-table">
                  <tbody>
                    <tr v-for="row in getBuildingDetailRows(selected)" :key="`building-${row.label}`">
                      <th>{{ row.label }}</th>
                      <td>{{ row.value }}</td>
                    </tr>
                    <tr v-if="!getBuildingDetailRows(selected).length">
                      <td colspan="2" class="detail-empty-cell">등록된 정보가 없습니다.</td>
                    </tr>
                  </tbody>
                </table>
              </section>

              <section v-if="selectedDetailFocus === 'dong'" class="detail-table-wrap">
                <div class="detail-section-head">
                  <div class="detail-section-title detail-section-title-inline">
                    <h4>동 요약정보</h4>
                  </div>
                </div>
                <table class="detail-table">
                  <tbody>
                    <tr v-for="row in getDongDetailRows(selected)" :key="`dong-${row.label}`">
                      <th>{{ row.label }}</th>
                      <td>{{ row.value }}</td>
                    </tr>
                    <tr v-if="!getDongDetailRows(selected).length">
                      <td colspan="2" class="detail-empty-cell">등록된 정보가 없습니다.</td>
                    </tr>
                  </tbody>
                </table>
              </section>

              <section v-if="selectedDetailFocus === 'facility'" class="detail-table-wrap">
                <div class="detail-section-head">
                  <div class="detail-section-title detail-section-title-inline">
                    <h4>시설정보</h4>
                    <label v-if="canUploadFacilityPhoto" class="mini-register-btn register detail-mini-btn photo-action-btn">
                      <input type="file" accept="image/*" multiple @change="(event) => uploadPhotos('facility', event)" />
                      {{ facilityPhotoUploading ? "업로드중" : "사진추가" }}
                    </label>
                  </div>
                  <div class="detail-section-actions">
                    <button
                      type="button"
                      class="mini-register-btn detail-mini-btn"
                      :class="isSelectedBuildingOnly ? 'register' : 'edit'"
                      @click="isSelectedBuildingOnly ? openFacilityCreate(selected) : openFacilityEdit()"
                    >
                      {{ isSelectedBuildingOnly ? "📝" : "시설수정" }}
                    </button>
                    <button
                      v-if="canDeleteSelected && !isSelectedBuildingOnly"
                      type="button"
                      class="mini-register-btn danger detail-mini-btn"
                      @click="removeItem"
                    >
                      시설삭제
                    </button>
                  </div>
                </div>
                <table class="detail-table">
                  <tbody>
                    <tr v-for="row in getFacilityDetailRows(selected)" :key="`facility-${row.label}`">
                      <th>{{ row.label }}</th>
                      <td>{{ row.value }}</td>
                    </tr>
                    <tr v-if="!getFacilityDetailRows(selected).length">
                      <td colspan="2" class="detail-empty-cell">등록된 정보가 없습니다.</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </section>

            <section v-if="showPhotoPanel" class="photo-box">
              <div class="comment-head">
                <h4>사진 {{ photoCount }}장</h4>
                <div class="comment-head-actions">
                  <button
                    type="button"
                    class="text-toggle"
                    @click="photosCollapsed = !photosCollapsed"
                  >
                    {{ photosCollapsed ? "보이기" : "접기" }}
                  </button>
                </div>
              </div>

              <template v-if="!photosCollapsed">
                <div class="photo-stack">
                  <template v-if="selectedDetailFocus === 'building' || selectedDetailFocus === 'facility'">
                  <p v-if="buildingPhotosLoading" class="muted">건물 사진을 불러오는 중입니다.</p>
                  <p v-else-if="buildingPhotosError" class="error-text">{{ buildingPhotosError }}</p>
                  <div v-else-if="buildingPhotos.length" class="photo-grid">
                    <article v-for="photo in buildingPhotos" :key="`building-${photo.id}`" class="photo-card">
                      <button type="button" class="photo-thumb-btn" @click="openPhoto(photo)">
                        <span class="photo-kind-label">{{ photoLabel('building') }}</span>
                        <img :src="photo.thumb_url || photo.display_url || photo.file_url" :alt="photo.original_name" class="photo-thumb" />
                      </button>
                      <div class="photo-meta">
                        <span :class="['photo-reuse-label', { 'photo-reuse-label-reused': photo.is_reused }]">
                          {{ photo.is_reused ? "참조사진" : "원본사진" }}
                        </span>
                        <strong>{{ formatLoginIdLabel(photo.user_name, photo.user_id) }}</strong>
                        <span>{{ formatPhotoDateTime(photo.created_at) }}</span>
                      </div>
                      <div class="photo-card-actions">
                        <button type="button" class="photo-inline-btn" @click="openOriginalPhoto(photo)">원본</button>
                        <button
                          v-if="canDeletePhoto(photo)"
                          type="button"
                          class="photo-inline-btn photo-inline-btn-danger"
                          @click="removePhoto('building', photo)"
                        >
                          삭제
                        </button>
                      </div>
                    </article>
                  </div>
                  </template>

                  <template v-if="selectedDetailFocus === 'dong'">
                  <p v-if="dongPhotosLoading" class="muted">동 사진을 불러오는 중입니다.</p>
                  <p v-else-if="dongPhotosError" class="error-text">{{ dongPhotosError }}</p>
                  <div v-else-if="dongPhotos.length" class="photo-grid">
                    <article v-for="photo in dongPhotos" :key="`dong-${photo.id}`" class="photo-card">
                      <button type="button" class="photo-thumb-btn" @click="openPhoto(photo)">
                        <span class="photo-kind-label">{{ photoLabel('dong') }}</span>
                        <img :src="photo.thumb_url || photo.display_url || photo.file_url" :alt="photo.original_name" class="photo-thumb" />
                      </button>
                      <div class="photo-meta">
                        <span :class="['photo-reuse-label', { 'photo-reuse-label-reused': photo.is_reused }]">
                          {{ photo.is_reused ? "참조사진" : "원본사진" }}
                        </span>
                        <strong>{{ formatLoginIdLabel(photo.user_name, photo.user_id) }}</strong>
                        <span>{{ formatPhotoDateTime(photo.created_at) }}</span>
                      </div>
                      <div class="photo-card-actions">
                        <button type="button" class="photo-inline-btn" @click="openOriginalPhoto(photo)">원본</button>
                        <button
                          v-if="canDeletePhoto(photo)"
                          type="button"
                          class="photo-inline-btn photo-inline-btn-danger"
                          @click="removePhoto('dong', photo)"
                        >
                          삭제
                        </button>
                      </div>
                    </article>
                  </div>
                  </template>

                  <template v-if="selectedDetailFocus === 'facility'">
                  <p v-if="facilityPhotosLoading" class="muted">시설 사진을 불러오는 중입니다.</p>
                  <p v-else-if="facilityPhotosError" class="error-text">{{ facilityPhotosError }}</p>
                  <div v-else-if="facilityPhotos.length" class="photo-grid">
                    <article v-for="photo in facilityPhotos" :key="`facility-${photo.id}`" class="photo-card">
                      <button type="button" class="photo-thumb-btn" @click="openPhoto(photo)">
                        <span class="photo-kind-label">{{ photoLabel('facility') }}</span>
                        <img :src="photo.thumb_url || photo.display_url || photo.file_url" :alt="photo.original_name" class="photo-thumb" />
                      </button>
                      <div class="photo-meta">
                        <span :class="['photo-reuse-label', { 'photo-reuse-label-reused': photo.is_reused }]">
                          {{ photo.is_reused ? "참조사진" : "원본사진" }}
                        </span>
                        <strong>{{ formatLoginIdLabel(photo.user_name, photo.user_id) }}</strong>
                        <span>{{ formatPhotoDateTime(photo.created_at) }}</span>
                      </div>
                      <div class="photo-card-actions">
                        <button type="button" class="photo-inline-btn" @click="openOriginalPhoto(photo)">원본</button>
                        <button
                          v-if="canDeletePhoto(photo)"
                          type="button"
                          class="photo-inline-btn photo-inline-btn-danger"
                          @click="removePhoto('facility', photo)"
                        >
                          삭제
                        </button>
                      </div>
                    </article>
                  </div>
                  </template>

                </div>
              </template>
            </section>

            <section v-if="showCommentListPanel" class="comment-box">
              <div class="comment-head">
                <h4>댓글 {{ comments.length }}개</h4>
                <div class="comment-head-actions">
                  <button
                    type="button"
                    class="text-toggle"
                    @click="commentsCollapsed = !commentsCollapsed"
                  >
                    {{ commentsCollapsed ? "보이기" : "접기" }}
                  </button>
                </div>
              </div>

              <template v-if="!commentsCollapsed">
                <p v-if="commentsLoading" class="muted">댓글을 불러오는 중입니다.</p>
                <p v-else-if="commentsError" class="error-text">{{ commentsError }}</p>
                <ul v-else-if="comments.length" class="comment-list">
                  <li v-for="comment in comments" :key="comment.id" class="comment-item">
                    <div class="comment-meta">
                      <strong>{{ formatLoginIdLabel(comment.user_name, comment.user_id) }}</strong>
                      <span>{{ formatDateTime(comment.created_at) }}</span>
                    </div>
                    <p v-if="isAutoComment(comment)" class="comment-text auto">
                      <template v-if="parseAutoComment(comment.comment)">
                        <span class="auto-comment-prefix">{{ parseAutoComment(comment.comment).scope }}</span>
                        <span
                          v-for="(field, index) in parseAutoComment(comment.comment).fields"
                          :key="`${comment.id}-field-${field}-${index}`"
                          :class="['auto-comment-field', `auto-comment-field-${index % 4}`]"
                        >
                          {{ field }}<span v-if="index < parseAutoComment(comment.comment).fields.length - 1" class="auto-comment-sep">, </span>
                        </span>
                        <span class="auto-comment-suffix"> 수정</span>
                      </template>
                      <template v-else>{{ comment.comment }}</template>
                    </p>
                    <p v-else class="comment-text">{{ comment.comment }}</p>
                    <button
                      v-if="canDeleteComment(comment)"
                      type="button"
                      class="text-danger"
                      @click="removeComment(comment)"
                    >
                      삭제
                    </button>
                  </li>
                </ul>
              </template>
            </section>

            <section v-if="canCommentOnSelected" class="comment-box comment-box-composer">
              <div class="comment-editor">
                <textarea
                  v-model="commentDraft"
                  rows="3"
                  maxlength="1000"
                  placeholder="댓글을 입력하세요."
                ></textarea>
                <button
                  type="button"
                  class="btn btn-primary"
                  :disabled="commentSubmitting || !commentDraft.trim()"
                  @click="addComment"
                >
                  {{ commentSubmitting ? "등록 중..." : "댓글 등록" }}
                </button>
              </div>
            </section>
          </div>

          <footer class="modal-actions">
            <button type="button" class="btn btn-ghost" @click="closeModal">뒤로</button>
          </footer>
        </article>
      </div>
    </teleport>

    <teleport to="body">
      <div v-if="isPhotoModal && selected" class="modal-backdrop" @click.self="closeModal">
        <article class="modal-shell detail-shell photo-only-shell">
          <header class="modal-header detail-header photo-only-header">
            <div class="detail-title-row">
              <span v-if="formatAdminDongForDisplay(selected.admin_dong)" class="chip chip-admin">
                {{ formatAdminDongForDisplay(selected.admin_dong) }}
              </span>
              <span v-if="formatLot(selected)" class="plain-text">
                {{ formatLot(selected) }}
              </span>
              <span v-if="normalizeText(selected.building_name)" class="chip chip-detail-building">
                {{ normalizeText(selected.building_name) }}
              </span>
              <span v-if="formatBuildingDongForDisplay(selected.building_dong)" class="detail-dong">
                {{ formatBuildingDongForDisplay(selected.building_dong) }}
              </span>
              <span
                v-if="!formatAdminDongForDisplay(selected.admin_dong) && !formatLot(selected) && !normalizeText(selected.building_name) && !formatBuildingDongForDisplay(selected.building_dong)"
                class="detail-empty"
              >
                건물 정보 없음
              </span>
            </div>
            <button type="button" class="close-btn" @click="closeModal">닫기</button>
          </header>

          <div class="detail-content-scroll photo-only-content">
            <section class="photo-box photo-only-box">
              <p v-if="photoModalLoading" class="muted">사진을 불러오는 중입니다.</p>
              <p v-else-if="photoModalError" class="error-text">{{ photoModalError }}</p>
              <p v-else-if="!photoModalPhotos.length" class="muted">등록된 사진이 없습니다.</p>
              <div
                v-else
                class="photo-grid photo-grid-photo-only"
                :class="{ 'photo-grid-photo-only-single': photoModalPhotos.length === 1 }"
              >
                <article v-for="photo in photoModalPhotos" :key="`photo-only-${photo.id}`" class="photo-card photo-preview-card">
                  <button type="button" class="photo-thumb-btn" @click="openPhoto(photo)">
                    <span class="photo-kind-label">{{ photoLabel(photoModalKind) }}</span>
                    <img :src="photo.thumb_url || photo.display_url || photo.file_url" :alt="photo.original_name" class="photo-thumb" />
                  </button>
                  <div class="photo-meta">
                    <span :class="['photo-reuse-label', { 'photo-reuse-label-reused': photo.is_reused }]">
                      {{ photo.is_reused ? "참조사진" : "원본사진" }}
                    </span>
                  </div>
                  <div v-if="photoModalKind === 'building'" class="photo-card-actions">
                    <button type="button" class="photo-inline-btn" @click="openOriginalPhoto(photo)">원본</button>
                    <button
                      v-if="canShowSetPrimaryButton('building', photo, photoModalPhotos)"
                      type="button"
                      class="photo-inline-btn"
                      :disabled="photo.is_primary"
                      @click="setPrimaryPhoto('building', photo)"
                    >
                      {{ photo.is_primary ? "대표중" : "대표" }}
                    </button>
                  </div>
                </article>
              </div>
            </section>
          </div>

          <footer class="modal-actions">
            <button type="button" class="btn btn-ghost" @click="closeModal">뒤로</button>
          </footer>
        </article>
      </div>
    </teleport>

    <teleport to="body">
      <div v-if="photoPreviewOpen" class="modal-backdrop photo-preview-backdrop" @click.self="closePhotoPreview">
        <article class="modal-shell photo-preview-shell">
          <header class="modal-header photo-preview-header">
            <div class="detail-title-row photo-preview-title-row">
              <span v-if="formatAdminDongForDisplay(selected?.admin_dong)" class="chip chip-admin">
                {{ formatAdminDongForDisplay(selected?.admin_dong) }}
              </span>
              <span v-if="formatLot(selected)" class="plain-text">
                {{ formatLot(selected) }}
              </span>
              <span v-if="normalizeText(selected?.building_name)" class="chip chip-detail-building">
                {{ normalizeText(selected?.building_name) }}
              </span>
              <span v-if="formatBuildingDongForDisplay(selected?.building_dong)" class="detail-dong">
                {{ formatBuildingDongForDisplay(selected?.building_dong) }}
              </span>
            </div>
            <div class="photo-preview-head-actions">
              <button
                v-if="photoPreviewPhoto"
                type="button"
                class="close-btn"
                @click="openOriginalPhoto(photoPreviewPhoto)"
              >
                원본
              </button>
              <button type="button" class="close-btn" @click="closePhotoPreview">뒤로</button>
              <button type="button" class="close-btn" @click="closePhotoFlow">닫기</button>
            </div>
          </header>
          <div class="photo-preview-stage">
            <div class="photo-preview-stage-frame">
              <span v-if="photoPreviewKind" class="photo-kind-label photo-preview-kind-label">{{ photoLabel(photoPreviewKind) }}</span>
              <img :src="photoPreviewUrl" alt="사진 미리보기" class="photo-preview-stage-image" />
            </div>
          </div>
          <footer class="photo-preview-actions">
            <button
              v-if="photoPreviewPhoto && photoPreviewIsOriginal"
              type="button"
              class="btn btn-secondary"
              @click="openPhoto(photoPreviewPhoto)"
            >
              일반보기
            </button>
            <button
              v-if="photoPreviewPhoto && !photoPreviewIsOriginal"
              type="button"
              class="btn btn-secondary"
              @click="openOriginalPhoto(photoPreviewPhoto)"
            >
              원본
            </button>
            <button
              v-if="photoPreviewPhoto"
              type="button"
              class="btn btn-primary"
              :disabled="photoDownloadLoading"
              @click="downloadPreviewPhoto(photoPreviewPhoto)"
            >
              {{ photoDownloadLoading ? "다운로드중" : "다운로드" }}
            </button>
            <button type="button" class="btn btn-ghost" @click="photoPreviewIsOriginal ? closePhotoFlow() : closePhotoPreview()">
              {{ photoPreviewIsOriginal ? "닫기" : "뒤로" }}
            </button>
          </footer>
        </article>
      </div>
    </teleport>

    <teleport to="body">
      <div v-if="duplicateCompareOpen" class="modal-backdrop" @click.self="closeDuplicateCompare">
        <article class="modal-shell duplicate-shell">
          <header class="modal-header">
            <div>
              <p class="modal-kicker">중복 사진 후보</p>
              <h3>{{ duplicateCompareTitle }}</h3>
            </div>
            <button type="button" class="close-btn" @click="closeDuplicateCompare">닫기</button>
          </header>

          <div class="duplicate-content">
            <p class="muted">{{ duplicateCompareGuide }}</p>

            <article v-for="preview in duplicatePendingPreviews" :key="`new-${preview.key}`" class="duplicate-compare-card duplicate-compare-card-new">
              <div class="duplicate-candidate-thumb-wrap">
                <img
                  :src="preview.url"
                  :alt="preview.name || '새 사진'"
                  class="duplicate-candidate-thumb"
                />
              </div>
              <div class="duplicate-candidate-meta">
                <strong>{{ preview.name || "새 사진" }}</strong>
                <p class="muted">{{ duplicatePendingScopeLabel }}</p>
                <p class="muted">{{ duplicatePendingScopeSummary }}</p>
                <p class="muted">새 업로드 대상</p>
              </div>
            </article>

            <article v-for="candidate in duplicateCompareCandidates" :key="`dup-${candidate.photo?.id}`" class="duplicate-candidate-card">
              <div class="duplicate-candidate-thumb-wrap">
                <img
                  :src="normalizeInetMediaUrl(candidate.photo?.thumb_url || candidate.photo?.display_url || candidate.photo?.file_url)"
                  :alt="candidate.photo?.original_name || '중복 후보 사진'"
                  class="duplicate-candidate-thumb"
                />
              </div>
              <div class="duplicate-candidate-meta">
                <strong>{{ candidate.photo?.original_name || "기존 사진" }}</strong>
                <p class="muted">{{ duplicateCandidateScopeLabel(candidate) }}</p>
                <p class="muted">{{ duplicateCandidateScopeSummary(candidate) }}</p>
                <p class="muted">해시 거리: {{ candidate.hash_distance ?? "-" }}</p>
                <p class="muted">참조 방식: {{ candidate.photo?.is_reused ? "참조" : "원본" }}</p>
                <p class="muted">날짜 기준: {{ candidate.photo?.captured_at_source || "-" }}</p>
                <p class="muted">{{ duplicateCandidateReason(candidate) }}</p>
                <div class="duplicate-candidate-actions">
                  <button
                    v-if="normalizeText(candidate.match_kind) === 'exact_duplicate'"
                    type="button"
                    class="btn btn-ghost"
                    @click="reuseDuplicateCandidate(candidate)"
                  >
                    기존 사진 참조
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="replaceDuplicatePrimary(candidate)"
                  >
                    {{ duplicateReplaceButtonLabel }}
                  </button>
                </div>
              </div>
            </article>
          </div>

          <footer class="modal-actions">
            <button type="button" class="btn btn-ghost" @click="closeDuplicateCompare">취소</button>
            <button type="button" class="btn btn-primary" @click="proceedDuplicateUpload">
              그대로 업로드
            </button>
          </footer>
        </article>
      </div>
    </teleport>

    <teleport to="body">
      <div v-if="isEditorModal" class="modal-backdrop" @click.self="closeModal">
        <article class="modal-shell editor-shell">
          <header class="modal-header">
            <div>
              <h3 v-if="!editorLinkedHeader">{{ editorTitle }}</h3>
              <div v-else class="editor-linked-title-row">
                <span v-if="editorLinkedHeader.admin_dong" class="chip chip-admin">
                  {{ editorLinkedHeader.admin_dong }}
                </span>
                <span v-if="editorLinkedHeader.lot" class="plain-text">
                  {{ editorLinkedHeader.lot }}
                </span>
                <span v-if="editorLinkedHeader.building_name" class="chip chip-building">
                  {{ editorLinkedHeader.building_name }}
                </span>
                <span v-if="editorLinkedHeader.building_dong" class="plain-text">
                  {{ editorLinkedHeader.building_dong }}
                </span>
                <span v-if="editorLinkedHeader.line" class="plain-text">
                  {{ editorLinkedHeader.line }}
                </span>
                <span class="editor-linked-mode">{{ editorLinkedHeader.mode_label }}</span>
              </div>
            </div>
            <button type="button" class="close-btn" @click="closeModal">닫기</button>
          </header>

          <div class="editor-grid">
            <template v-if="showNewRegisterFields">
              <section class="group-card group-card-required full">
                <div class="group-card-grid">
                  <label class="field full">
                    <span class="label-title">🏢 국사 <em class="req">*</em></span>
                    <div class="office-line">
                      <input v-model="form.office_name" list="office-options" placeholder="국사" @input="handleFormOfficeInput" />
                      <button type="button" class="btn btn-ghost btn-mini" @click="setDefaultOffice(defaultOfficeName)">
                        기본국사 적용
                      </button>
                    </div>
                    <datalist id="office-options">
                      <option v-for="office in officeOptions" :key="office" :value="office" />
                    </datalist>
                  </label>

                  <label class="field">
                    <span class="label-title">🏘 행정동 <em class="req">*</em></span>
                    <input
                      v-model="form.admin_dong"
                      placeholder="예) 원곡"
                      @input="handleFormAdminDongInput"
                      @blur="form.admin_dong = normalizeAdminDong(form.admin_dong)"
                    />
                  </label>

                  <label class="field">
                    <span class="label-title">📍 대번지</span>
                    <input v-model="form.main_lot" placeholder="예) 1743" />
                  </label>
                  <label class="field">
                    <span class="label-title">📍 소번지</span>
                    <input v-model="form.sub_lot" placeholder="예) 10" />
                  </label>
                  <label class="field full">
                    <span class="label-title">🏬 건물명</span>
                    <input v-model="form.building_name" placeholder="예) 현대하이츠" />
                  </label>
                </div>
              </section>
            </template>

            <template v-if="showSupplementRegisterFields">
              <section class="group-card group-card-subtle full">
                <div class="group-card-grid">
                  <label class="field"><span>🗄 MDF</span><input v-model="form.mdf" placeholder="예) 옥상, 1층" /></label>
                  <label class="field"><span>🏢 관리사무소</span><input v-model="form.management_office" placeholder="예) 1층, 경비실" /></label>
                  <label class="field"><span>🔒 시건장치</span><input v-model="form.lock_device" placeholder="예) 번호키, 자물쇠" /></label>
                  <label class="field"><span>🔑 KEY위치</span><input v-model="form.key_location" placeholder="예) 경비실, 관리실" /></label>
                  <label class="field"><span>🚪 출입문</span><input v-model="form.entrance_door" placeholder="예) 공동현관, 옆문" /></label>
                  <label class="field"><span>🚻 화장실</span><input v-model="form.restroom" placeholder="예) 있음, 없음, 1층" /></label>
                  <label class="field"><span>🧰 단자함</span><input v-model="form.terminal_box" placeholder="예) 1층, 복도" /></label>
                  <label class="field"><span>🌐 전용건물</span><input v-model="form.exclusive_provider" placeholder="예) sk, lg, kt, 기타" /></label>
                  <label class="field full">
                    <span>📝 건물메모</span>
                    <textarea v-model="form.building_memo" rows="3"></textarea>
                  </label>
                </div>
              </section>
            </template>

            <template v-if="showFacilityRegisterFields">
              <section class="group-card group-card-subtle full">
                <div class="group-card-grid">
                  <label v-if="showFacilityDongInput" class="field">
                    <span>🏷 동</span>
                    <input
                      v-model="form.building_dong"
                      placeholder="예) 108"
                      @blur="form.building_dong = normalizeBuildingDong(form.building_dong)"
                    />
                  </label>

                  <label v-if="showFacilityLineInput" class="field">
                    <span>🏚 라인</span>
                    <input
                      v-model="form.line"
                      placeholder="예) 1-2 혹은 1~2"
                      @blur="form.line = normalizeLineValue(form.line)"
                    />
                  </label>
                  <label class="field">
                    <span>📌 위치</span>
                    <input
                      v-model="form.position"
                      placeholder="예) 숫자 혹은 B1 혹은 옥상"
                      @blur="form.position = normalizePositionValue(form.position)"
                    />
                  </label>
                  <label class="field">
                    <span>🏙 적용층</span>
                    <input
                      v-model="form.apply_floor"
                      placeholder="예) 1~2 혹은 3~4"
                      @blur="form.apply_floor = normalizeApplyFloorValue(form.apply_floor)"
                    />
                  </label>
                  <label class="field">
                    <span>🌐 시설</span>
                    <input
                      v-model="form.facility"
                      placeholder="예) S0020011, FS32R132"
                    />
                  </label>
                  <label class="field">
                    <span>📍 장비위치</span>
                    <input
                      v-model="form.equipment_location"
                      placeholder="예) 숫자 혹은 B1 혹은 옥상"
                      @blur="form.equipment_location = normalizeEquipmentLocationValue(form.equipment_location)"
                    />
                  </label>
                  <label class="field full">
                    <span>📞 전화시설</span>
                    <input
                      v-model="form.phone_facility"
                      placeholder=""
                    />
                  </label>
                  <label class="field full">
                    <span>📝 메모</span>
                    <textarea v-model="form.memo" rows="4"></textarea>
                  </label>
                </div>
              </section>
            </template>
          </div>

          <footer class="modal-actions sticky">
            <button type="button" class="btn btn-ghost" @click="closeModal">취소</button>
            <button type="button" class="btn btn-primary" @click="saveItem">
              {{ modalMode === "create" ? "등록" : "저장" }}
            </button>
          </footer>
        </article>
      </div>
    </teleport>
  </section>
</template>

<script setup>
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import api from "@/api";
import ktLogo from "@/assets/images/kt.png";
import lgLogo from "@/assets/images/lg.png";
import skLogo from "@/assets/images/sk.png";
import sunghoMark from "@/assets/images/sungho.png";

const DEFAULT_OFFICE_NAME = "서안산";
const DEFAULT_OFFICE_STORAGE_LEGACY_KEY = "inet-default-office-name";
const DEFAULT_OFFICE_STORAGE_KEY_PREFIX = "inet-default-office-name-by-user";
const INET_COLLECTION_PATH = "/inet/";
const INET_OFFICES_PATH = "/inet/offices";
const INET_SCOREBOARD_PATH = "/inet/scoreboard";
const INET_POST_LOGIN_ACTION_KEY = "inet-post-login-action";
const INET_REDIRECT_PATH = "/inet";
const AUTH_STORAGE_KEYS = ["token", "tokenExpiresAt", "loggedInUser", "id", "userData"];
const INET_DELETE_ADMIN_LOGIN_IDS = Object.freeze(["nanmoo"]);
const NEW_REGISTER_REQUIRED_FIELDS = Object.freeze([
  { key: "office_name", label: "국사" },
  { key: "admin_dong", label: "행정동" },
]);

const router = useRouter();

const allItems = ref([]);
const totalBuildingCount = ref(0);
const hasMoreItems = ref(false);
const listLoading = ref(false);
const listLoadingMore = ref(false);
const nextOffset = ref(0);
const query = ref("");
const listError = ref("");
const selected = ref(null);
const selectedDetailFocus = ref("facility");
const modalMode = ref("");
const createEntryType = ref("new");
const createSourceFacilityId = ref(null);
const isMobile = ref(false);
const viewportWidth = ref(0);
const itemSpanMap = ref({});

const isLoggedIn = ref(false);
const currentUserLabel = ref("");
const remainingMinutes = ref(0);
const accountMenuOpen = ref(false);
const accountMenuRef = ref(null);
const accountPanelOpen = ref(false);
const accountPanelTab = ref("profile");
const accountLoading = ref(false);
const accountSubmitting = ref(false);
const accountError = ref("");
const accountProfile = ref(null);
const adminAccountUsers = ref([]);
const adminAccountLoading = ref(false);
const facilityAdminLoading = ref(false);
const adminOfficeItems = ref([]);
const adminDongItems = ref([]);
const selectedAdminOfficeId = ref("");
const selectedAdminDongKey = ref("");
const facilityAdminDialog = ref({
  open: false,
  mode: "rename",
  fieldKey: "",
  item: null,
  title: "",
  placeholder: "",
  message: "",
  inputValue: "",
  submitting: false,
  error: "",
});
const accountPasswordForm = ref({
  current_password: "",
  new_password: "",
  confirm_password: "",
});
const accountLoginIdForm = ref({
  current_password: "",
  new_login_id: "",
});
const adminAccountForm = ref({
  target_user_id: 0,
  login_change_remaining: 1,
});
const adminCreateUserForm = ref({
  login_id: "",
  display_name: "",
});

const comments = ref([]);
const commentsLoading = ref(false);
const commentsError = ref("");
const commentDraft = ref("");
const commentSubmitting = ref(false);
const commentsCollapsed = ref(true);
const photosCollapsed = ref(true);
const photoModalKind = ref("building");
const photoPreviewOpen = ref(false);
const photoPreviewUrl = ref("");
const photoPreviewKind = ref("");
const photoPreviewPhoto = ref(null);
const photoPreviewIsOriginal = ref(false);
const photoDownloadLoading = ref(false);
const buildingPhotos = ref([]);
const buildingPhotosLoading = ref(false);
const buildingPhotosError = ref("");
const buildingPhotoUploading = ref(false);
const dongPhotos = ref([]);
const dongPhotosLoading = ref(false);
const dongPhotosError = ref("");
const dongPhotoUploading = ref(false);
const facilityPhotos = ref([]);
const facilityPhotosLoading = ref(false);
const facilityPhotosError = ref("");
const facilityPhotoUploading = ref(false);
const duplicateCompareOpen = ref(false);
const duplicateCompareCandidates = ref([]);
const duplicatePendingUpload = ref(null);
const duplicatePendingPreviews = ref([]);
const duplicateCompareMode = ref("similar_duplicate");
const noticeMessage = ref("");
const noticeTone = ref("info");
let noticeTimer = null;

const officeOptionsFromServer = ref([]);
const defaultOfficeName = ref(loadDefaultOfficeName());
const selectedOfficeFilter = ref(defaultOfficeName.value);
const facilityListRef = ref(null);
const officeMenuOpen = ref(false);
const officeFilterRef = ref(null);
const scoreModalOpen = ref(false);
const scoreLoading = ref(false);
const scoreError = ref("");
const scoreboard = ref(makeEmptyScoreboard());

let authTimerId = null;
let successAudio = null;
let failAudio = null;
let lastOfficeStorageIdentity = "";
const PAGE_SIZE = 10;
let facilityLayoutFrame = 0;
let facilityResizeObserver = null;
const facilityItemElements = new Map();

const form = ref({
  office_id: null,
  admin_dong_id: null,
  office_name: defaultOfficeName.value,
  admin_dong: "",
  main_lot: "",
  sub_lot: "",
  building_name: "",
  address: "",
  building_dong: "",
  line: "",
  mdf: "",
  management_office: "",
  lock_device: "",
  key_location: "",
  entrance_door: "",
  restroom: "",
  building_memo: "",
  terminal_box: "",
  exclusive_provider: "",
  apply_floor: "",
  position: "",
  equipment_location: "",
  facility: "",
  phone_facility: "",
  memo: "",
});
const facilityCreatePresetScope = ref("building");

function makeEmptyScoreboard() {
  return {
    office_name: null,
    building_total: 0,
    facility_total: 0,
    photo_total: 0,
    created_total: 0,
    edited_total: 0,
    comment_total: 0,
    building_scores: [],
    facility_scores: [],
    photo_scores: [],
    created_scores: [],
    edited_scores: [],
    comment_scores: [],
  };
}

const officeOptions = computed(() => {
  const names = new Set();
  const normalizedDefault = normalizeText(defaultOfficeName.value);
  if (normalizedDefault) names.add(normalizedDefault);

  for (const office of officeOptionsFromServer.value) {
    const normalized = normalizeText(office);
    if (normalized) names.add(normalized);
  }

  for (const item of allItems.value) {
    const normalized = normalizeText(item?.office_name);
    if (normalized) names.add(normalized);
  }

  return Array.from(names);
});

const items = computed(() => {
  const selectedOffice = normalizeText(selectedOfficeFilter.value);
  if (!selectedOffice) return allItems.value;
  return allItems.value.filter((item) => normalizeText(item?.office_name) === selectedOffice);
});

const groupedItems = computed(() => {
  const groups = new Map();
  for (const item of items.value) {
    const key = getBuildingGroupKey(item);
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        representative: item,
        items: [item],
      });
      continue;
    }
    groups.get(key).items.push(item);
  }
  return Array.from(groups.values()).sort(compareBuildingGroups);
});


const selectedOfficeLabel = computed(() => selectedOfficeFilter.value || "전체");
const selectedCommentTargetId = computed(() => {
  const targetId = Number(selected.value?.comment_target_id || selected.value?.id || 0);
  return targetId !== 0 ? targetId : 0;
});
const buildingPhotoTargetId = computed(() => {
  const buildingId = Number(selected.value?.building_id || 0);
  return buildingId > 0 ? -Math.abs(buildingId) : 0;
});
const dongPhotoTargetId = computed(() => {
  const targetId = Number(selected.value?.id || 0);
  return targetId > 0 && normalizeBuildingDong(selected.value?.building_dong) ? targetId : 0;
});
const facilityPhotoTargetId = computed(() => {
  const targetId = Number(selected.value?.id || 0);
  return targetId !== 0 ? targetId : 0;
});
const canCommentOnSelected = computed(
  () => selectedDetailFocus.value === "building" && selectedCommentTargetId.value !== 0
);
const canUploadBuildingPhoto = computed(() => buildingPhotoTargetId.value !== 0 && isLoggedIn.value);
const canUploadDongPhoto = computed(() => dongPhotoTargetId.value !== 0 && isLoggedIn.value);
const canUploadFacilityPhoto = computed(() => facilityPhotoTargetId.value !== 0 && isLoggedIn.value);
const duplicatePendingScopeLabel = computed(() => {
  const kind = normalizeText(duplicatePendingUpload.value?.kind);
  if (kind === "building") return "건물사진 후보 비교";
  if (kind === "dong") return "동사진 후보 비교";
  return "시설사진 후보 비교";
});
const duplicatePendingScopeSummary = computed(() => {
  const sourceItem = duplicatePendingUpload.value?.sourceItem || selected.value;
  if (!sourceItem) return "";
  return [
    normalizeText(sourceItem?.office_name),
    formatAdminDongForDisplay(sourceItem?.admin_dong),
    formatLot(sourceItem),
    normalizeText(sourceItem?.building_name),
    formatBuildingDongForDisplay(sourceItem?.building_dong),
    formatLineForDisplay(sourceItem?.line),
    formatPositionForDisplay(sourceItem?.position),
    normalizeText(sourceItem?.facility),
  ].filter(Boolean).join(" / ");
});
const duplicateCompareTitle = computed(() =>
  duplicateCompareMode.value === "building_context" ? "같은 건물의 기존 사진이 있습니다" : "비슷한 사진이 있습니다"
);
const duplicateCompareGuide = computed(() =>
  duplicateCompareMode.value === "building_context"
    ? "완전히 같은 사진은 아니지만 같은 건물의 기존 사진입니다. 비교 후 그대로 업로드할지, 대표 사진을 교체할지 결정해 주세요."
    : "새 사진과 기존 후보를 비교한 뒤 그대로 업로드할지, 기존 사진을 참조할지, 대표 사진을 교체할지 결정해 주세요."
);
const duplicateReplaceButtonLabel = computed(() =>
  duplicateCompareMode.value === "building_context" ? "이 사진을 새 대표로 교체" : "이 사진을 새 사진으로 교체"
);
const photoCount = computed(() => {
  if (selectedDetailFocus.value === "building") return buildingPhotos.value.length;
  if (selectedDetailFocus.value === "dong") return dongPhotos.value.length;
  return buildingPhotos.value.length + facilityPhotos.value.length;
});
const showPhotoPanel = computed(
  () =>
    (
      selectedDetailFocus.value === "building" && (
        photoCount.value > 0
      )
    ) ||
    (
      selectedDetailFocus.value === "dong" && (
        photoCount.value > 0
      )
    ) ||
    (
      selectedDetailFocus.value === "facility" && (
        photoCount.value > 0
      )
    )
);
const showCommentListPanel = computed(
  () => selectedDetailFocus.value === "building" && (comments.value.length > 0 || commentsLoading.value || !!commentsError.value)
);
const scoreUserId = computed(() => getStoredUserId());
const isInetAdmin = computed(() => normalizeText(getStoredLoginId()).toLowerCase() === "nanmoo");
const selectedAdminUser = computed(() => (
  adminAccountUsers.value.find((user) => user.id === Number(adminAccountForm.value.target_user_id || 0)) || null
));
const selectedAdminOfficeItem = computed(() => (
  adminOfficeItems.value.find((item) => String(item.office_id || "") === selectedAdminOfficeId.value) || null
));
const filteredAdminDongItems = computed(() => {
  if (!selectedAdminOfficeId.value) return adminDongItems.value;
  return adminDongItems.value.filter((item) => String(item.office_id || "") === selectedAdminOfficeId.value);
});
const selectedAdminDongItem = computed(() => (
  filteredAdminDongItems.value.find((item) => buildAdminDongKey(item) === selectedAdminDongKey.value) || null
));
const piePalette = Object.freeze(["#1b7f6c", "#3a86ff", "#4dc48d", "#f29e4c", "#8a56d6"]);

const isDetailModal = computed(() => modalMode.value === "detail");
const isPhotoModal = computed(() => modalMode.value === "photo");
const isEditorModal = computed(() => modalMode.value === "create" || modalMode.value === "edit");
const isAnyModalOpen = computed(() => isDetailModal.value || isPhotoModal.value || isEditorModal.value || scoreModalOpen.value || accountPanelOpen.value);
const showNewRegisterFields = computed(
  () => createEntryType.value === "new"
);
const showSupplementRegisterFields = computed(
  () => createEntryType.value === "supplement"
);
const showFacilityRegisterFields = computed(
  () => createEntryType.value === "facility"
);
const showFacilityDongInput = computed(
  () => !(modalMode.value === "create" && createEntryType.value === "facility" && ["dong", "line"].includes(facilityCreatePresetScope.value))
);
const showFacilityLineInput = computed(
  () => !(modalMode.value === "create" && createEntryType.value === "facility" && facilityCreatePresetScope.value === "line")
);

const isSelectedBuildingOnly = computed(
  () => selectedDetailFocus.value === "facility" && !hasFacilityCoreContent(selected.value)
);
const photoModalPhotos = computed(() => (
  photoModalKind.value === "building" ? buildingPhotos.value :
    photoModalKind.value === "dong" ? dongPhotos.value :
      facilityPhotos.value
));
const photoModalLoading = computed(() => (
  photoModalKind.value === "building" ? buildingPhotosLoading.value :
    photoModalKind.value === "dong" ? dongPhotosLoading.value :
      facilityPhotosLoading.value
));
const photoModalError = computed(() => (
  photoModalKind.value === "building" ? buildingPhotosError.value :
    photoModalKind.value === "dong" ? dongPhotosError.value :
      facilityPhotosError.value
));
const photoModalTitle = computed(() => {
  const parts = [
    formatAdminDongForDisplay(selected.value?.admin_dong),
    normalizeText(selected.value?.building_name),
    formatBuildingDongForDisplay(selected.value?.building_dong),
  ].filter(Boolean);
  return parts.join(" ") || "사진";
});

const canDeleteSelected = computed(() => {
  if (!selected.value || !hasValidSession()) return false;
  const currentUserId = getStoredUserId();
  const createdBy = Number(selected.value?.created_by || 0);
  const loginId = getStoredLoginId().toLowerCase();
  const isAdmin = INET_DELETE_ADMIN_LOGIN_IDS.includes(loginId);
  return isAdmin || (currentUserId > 0 && createdBy > 0 && currentUserId === createdBy);
});

const rankedBuildingScores = computed(() => withDenseRank(scoreboard.value.building_scores));
const rankedFacilityScores = computed(() => withDenseRank(scoreboard.value.facility_scores));
const rankedPhotoScores = computed(() => withDenseRank(scoreboard.value.photo_scores));
const rankedEditedScores = computed(() => withDenseRank(scoreboard.value.edited_scores));
const rankedCommentScores = computed(() => withDenseRank(scoreboard.value.comment_scores));

const topBuildingScores = computed(() => rankedBuildingScores.value.slice(0, 5));
const topFacilityScores = computed(() => rankedFacilityScores.value.slice(0, 5));
const topPhotoScores = computed(() => rankedPhotoScores.value.slice(0, 5));
const topEditedScores = computed(() => rankedEditedScores.value.slice(0, 5));
const topCommentScores = computed(() => rankedCommentScores.value.slice(0, 5));

const buildingPieLegend = computed(() => buildPieLegend(topBuildingScores.value, piePalette));
const facilityPieLegend = computed(() => buildPieLegend(topFacilityScores.value, piePalette));
const photoPieLegend = computed(() => buildPieLegend(topPhotoScores.value, piePalette));
const editedPieLegend = computed(() => buildPieLegend(topEditedScores.value, piePalette));
const commentPieLegend = computed(() => buildPieLegend(topCommentScores.value, piePalette));

const buildingPieStyle = computed(() => buildPieStyle(buildingPieLegend.value));
const facilityPieStyle = computed(() => buildPieStyle(facilityPieLegend.value));
const photoPieStyle = computed(() => buildPieStyle(photoPieLegend.value));
const editedPieStyle = computed(() => buildPieStyle(editedPieLegend.value));
const commentPieStyle = computed(() => buildPieStyle(commentPieLegend.value));

const myBuildingScore = computed(() => findMyScoreEntry(rankedBuildingScores.value));
const myFacilityScore = computed(() => findMyScoreEntry(rankedFacilityScores.value));
const myPhotoScore = computed(() => findMyScoreEntry(rankedPhotoScores.value));
const myEditedScore = computed(() => findMyScoreEntry(rankedEditedScores.value));
const myCommentScore = computed(() => findMyScoreEntry(rankedCommentScores.value));

const userInitial = computed(() => {
  const normalized = normalizeText(currentUserLabel.value) || "사용자";
  return normalized ? normalized[0].toUpperCase() : "U";
});

const editorLinkedHeader = computed(() => {
  const shouldShow =
    modalMode.value === "edit" ||
    (modalMode.value === "create" && createEntryType.value === "facility");
  if (!shouldShow) return null;

  const adminDong = formatAdminDongForDisplay(form.value.admin_dong);
  const lot = formatLotFromParts(form.value.main_lot, form.value.sub_lot);
  const buildingName = normalizeText(form.value.building_name);
  const buildingDong = !showFacilityDongInput.value ? formatBuildingDongForDisplay(form.value.building_dong) : "";
  const line = !showFacilityLineInput.value ? formatLineForDisplay(form.value.line) : "";

  if (!adminDong && !lot && !buildingName && !buildingDong && !line) return null;

  return {
    admin_dong: adminDong,
    lot,
    building_name: buildingName,
    building_dong: buildingDong,
    line,
    mode_label: editorTitle.value,
  };
});

const editorTitle = computed(() => {
  if (modalMode.value === "create") {
    if (createEntryType.value === "supplement") return "부가등록";
    if (createEntryType.value === "facility") return "시설등록";
    return "건물등록";
  }
  if (createEntryType.value === "supplement") return "부가정보";
  if (createEntryType.value === "facility") return "시설수정";
  return "건물수정";
});

function normalizeText(value) {
  return String(value || "").trim();
}

function normalizeExclusiveProvider(value) {
  const normalized = normalizeText(value);
  if (!normalized) return "";
  const lowered = normalized.toLowerCase();
  if (["kt", "lg", "sk"].includes(lowered)) return lowered;
  return "기타";
}

function getExclusiveProvider(group) {
  const rows = Array.isArray(group?.items) ? group.items : [];
  for (const entry of rows) {
    const normalized = normalizeExclusiveProvider(entry?.exclusive_provider);
    if (normalized) return normalized;
  }
  return "";
}

function getExclusiveProviderImage(provider) {
  switch (normalizeExclusiveProvider(provider)) {
    case "kt":
      return ktLogo;
    case "lg":
      return lgLogo;
    case "sk":
      return skLogo;
    default:
      return "";
  }
}

function normalizeAdminDong(raw) {
  const normalized = normalizeText(raw);
  if (!normalized) return "";
  return normalized.replace(/동$/, "").trim();
}

function normalizeBuildingDong(raw) {
  const normalized = normalizeText(raw);
  if (!normalized) return "";
  return normalized.replace(/\s+/g, "").replace(/동$/, "").trim();
}

function formatAdminDongForDisplay(raw) {
  const normalized = normalizeAdminDong(raw);
  return normalized ? `${normalized}동` : "";
}

function formatBuildingDongForDisplay(raw) {
  const normalized = normalizeBuildingDong(raw);
  return normalized ? `${normalized}동` : "";
}

function normalizeLineValue(raw) {
  const normalized = normalizeText(raw);
  if (!normalized) return "";

  const compact = normalized.replace(/\s+/g, "");
  const withoutSuffix = compact.replace(/라인$/, "");
  const simple = withoutSuffix.match(/^(\d+)(?:[-~](\d+))?$/);
  if (simple) {
    return simple[2] ? `${simple[1]}~${simple[2]}` : simple[1];
  }
  return withoutSuffix.replace(/(\d+)\s*[-~]\s*(\d+)/g, "$1~$2");
}

function formatLineForDisplay(raw) {
  const normalized = normalizeLineValue(raw);
  if (!normalized) return "";
  return `${normalized}라인`;
}

function normalizeApplyFloorValue(raw) {
  const normalized = normalizeText(raw);
  if (!normalized) return "";

  const compact = normalized.replace(/\s+/g, "");
  const simple = compact.match(/^(\d+)(?:[-~](\d+))?층?$/);
  if (simple) {
    return simple[2] ? `${simple[1]}~${simple[2]}` : simple[1];
  }
  return normalized.replace(/(\d+)\s*[-~]\s*(\d+)/g, "$1~$2");
}

function formatApplyFloorForDisplay(raw) {
  const normalized = normalizeApplyFloorValue(raw);
  if (!normalized) return "";
  return /층$/.test(normalized) ? normalized : `${normalized}층`;
}

function normalizePositionValue(raw) {
  const normalized = normalizeText(raw);
  if (!normalized) return "";

  const compact = normalized.replace(/\s+/g, "");
  const basementByB = compact.match(/^[bB]\s*(\d+)\s*층?$/);
  if (basementByB) return `B${basementByB[1]}`;

  const basementByText = normalized.match(/^지하\s*(\d+)\s*층?$/);
  if (basementByText) return `B${basementByText[1]}`;

  const floorByNumber = normalized.match(/^(\d+)\s*층?$/);
  if (floorByNumber) return floorByNumber[1];

  return normalized;
}

function normalizeEquipmentLocationValue(raw) {
  return normalizePositionValue(raw);
}

function formatPositionForDisplay(raw) {
  const normalized = normalizePositionValue(raw);
  if (!normalized) return "";

  const basement = normalized.match(/^[bB](\d+)$/);
  if (basement) return `지하${basement[1]}층`;

  const floor = normalized.match(/^(\d+)$/);
  if (floor) return `${floor[1]}층`;

  return normalized;
}

function getBuildingGroupKey(item) {
  const parts = [
    normalizeText(item?.office_name).toLowerCase(),
    normalizeAdminDong(item?.admin_dong).toLowerCase(),
    normalizeText(item?.main_lot).toLowerCase(),
    normalizeText(item?.sub_lot).toLowerCase(),
  ];
  if (parts.some(Boolean)) return `sig:${parts.join("|")}`;
  return `id:${Number(item?.id || 0)}`;
}

function isGroupActive(group) {
  if (!selected.value) return false;
  const selectedId = Number(selected.value.id || 0);
  return Array.isArray(group?.items) && group.items.some((entry) => Number(entry.id || 0) === selectedId);
}

function getDongGroupKey(item) {
  const normalizedDong = normalizeBuildingDong(item?.building_dong).toLowerCase();
  if (!normalizedDong) return `id:${Number(item?.id || 0)}`;
  return `dong:${normalizedDong}`;
}

function getLineSubGroupKey(item) {
  const normalizedLine = normalizeLineValue(item?.line).toLowerCase();
  if (!normalizedLine) return `id:${Number(item?.id || 0)}`;
  return `line:${normalizedLine}`;
}

function groupDongItems(entries) {
  const rows = Array.isArray(entries) ? entries : [];
  const hasAnyFacilityContent = rows.some((entry) => hasFacilityCoreContent(entry));
  const grouped = new Map();
  for (const entry of rows) {
    if (hasAnyFacilityContent && !hasFacilityCoreContent(entry)) {
      continue;
    }
    const key = getDongGroupKey(entry);
    if (!grouped.has(key)) {
      grouped.set(key, {
        key,
        items: [entry],
        lineGroups: [],
      });
      continue;
    }
    grouped.get(key).items.push(entry);
  }
  if (!grouped.size && rows.length) {
    const representative = rows[0];
    return [{
      key: `empty:${Number(representative?.id || 0)}`,
      items: [representative],
      title: formatBuildingDongForDisplay(representative?.building_dong),
      lineGroups: [{
        key: `empty-line:${Number(representative?.id || 0)}`,
        title: "",
        fallbackTitle: formatFacilitySectionTitle(representative),
        items: [representative],
      }],
    }];
  }
  for (const dongGroup of grouped.values()) {
    dongGroup.items.sort(compareFacilityEntries);
    dongGroup.title = formatBuildingDongForDisplay(dongGroup.items[0]?.building_dong);
    const lineGrouped = new Map();
    for (const entry of dongGroup.items) {
      const key = getLineSubGroupKey(entry);
      if (!lineGrouped.has(key)) {
        lineGrouped.set(key, {
          key,
          title: formatLineForDisplay(entry?.line),
          fallbackTitle: "",
          items: [entry],
        });
        continue;
      }
      lineGrouped.get(key).items.push(entry);
    }
    dongGroup.lineGroups = Array.from(lineGrouped.values())
      .map((subGroup) => {
        subGroup.items.sort(compareFacilityEntries);
        subGroup.title = formatLineForDisplay(subGroup.items[0]?.line);
        subGroup.fallbackTitle = dongGroup.title ? "" : formatFacilitySectionTitle(subGroup.items[0]);
        return subGroup;
      })
      .sort(compareDongLineSubGroups);
  }
  return Array.from(grouped.values()).sort(compareDongGroups);
}

function isDongLineSubGroupActive(subGroup) {
  const selectedId = Number(selected.value?.id || 0);
  if (!selectedId) return false;
  const rows = Array.isArray(subGroup?.items) ? subGroup.items : [];
  return rows.some((entry) => Number(entry?.id || 0) === selectedId);
}

function isDongGroupActive(dongGroup) {
  const selectedId = Number(selected.value?.id || 0);
  if (!selectedId) return false;
  const rows = Array.isArray(dongGroup?.items) ? dongGroup.items : [];
  return rows.some((entry) => Number(entry?.id || 0) === selectedId);
}

function formatLot(item) {
  const main = normalizeText(item?.main_lot);
  const sub = normalizeText(item?.sub_lot);
  if (!main && !sub) return "";
  if (!main) return sub;
  if (!sub) return main;
  return `${main}-${sub}`;
}

function formatPreviewLot(item) {
  const directLot = formatLot(item);
  if (directLot) return directLot;
  const address = normalizeText(item?.address);
  if (!address) return "";
  const match = address.match(/(\d+)(?:-(\d+))?/);
  if (!match) return "";
  return match[2] ? `${match[1]}-${match[2]}` : match[1];
}

function normalizeInetMediaUrl(value, cacheKey = "") {
  const raw = normalizeText(value);
  if (!raw) return "";
  const normalizedCacheKey = normalizeText(cacheKey);
  const separator = raw.includes("?") ? "&" : "?";
  const suffix = normalizedCacheKey ? `${separator}v=${encodeURIComponent(normalizedCacheKey)}` : "";
  if (/^https?:\/\//i.test(raw)) return `${raw}${suffix}`;
  if (typeof window !== "undefined") {
    return new URL(`${raw.startsWith("/") ? raw : `/${raw}`}${suffix}`, window.location.origin).toString();
  }
  return `${raw.startsWith("/") ? raw : `/${raw}`}${suffix}`;
}

function formatLotFromParts(mainLotRaw, subLotRaw) {
  const main = normalizeText(mainLotRaw);
  const sub = normalizeText(subLotRaw);
  if (!main && !sub) return "";
  if (!main) return sub;
  if (!sub) return main;
  return `${main}-${sub}`;
}

function buildAddressFromLot(adminDongRaw, mainLotRaw, subLotRaw) {
  const adminDong = formatAdminDongForDisplay(adminDongRaw);
  const main = normalizeText(mainLotRaw);
  const sub = normalizeText(subLotRaw);
  const lot = !main ? (sub || "") : (!sub ? main : `${main}-${sub}`);
  const joined = [adminDong, lot].filter(Boolean).join(" ");
  return normalizeText(joined);
}

function formatBuilding(item) {
  const buildingName = normalizeText(item?.building_name);
  const buildingDong = formatBuildingDongForDisplay(item?.building_dong);
  return [buildingName, buildingDong].filter(Boolean).join(" ");
}

function hasFacilityCoreContent(item) {
  if (!item) return false;
  const fields = [
    item?.building_dong,
    item?.line,
    item?.apply_floor,
    item?.position,
    item?.facility,
    item?.memo,
  ];
  return fields.some((value) => Boolean(normalizeText(value))) ||
    Boolean(item?.has_facility_photo) ||
    Boolean(normalizeText(item?.facility_photo_thumb_url));
}

function hasGroupSupplementValue(group, fieldName) {
  const rows = Array.isArray(group?.items) ? group.items : [];
  return rows.some((entry) => Boolean(normalizeText(entry?.[fieldName])));
}

function formatFacilitySummary(item) {
  const position = formatPositionForDisplay(item?.position);
  const facility = normalizeText(item?.facility);
  const applyFloor = formatApplyFloorForDisplay(item?.apply_floor);
  return [
    position ? `📌 ${position}` : "",
    facility ? `🌐 ${facility}` : "",
    applyFloor ? `🏙 ${applyFloor}` : "",
  ].filter(Boolean).join("    ");
}

function formatFacilitySubTitle(item) {
  const dong = formatBuildingDongForDisplay(item?.building_dong);
  const line = formatLineForDisplay(item?.line);
  return [dong, line].filter(Boolean).join(" ");
}

function hasFacilityDisplayContent(item) {
  return Boolean(
    formatFacilitySummary(item) ||
    formatMemoSummary(item?.memo) ||
    formatBuildingSupplementSummary(item)
  );
}

function hasFacilitySpecificContent(item) {
  if (!item) return false;
  return [
    item?.line,
    item?.apply_floor,
    item?.position,
    item?.facility,
    item?.memo,
  ].some((value) => Boolean(normalizeText(value))) ||
    Boolean(item?.has_facility_photo) ||
    Boolean(normalizeText(item?.facility_photo_thumb_url));
}

function formatFacilitySectionTitle(item) {
  const dong = formatFacilitySubTitle(item);
  if (dong) return dong;
  return hasFacilitySpecificContent(item) ? "시설정보" : "건물정보";
}

function formatMemoSummary(rawMemo) {
  const memo = normalizeText(rawMemo);
  return memo ? `(${memo})` : "";
}

function compareDongLineSubGroups(a, b) {
  return compareValues(
    [
      buildingDongSortKey(a?.items?.[0]?.building_dong),
      normalizeBuildingDong(a?.items?.[0]?.building_dong).toLowerCase(),
      lineSortKey(a?.items?.[0]?.line),
      normalizeLineValue(a?.items?.[0]?.line).toLowerCase(),
      applyFloorSortKey(a?.items?.[0]?.apply_floor),
      Number(a?.items?.[0]?.id || 0),
    ],
    [
      buildingDongSortKey(b?.items?.[0]?.building_dong),
      normalizeBuildingDong(b?.items?.[0]?.building_dong).toLowerCase(),
      lineSortKey(b?.items?.[0]?.line),
      normalizeLineValue(b?.items?.[0]?.line).toLowerCase(),
      applyFloorSortKey(b?.items?.[0]?.apply_floor),
      Number(b?.items?.[0]?.id || 0),
    ],
  );
}

function compareDongGroups(a, b) {
  return compareValues(
    [
      buildingDongSortKey(a?.items?.[0]?.building_dong),
      normalizeBuildingDong(a?.items?.[0]?.building_dong).toLowerCase(),
      Number(a?.items?.[0]?.id || 0),
    ],
    [
      buildingDongSortKey(b?.items?.[0]?.building_dong),
      normalizeBuildingDong(b?.items?.[0]?.building_dong).toLowerCase(),
      Number(b?.items?.[0]?.id || 0),
    ],
  );
}

function compareFacilityEntries(a, b) {
  return compareValues(
    [
      applyFloorSortKey(a?.apply_floor),
      positionSortKey(a?.position),
      normalizeApplyFloorValue(a?.apply_floor).toLowerCase(),
      normalizePositionValue(a?.position).toLowerCase(),
      normalizeText(a?.facility).toLowerCase(),
      Number(a?.id || 0),
    ],
    [
      applyFloorSortKey(b?.apply_floor),
      positionSortKey(b?.position),
      normalizeApplyFloorValue(b?.apply_floor).toLowerCase(),
      normalizePositionValue(b?.position).toLowerCase(),
      normalizeText(b?.facility).toLowerCase(),
      Number(b?.id || 0),
    ],
  );
}

function compareValues(left, right) {
  const size = Math.max(left.length, right.length);
  for (let index = 0; index < size; index += 1) {
    const a = left[index];
    const b = right[index];
    if (a === b) continue;
    if (a == null) return 1;
    if (b == null) return -1;
    if (a < b) return -1;
    if (a > b) return 1;
  }
  return 0;
}

function buildingDongSortKey(raw) {
  return parseLeadingNumber(normalizeBuildingDong(raw));
}

function lineSortKey(raw) {
  return parseRangeStart(normalizeLineValue(raw));
}

function applyFloorSortKey(raw) {
  return parseRangeStart(normalizeApplyFloorValue(raw));
}

function positionSortKey(raw) {
  const normalized = normalizePositionValue(raw);
  if (/^b\d+$/i.test(normalized)) {
    return -parseLeadingNumber(normalized.slice(1));
  }
  return parseLeadingNumber(normalized);
}

function parseRangeStart(raw) {
  const normalized = normalizeText(raw);
  if (!normalized) return Number.MAX_SAFE_INTEGER;
  const token = normalized.split("~")[0].split("-")[0].trim();
  return parseLeadingNumber(token);
}

function parseLeadingNumber(raw) {
  const normalized = normalizeText(raw);
  if (!normalized) return Number.MAX_SAFE_INTEGER;
  const match = normalized.match(/(\d+)/);
  if (!match) return Number.MAX_SAFE_INTEGER;
  return Number.parseInt(match[1], 10);
}

function formatBuildingSupplementSummary(item) {
  if (!item || hasFacilityCoreContent(item)) return "";

  const parts = [
    (() => {
      const provider = normalizeExclusiveProvider(item.exclusive_provider);
      if (!provider) return "";
      return provider === "기타" ? "🌐 기타" : `🌐 ${provider.toUpperCase()}`;
    })(),
    normalizeText(item.mdf) ? `🗄 ${normalizeText(item.mdf)}` : "",
    normalizeText(item.management_office) ? `🏢 ${normalizeText(item.management_office)}` : "",
    normalizeText(item.lock_device) ? `🔒 ${normalizeText(item.lock_device)}` : "",
    normalizeText(item.restroom) ? `🚻 ${normalizeText(item.restroom)}` : "",
    normalizeText(item.terminal_box) ? `🧰 ${normalizeText(item.terminal_box)}` : "",
    normalizeText(item.building_memo) ? `📝 ${normalizeText(item.building_memo)}` : "",
  ].filter(Boolean);

  return parts.join("    ");
}

function normalizeScoreEntries(entries) {
  if (!Array.isArray(entries)) return [];
  return entries
    .map((entry) => {
      const userId = Number(entry?.user_id || 0);
      const count = Number(entry?.count || 0);
      const percent = Number(entry?.percent || 0);
      return {
        user_id: userId,
        user_name: normalizeText(entry?.user_name) || (userId > 0 ? `#${userId}` : "-"),
        count: Number.isFinite(count) ? count : 0,
        percent: Number.isFinite(percent) ? percent : 0,
      };
    })
    .filter((entry) => entry.user_id > 0 && entry.count > 0);
}

function formatPercent(value) {
  const normalized = Number(value || 0);
  if (!Number.isFinite(normalized)) return "0";
  const rounded = Math.max(0, Math.min(normalized, 100));
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
}

function clampPercent(value) {
  const normalized = Number(value || 0);
  if (!Number.isFinite(normalized)) return 0;
  return Math.max(0, Math.min(normalized, 100));
}

function denseRankByCount(entries, targetCount) {
  const countGroups = [...new Set((Array.isArray(entries) ? entries : []).map((entry) => Number(entry?.count || 0)))]
    .sort((a, b) => b - a);
  const idx = countGroups.findIndex((count) => count === Number(targetCount || 0));
  return idx >= 0 ? idx + 1 : countGroups.length + 1;
}

function withDenseRank(entries) {
  if (!Array.isArray(entries)) return [];
  return entries.map((entry) => ({
    ...entry,
    rank: denseRankByCount(entries, entry.count),
  }));
}

function buildPieLegend(entries, palette) {
  const top = Array.isArray(entries) ? entries : [];
  const list = top.map((entry, index) => ({
    key: `${entry.user_id}-${index}`,
    label: entry.user_name,
    percent: clampPercent(entry.percent),
    count: Number.isFinite(Number(entry.count)) ? Number(entry.count) : 0,
    rank: Number.isFinite(Number(entry.rank)) ? Number(entry.rank) : denseRankByCount(top, entry.count),
    color: palette[index % palette.length],
  }));
  const used = list.reduce((sum, entry) => sum + entry.percent, 0);
  const remain = Math.max(0, 100 - used);
  if (remain > 0.05) {
    list.push({
      key: "others",
      label: "기타",
      percent: remain,
      count: null,
      rank: null,
      color: "#cfd9e4",
    });
  }
  return list;
}

function buildPieStyle(legend) {
  if (!Array.isArray(legend) || !legend.length) {
    return { background: "#e5edf4" };
  }
  let start = 0;
  const slices = legend
    .filter((entry) => entry.percent > 0)
    .map((entry) => {
      const from = start;
      const to = Math.min(100, from + entry.percent);
      start = to;
      return `${entry.color} ${from}% ${to}%`;
    });
  return {
    background: `conic-gradient(${slices.join(", ")})`,
  };
}

function findMyScoreEntry(entries) {
  if (!Array.isArray(entries) || !entries.length) return null;
  const uid = Number(scoreUserId.value || 0);
  const label = normalizeText(currentUserLabel.value).toLowerCase();
  const targetIndex = entries.findIndex((entry) => {
    const entryUid = Number(entry?.user_id || 0);
    const entryLabel = normalizeText(entry?.user_name).toLowerCase();
    const sameById = uid > 0 && entryUid === uid;
    const sameByLabel = uid <= 0 && label && entryLabel === label;
    return sameById || sameByLabel;
  });
  if (targetIndex < 0) return null;
  const target = entries[targetIndex];
  return {
    ...target,
    rank: Number.isFinite(Number(target.rank))
      ? Number(target.rank)
      : denseRankByCount(entries, target.count),
  };
}

function formatMyScoreLine(entry) {
  if (!entry) return "";
  return `${rankFlower(entry.rank)} ${entry.rank}위 ${formatPercent(entry.percent)}%`;
}

function rankFlower(rank) {
  switch (Number(rank || 0)) {
    case 1:
      return "❀";
    case 2:
      return "✿";
    case 3:
      return "❁";
    case 4:
      return "✾";
    case 5:
      return "✽";
    default:
      return "•";
  }
}

function rankColor(rank) {
  switch (Number(rank || 0)) {
    case 1:
      return "#d4a017";
    case 2:
      return "#7a8798";
    case 3:
      return "#b87333";
    case 4:
      return "#2aa198";
    case 5:
      return "#8e44ad";
    default:
      return "#607282";
  }
}

async function fetchScoreboard() {
  try {
    scoreLoading.value = true;
    scoreError.value = "";
    const officeName = normalizeText(selectedOfficeFilter.value);
    const params = {
      ...(officeName ? { office_name: officeName } : {}),
      _ts: Date.now(),
    };
    const res = await api.get(INET_SCOREBOARD_PATH, { params });
    const data = res?.data || {};
    const fallbackCreatedScores = normalizeScoreEntries(data.created_scores);
    const parsedBuildingScores = normalizeScoreEntries(data.building_scores);
    const parsedFacilityScores = normalizeScoreEntries(data.facility_scores);
    const parsedPhotoScores = normalizeScoreEntries(data.photo_scores);
    const buildingScores = parsedBuildingScores.length ? parsedBuildingScores : fallbackCreatedScores;
    const buildingTotal = Number(data.building_total || 0) || Number(data.created_total || 0);
    const facilityTotal = Number(data.facility_total || 0);
    scoreboard.value = {
      office_name: normalizeText(data.office_name) || null,
      building_total: buildingTotal,
      facility_total: facilityTotal,
      photo_total: Number(data.photo_total || 0),
      created_total: Number(data.created_total || 0) || (buildingTotal + facilityTotal),
      edited_total: Number(data.edited_total || 0),
      comment_total: Number(data.comment_total || 0),
      building_scores: buildingScores,
      facility_scores: parsedFacilityScores,
      photo_scores: parsedPhotoScores,
      created_scores: fallbackCreatedScores.length ? fallbackCreatedScores : buildingScores,
      edited_scores: normalizeScoreEntries(data.edited_scores),
      comment_scores: normalizeScoreEntries(data.comment_scores),
    };
  } catch {
    scoreError.value = "스코어를 불러오지 못했습니다.";
    scoreboard.value = makeEmptyScoreboard();
  } finally {
    scoreLoading.value = false;
  }
}

async function openScoreboard() {
  scoreModalOpen.value = true;
  await fetchScoreboard();
}

function closeScoreboard() {
  scoreModalOpen.value = false;
}

async function refreshScoreboardIfOpen() {
  if (!scoreModalOpen.value) return;
  await fetchScoreboard();
}

function hasValidSession() {
  const token = localStorage.getItem("token");
  const tokenExpiresAt = Number(localStorage.getItem("tokenExpiresAt") || 0);
  return Boolean(token && tokenExpiresAt && Date.now() < tokenExpiresAt);
}

function computeRemainingMinutes() {
  const tokenExpiresAt = Number(localStorage.getItem("tokenExpiresAt") || 0);
  if (!tokenExpiresAt) return 0;
  return Math.max(Math.ceil((tokenExpiresAt - Date.now()) / 60000), 0);
}

function getStoredUserLabel() {
  const loggedInUser = normalizeText(localStorage.getItem("loggedInUser"));
  if (loggedInUser) return loggedInUser;

  try {
    const raw = localStorage.getItem("userData");
    if (!raw) return "";
    const parsed = JSON.parse(raw);
    return normalizeText(parsed?.username || parsed?.name || "");
  } catch {
    return "";
  }
}

function getStoredLoginId() {
  const loggedInUser = normalizeText(localStorage.getItem("loggedInUser"));
  if (loggedInUser) return loggedInUser;

  try {
    const raw = localStorage.getItem("userData");
    if (!raw) return "";
    const parsed = JSON.parse(raw);
    return normalizeText(parsed?.username || "");
  } catch {
    return "";
  }
}

function getStoredUserId() {
  return Number(localStorage.getItem("id") || 0);
}

function formatLoginIdLabel(loginId, userId) {
  const normalizedLoginId = normalizeText(loginId);
  if (normalizedLoginId) return normalizedLoginId;
  const normalizedId = Number(userId || 0);
  return normalizedId > 0 ? `#${normalizedId}` : "-";
}

function formatHeaderUserLabel(loginId, userId) {
  const normalizedLoginId = normalizeText(loginId);
  if (normalizedLoginId) return normalizedLoginId;
  const normalizedId = Number(userId || 0);
  return normalizedId > 0 ? `#${normalizedId}` : "";
}

function parseDateTime(value) {
  if (!value) return null;
  const normalized = normalizeText(value);
  if (!normalized) return null;

  const candidates = [normalized, normalized.replace(" ", "T")];
  for (const candidate of candidates) {
    const dt = new Date(candidate);
    if (!Number.isNaN(dt.getTime())) return dt;
  }
  return null;
}

function formatDateTime(value) {
  const dt = parseDateTime(value);
  if (!dt) return "";

  const pad = (n) => String(n).padStart(2, "0");
  return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())} ${pad(dt.getHours())}:${pad(
    dt.getMinutes()
  )}:${pad(dt.getSeconds())}`;
}

function formatPhotoDateTime(value) {
  const dt = parseDateTime(value);
  if (!dt) return "";

  const pad = (n) => String(n).padStart(2, "0");
  return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())} ${pad(dt.getHours())}:${pad(
    dt.getMinutes()
  )}`;
}

function isRecentDateTime(value) {
  const dt = parseDateTime(value);
  if (!dt) return false;
  const now = new Date();
  return dt.getFullYear() === now.getFullYear()
    && dt.getMonth() === now.getMonth()
    && dt.getDate() === now.getDate();
}

function isRecentGroup(group) {
  const buildingCreatedAt = group?.representative?.building_created_at;
  return isRecentDateTime(buildingCreatedAt);
}

function buildingCreatedAtMillis(group) {
  return parseDateTime(group?.representative?.building_created_at)?.getTime() || 0;
}

function compareBuildingGroups(a, b) {
  const aRecent = isRecentGroup(a);
  const bRecent = isRecentGroup(b);
  if (aRecent !== bRecent) return aRecent ? -1 : 1;

  if (aRecent && bRecent) {
    const createdDiff = buildingCreatedAtMillis(b) - buildingCreatedAtMillis(a);
    if (createdDiff !== 0) return createdDiff;
  }

  return compareValues(
    [
      normalizeAdminDong(a?.representative?.admin_dong).toLowerCase(),
      Number.parseInt(normalizeText(a?.representative?.main_lot) || "0", 10),
      Number.parseInt(normalizeText(a?.representative?.sub_lot) || "0", 10),
      normalizeText(a?.representative?.building_name).toLowerCase(),
      buildingDongSortKey(a?.representative?.building_dong),
      normalizeBuildingDong(a?.representative?.building_dong).toLowerCase(),
      lineSortKey(a?.representative?.line),
      normalizeLineValue(a?.representative?.line).toLowerCase(),
      Number(a?.representative?.building_id || a?.representative?.id || 0),
    ],
    [
      normalizeAdminDong(b?.representative?.admin_dong).toLowerCase(),
      Number.parseInt(normalizeText(b?.representative?.main_lot) || "0", 10),
      Number.parseInt(normalizeText(b?.representative?.sub_lot) || "0", 10),
      normalizeText(b?.representative?.building_name).toLowerCase(),
      buildingDongSortKey(b?.representative?.building_dong),
      normalizeBuildingDong(b?.representative?.building_dong).toLowerCase(),
      lineSortKey(b?.representative?.line),
      normalizeLineValue(b?.representative?.line).toLowerCase(),
      Number(b?.representative?.building_id || b?.representative?.id || 0),
    ],
  );
}

function formatCreatorInfo(item) {
  const creator = formatHeaderUserLabel(item?.created_by_name, item?.created_by);
  const createdAt = formatDateTime(item?.created_at);

  if (creator && createdAt) return `${creator} (${createdAt})`;
  if (creator) return creator;
  if (createdAt) return createdAt;
  return "";
}

function getBuildingDetailRows(item) {
  if (!item) return [];

  return [
    { label: "🗄 MDF", value: normalizeText(item.mdf) },
    { label: "🏢 관리사무소", value: normalizeText(item.management_office) },
    { label: "🔒 시건장치", value: normalizeText(item.lock_device) },
    { label: "🔑 KEY위치", value: normalizeText(item.key_location) },
    { label: "🚪 출입문", value: normalizeText(item.entrance_door) },
    { label: "🚻 화장실", value: normalizeText(item.restroom) },
    { label: "📝 건물메모", value: normalizeText(item.building_memo) },
    { label: "🌐 전용건물", value: normalizeExclusiveProvider(item.exclusive_provider) },
  ].filter((row) => normalizeText(row.value));
}

function getFacilityDetailRows(item) {
  if (!item) return [];

  return [
    { label: "🧰 단자함", value: normalizeText(item.terminal_box) },
    { label: "🏚 라인", value: formatLineForDisplay(item.line) },
    { label: "🏙 적용층", value: formatApplyFloorForDisplay(item.apply_floor) },
    { label: "📌 위치", value: formatPositionForDisplay(item.position) },
    { label: "📍 장비위치", value: normalizeText(item.equipment_location) },
    { label: "🌐 시설", value: normalizeText(item.facility) },
    { label: "📞 전화시설", value: normalizeText(item.phone_facility) },
    { label: "📝 메모", value: normalizeText(item.memo) },
  ].filter((row) => normalizeText(row.value));
}

function getDongDetailRows(item) {
  if (!item) return [];

  return [
    { label: "🏚 라인", value: formatLineForDisplay(item.line) },
    { label: "📌 위치", value: formatPositionForDisplay(item.position) },
    { label: "🏙 적용층", value: formatApplyFloorForDisplay(item.apply_floor) },
    { label: "🌐 장비명", value: normalizeText(item.facility) },
  ].filter((row) => normalizeText(row.value));
}

function playUiTone(type = "success") {
  if (typeof window === "undefined") return;
  const target = type === "success" ? successAudio : failAudio;
  if (!target) return;

  try {
    target.pause();
    target.currentTime = 0;
    const playPromise = target.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {});
    }
  } catch {
    // ignore
  }
}

function clearNotice() {
  noticeMessage.value = "";
  if (noticeTimer) {
    clearTimeout(noticeTimer);
    noticeTimer = null;
  }
}

function resetDuplicatePendingPreviews() {
  for (const preview of duplicatePendingPreviews.value) {
    if (preview?.url && preview.url.startsWith("blob:")) {
      URL.revokeObjectURL(preview.url);
    }
  }
  duplicatePendingPreviews.value = [];
}

function buildDuplicatePendingPreviews(files) {
  resetDuplicatePendingPreviews();
  duplicatePendingPreviews.value = (Array.isArray(files) ? files : []).map((file, index) => ({
    key: `${index}-${file?.name || "file"}`,
    name: file?.name || "새 사진",
    url: URL.createObjectURL(file),
  }));
}

function showNotice(message, tone = "info", duration = 2600) {
  const normalized = normalizeText(message);
  if (!normalized) return;
  if (noticeTimer) {
    clearTimeout(noticeTimer);
    noticeTimer = null;
  }
  noticeMessage.value = normalized;
  noticeTone.value = tone;
  if (duration > 0) {
    noticeTimer = setTimeout(() => {
      noticeMessage.value = "";
      noticeTimer = null;
    }, duration);
  }
}

function syncAuthStatus() {
  const loggedIn = hasValidSession();
  isLoggedIn.value = loggedIn;
  currentUserLabel.value = getStoredUserLabel() || "사용자";
  remainingMinutes.value = loggedIn ? computeRemainingMinutes() : 0;
  if (!loggedIn) {
    accountMenuOpen.value = false;
    accountPanelOpen.value = false;
    accountProfile.value = null;
    adminAccountUsers.value = [];
    adminOfficeItems.value = [];
    adminDongItems.value = [];
  }
  syncDefaultOfficeForCurrentUser();
}

function resetAccountForms() {
  accountPasswordForm.value = {
    current_password: "",
    new_password: "",
    confirm_password: "",
  };
  accountLoginIdForm.value = {
    current_password: "",
    new_login_id: "",
  };
  adminAccountForm.value = {
    target_user_id: 0,
    login_change_remaining: 1,
  };
  adminCreateUserForm.value = {
    login_id: "",
    display_name: "",
  };
  selectedAdminOfficeId.value = "";
  selectedAdminDongKey.value = "";
}

async function loadAccountProfile() {
  if (!hasValidSession()) return null;
  accountLoading.value = true;
  accountError.value = "";
  try {
    const res = await api.get("/users/account/profile");
    accountProfile.value = res.data || null;
    return accountProfile.value;
  } catch (error) {
    accountError.value = error?.response?.data?.detail || "계정 정보를 불러오지 못했습니다.";
    return null;
  } finally {
    accountLoading.value = false;
  }
}

async function loadAdminAccountUsers() {
  if (!hasValidSession() || !isInetAdmin.value) return;
  adminAccountLoading.value = true;
  accountError.value = "";
  try {
    const res = await api.get("/users/account/admin/users");
    adminAccountUsers.value = Array.isArray(res.data) ? res.data : [];
  } catch (error) {
    accountError.value = error?.response?.data?.detail || "관리자 계정 목록을 불러오지 못했습니다.";
  } finally {
    adminAccountLoading.value = false;
  }
}

async function loadFacilityAdminLists() {
  if (!hasValidSession() || !isInetAdmin.value) return;
  facilityAdminLoading.value = true;
  accountError.value = "";
  try {
    const [officesRes, dongsRes] = await Promise.all([
      api.get("/inet/admin/offices"),
      api.get("/inet/admin/dongs"),
    ]);
    adminOfficeItems.value = Array.isArray(officesRes.data) ? officesRes.data : [];
    adminDongItems.value = Array.isArray(dongsRes.data) ? dongsRes.data : [];
    if (!adminOfficeItems.value.some((item) => String(item.office_id || "") === selectedAdminOfficeId.value)) {
      selectedAdminOfficeId.value = "";
    }
    if (!adminDongItems.value.some((item) => buildAdminDongKey(item) === selectedAdminDongKey.value)) {
      selectedAdminDongKey.value = "";
    }
  } catch (error) {
    accountError.value = error?.response?.data?.detail || "시설수정 목록을 불러오지 못했습니다.";
  } finally {
    facilityAdminLoading.value = false;
  }
}

function buildAdminDongKey(item) {
  const adminDongId = Number(item?.admin_dong_id || 0);
  if (adminDongId > 0) return `dong:${adminDongId}`;
  return `${normalizeText(item?.office_name)}::${normalizeText(item?.admin_dong)}`;
}

watch(selectedAdminOfficeId, () => {
  if (!filteredAdminDongItems.value.some((item) => buildAdminDongKey(item) === selectedAdminDongKey.value)) {
    selectedAdminDongKey.value = "";
  }
});

function toggleAccountMenu() {
  if (!isLoggedIn.value) {
    goToSunghoLogin();
    return;
  }
  accountMenuOpen.value = !accountMenuOpen.value;
}

async function openAccountPanel(tab = "profile") {
  if (!isLoggedIn.value) {
    goToSunghoLogin();
    return;
  }
  accountMenuOpen.value = false;
  accountPanelOpen.value = true;
  accountPanelTab.value = tab === "admin" && isInetAdmin.value
    ? "admin"
    : tab === "facility" && isInetAdmin.value
      ? "facility"
      : "profile";
  resetAccountForms();
  if (accountPanelTab.value !== "facility") {
    await loadAccountProfile();
  }
  if (accountPanelTab.value === "admin") {
    await loadAdminAccountUsers();
  } else if (accountPanelTab.value === "facility") {
    await loadFacilityAdminLists();
  }
}

async function openAdminFacilityPanel() {
  await openAccountPanel("facility");
}

function closeAccountPanel() {
  accountPanelOpen.value = false;
  accountError.value = "";
  resetAccountForms();
}

function renameFacilityField(fieldKey, item) {
  if (!isInetAdmin.value) return;
  facilityAdminDialog.value = {
    open: true,
    mode: "rename",
    fieldKey,
    item,
    title: fieldKey === "office" ? "국사 수정" : "행정동 수정",
    placeholder: fieldKey === "office" ? "새 국사명" : "새 행정동명",
    message: "",
    inputValue: fieldKey === "office" ? (item?.office_name || "") : (item?.admin_dong || ""),
    submitting: false,
    error: "",
  };
}

function deleteFacilityField(fieldKey, item) {
  if (!isInetAdmin.value) return;
  const label = fieldKey === "office" ? item?.office_name : `${item?.office_name} / ${item?.admin_dong}`;
  facilityAdminDialog.value = {
    open: true,
    mode: "delete",
    fieldKey,
    item,
    title: "",
    placeholder: "",
    message: `${label} 관련 항목을 삭제하시겠습니까?`,
    inputValue: "",
    submitting: false,
    error: "",
  };
}

function closeFacilityAdminDialog(force = false) {
  if (facilityAdminDialog.value.submitting && !force) return;
  facilityAdminDialog.value = {
    open: false,
    mode: "rename",
    fieldKey: "",
    item: null,
    title: "",
    placeholder: "",
    message: "",
    inputValue: "",
    submitting: false,
    error: "",
  };
}

async function submitFacilityAdminDialog() {
  const dialog = facilityAdminDialog.value;
  if (!dialog.open || !dialog.item) return;
  facilityAdminDialog.value = { ...dialog, submitting: true, error: "" };
  try {
    if (dialog.mode === "rename") {
      const trimmed = normalizeText(dialog.inputValue);
      const currentLabel = dialog.fieldKey === "office" ? dialog.item.office_name : dialog.item.admin_dong;
      if (!trimmed) {
        facilityAdminDialog.value = { ...facilityAdminDialog.value, submitting: false, error: "값을 입력해 주세요." };
        return;
      }
      if (trimmed === currentLabel) {
        closeFacilityAdminDialog();
        return;
      }
      if (dialog.fieldKey === "office") {
        await api.put("/inet/admin/offices", {
          office_id: dialog.item.office_id,
          new_name: trimmed,
        });
      } else {
        await api.put("/inet/admin/dongs", {
          admin_dong_id: dialog.item.admin_dong_id,
          new_admin_dong: trimmed,
        });
      }
      await Promise.all([loadFacilityAdminLists(), fetchItems(), fetchOfficeOptions()]);
      facilityAdminDialog.value = { ...facilityAdminDialog.value, submitting: false, error: "" };
      closeFacilityAdminDialog(true);
      showNotice(`${dialog.fieldKey === "office" ? "국사" : "행정동"}를 수정했습니다.`, "success");
    } else {
      if (dialog.fieldKey === "office") {
        await api.delete("/inet/admin/offices", {
          params: { office_id: dialog.item.office_id },
        });
      } else {
        await api.delete("/inet/admin/dongs", {
          params: { admin_dong_id: dialog.item.admin_dong_id },
        });
      }
      await Promise.all([loadFacilityAdminLists(), fetchItems(), fetchOfficeOptions()]);
      clearCommentsState();
      clearPhotosState();
      selected.value = null;
      facilityAdminDialog.value = { ...facilityAdminDialog.value, submitting: false, error: "" };
      closeFacilityAdminDialog(true);
      showNotice(`${dialog.fieldKey === "office" ? "국사" : "행정동"}를 삭제했습니다.`, "success");
    }
  } catch (error) {
    facilityAdminDialog.value = {
      ...facilityAdminDialog.value,
      submitting: false,
      error: extractApiErrorMessage(error, `${dialog.fieldKey === "office" ? "국사" : "행정동"} ${dialog.mode === "rename" ? "수정" : "삭제"}에 실패했습니다.`),
    };
  }
}

function updateAuthStorageAfterLoginIdChange(payload) {
  if (!payload?.access_token) return;
  localStorage.setItem("token", payload.access_token);
  localStorage.setItem("tokenExpiresAt", String(Number(payload.expires_at || 0)));
  localStorage.setItem("loggedInUser", payload.login_id || "");
  localStorage.setItem("id", String(Number(payload.uid || 0)));
  try {
    const raw = localStorage.getItem("userData");
    const parsed = raw ? JSON.parse(raw) : {};
    parsed.username = payload.login_id || parsed.username || "";
    parsed.uid = Number(payload.uid || parsed.uid || 0);
    localStorage.setItem("userData", JSON.stringify(parsed));
  } catch {
    localStorage.setItem("userData", JSON.stringify({
      username: payload.login_id || "",
      uid: Number(payload.uid || 0),
    }));
  }
  syncAuthStatus();
}

async function submitAccountPasswordChange() {
  if (accountSubmitting.value) return;
  if (!accountPasswordForm.value.current_password.trim()) {
    accountError.value = "현재 비밀번호를 입력해 주세요.";
    return;
  }
  if (!accountPasswordForm.value.new_password.trim()) {
    accountError.value = "새 비밀번호를 입력해 주세요.";
    return;
  }
  if (accountPasswordForm.value.new_password !== accountPasswordForm.value.confirm_password) {
    accountError.value = "새 비밀번호 확인이 일치하지 않습니다.";
    return;
  }
  accountSubmitting.value = true;
  accountError.value = "";
  try {
    const res = await api.post("/users/account/change-password", {
      current_password: accountPasswordForm.value.current_password,
      new_password: accountPasswordForm.value.new_password,
    });
    resetAccountForms();
    showNotice(res?.data?.message || "비밀번호를 변경했습니다.", "success");
  } catch (error) {
    accountError.value = error?.response?.data?.detail || "비밀번호 변경에 실패했습니다.";
  } finally {
    accountSubmitting.value = false;
  }
}

async function submitAccountLoginIdChange() {
  if (accountSubmitting.value) return;
  if (!accountProfile.value || Number(accountProfile.value.login_change_remaining || 0) <= 0) {
    accountError.value = "아이디 변경 가능 횟수가 남아 있지 않습니다.";
    return;
  }
  if (!accountLoginIdForm.value.current_password.trim()) {
    accountError.value = "현재 비밀번호를 입력해 주세요.";
    return;
  }
  if (!accountLoginIdForm.value.new_login_id.trim()) {
    accountError.value = "새 아이디를 입력해 주세요.";
    return;
  }
  accountSubmitting.value = true;
  accountError.value = "";
  try {
    const res = await api.post("/users/account/change-login-id", {
      current_password: accountLoginIdForm.value.current_password,
      new_login_id: accountLoginIdForm.value.new_login_id,
    });
    updateAuthStorageAfterLoginIdChange(res?.data || {});
    await loadAccountProfile();
    resetAccountForms();
    showNotice(res?.data?.message || "아이디를 변경했습니다.", "success", 3200);
  } catch (error) {
    accountError.value = error?.response?.data?.detail || "아이디 변경에 실패했습니다.";
  } finally {
    accountSubmitting.value = false;
  }
}

async function submitAdminPasswordReset() {
  if (accountSubmitting.value) return;
  if (!Number(adminAccountForm.value.target_user_id || 0)) {
    accountError.value = "대상 사용자를 선택해 주세요.";
    return;
  }
  accountSubmitting.value = true;
  accountError.value = "";
  try {
    const res = await api.post("/users/account/admin/reset-password", {
      target_user_id: Number(adminAccountForm.value.target_user_id),
    });
    showNotice(res?.data?.message || "비밀번호를 재설정했습니다.", "success");
  } catch (error) {
    accountError.value = error?.response?.data?.detail || "비밀번호 재설정에 실패했습니다.";
  } finally {
    accountSubmitting.value = false;
  }
}

async function submitAdminLoginChangeRemaining() {
  if (accountSubmitting.value) return;
  if (!Number(adminAccountForm.value.target_user_id || 0)) {
    accountError.value = "대상 사용자를 선택해 주세요.";
    return;
  }
  accountSubmitting.value = true;
  accountError.value = "";
  try {
    const res = await api.post("/users/account/admin/set-login-change-remaining", {
      target_user_id: Number(adminAccountForm.value.target_user_id),
      login_change_remaining: Number(adminAccountForm.value.login_change_remaining || 0),
    });
    await loadAdminAccountUsers();
    showNotice(res?.data?.message || "아이디 변경 잔여 횟수를 설정했습니다.", "success");
  } catch (error) {
    accountError.value = error?.response?.data?.detail || "아이디 변경 잔여 횟수 설정에 실패했습니다.";
  } finally {
    accountSubmitting.value = false;
  }
}

async function submitAdminCreateUser() {
  if (accountSubmitting.value) return;
  if (!adminCreateUserForm.value.login_id.trim()) {
    accountError.value = "새 로그인 아이디를 입력해 주세요.";
    return;
  }
  if (!adminCreateUserForm.value.display_name.trim()) {
    accountError.value = "이름을 입력해 주세요.";
    return;
  }
  accountSubmitting.value = true;
  accountError.value = "";
  try {
    const res = await api.post("/users/account/admin/create-user", {
      login_id: adminCreateUserForm.value.login_id,
      display_name: adminCreateUserForm.value.display_name,
    });
    adminCreateUserForm.value = {
      login_id: "",
      display_name: "",
    };
    await loadAdminAccountUsers();
    showNotice(res?.data?.message || "사용자를 생성했습니다.", "success", 3600);
  } catch (error) {
    accountError.value = error?.response?.data?.detail || "사용자 생성에 실패했습니다.";
  } finally {
    accountSubmitting.value = false;
  }
}

function startAuthTimer() {
  stopAuthTimer();
  syncAuthStatus();
  authTimerId = window.setInterval(syncAuthStatus, 10000);
}

function stopAuthTimer() {
  if (!authTimerId) return;
  clearInterval(authTimerId);
  authTimerId = null;
}

function clearAuthStorage() {
  for (const key of AUTH_STORAGE_KEYS) {
    localStorage.removeItem(key);
  }
}

function goToSunghoLogin() {
  router.push({ path: "/sungho", query: { redirect: INET_REDIRECT_PATH } });
}

async function logoutFromInet() {
  try {
    if (hasValidSession()) {
      await api.post("/logout");
    }
  } catch {
    // ignore
  }

  clearAuthStorage();
  accountMenuOpen.value = false;
  closeAccountPanel();
  syncAuthStatus();
  modalMode.value = "";
  closeScoreboard();
}

function onAuthStorageChanged(event) {
  const key = event?.key || "";
  if (
    !event ||
    !key ||
    AUTH_STORAGE_KEYS.includes(key) ||
    key === DEFAULT_OFFICE_STORAGE_LEGACY_KEY ||
    key.startsWith(`${DEFAULT_OFFICE_STORAGE_KEY_PREFIX}:`)
  ) {
    syncAuthStatus();
  }
}

function resolveCreateEntryType(entryType = "new") {
  if (entryType === "facility") return "facility";
  if (entryType === "supplement") return "supplement";
  return "new";
}

function stashPostLoginAction(mode, itemId = null, entryType = "new") {
  const resolvedType = resolveCreateEntryType(entryType);
  try {
    sessionStorage.setItem(
      INET_POST_LOGIN_ACTION_KEY,
      JSON.stringify({
        mode,
        itemId: itemId ? Number(itemId) : null,
        entryType: resolvedType,
      })
    );
  } catch {
    // ignore
  }
}

function takePostLoginAction() {
  try {
    const raw = sessionStorage.getItem(INET_POST_LOGIN_ACTION_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(INET_POST_LOGIN_ACTION_KEY);

    const parsed = JSON.parse(raw);
    if (!parsed || (parsed.mode !== "create" && parsed.mode !== "edit")) return null;
    return parsed;
  } catch {
    sessionStorage.removeItem(INET_POST_LOGIN_ACTION_KEY);
    return null;
  }
}

function requireManageAuth(mode, itemId = null, entryType = "new") {
  if (hasValidSession()) return true;
  stashPostLoginAction(mode, itemId, entryType);
  const actionLabel = mode === "create" ? "등록" : "편집";
  alert(`${actionLabel}하려면 로그인이 필요합니다. 로그인 화면으로 이동합니다.`);
  goToSunghoLogin();
  return false;
}

async function runPostLoginAction() {
  if (!hasValidSession()) return;
  const pending = takePostLoginAction();
  if (!pending) return;

  if (pending.mode === "create") {
    const resolvedType = resolveCreateEntryType(pending.entryType);
    const sourceItemId = Number(pending.itemId || 0);
    const sourceItem = sourceItemId ? items.value.find((item) => Number(item.id) === sourceItemId) || null : null;
    openCreate(resolvedType, sourceItem);
    return;
  }

  const editTargetId = Number(pending.itemId || 0);
  if (!editTargetId) return;

  const target = items.value.find((item) => Number(item.id) === editTargetId);
  if (!target) {
    alert("로그인 후 편집 대상을 찾을 수 없습니다. 목록에서 다시 선택해 주세요.");
    return;
  }

  selected.value = target;
  openEdit(pending.entryType || "facility");
}

function clearCommentsState() {
  comments.value = [];
  commentsLoading.value = false;
  commentsError.value = "";
  commentDraft.value = "";
  commentSubmitting.value = false;
  commentsCollapsed.value = true;
}

function clearPhotosState() {
  buildingPhotos.value = [];
  buildingPhotosLoading.value = false;
  buildingPhotosError.value = "";
  buildingPhotoUploading.value = false;
  dongPhotos.value = [];
  dongPhotosLoading.value = false;
  dongPhotosError.value = "";
  dongPhotoUploading.value = false;
  facilityPhotos.value = [];
  facilityPhotosLoading.value = false;
  facilityPhotosError.value = "";
  facilityPhotoUploading.value = false;
}

function reconcileSelectedWithCurrentList() {
  if (!selected.value) return;

  const matched = items.value.find((item) => Number(item.id) === Number(selected.value.id));
  if (matched) {
    selected.value = matched;
    return;
  }

  selected.value = null;
  clearCommentsState();
  clearPhotosState();
  if (isDetailModal.value || isPhotoModal.value) {
    modalMode.value = "";
  }
}

async function fetchItems() {
  await fetchItemsPage({ reset: true });
}

async function fetchItemsPage({ reset = false } = {}) {
  if (!reset && (!hasMoreItems.value || listLoading.value || listLoadingMore.value)) return;

  const targetOffset = reset ? 0 : nextOffset.value;
  try {
    if (reset) {
      listLoading.value = true;
      listError.value = "";
    } else {
      listLoadingMore.value = true;
    }
    const normalizedQuery = normalizeText(query.value);
    const selectedOffice = normalizeText(selectedOfficeFilter.value);
    const params = {
      limit: PAGE_SIZE,
      offset: targetOffset,
      ...(normalizedQuery ? { query: normalizedQuery } : {}),
      ...(selectedOffice ? { office_name: selectedOffice } : {}),
    };
    const res = await api.get(INET_COLLECTION_PATH, { params });
    const payload = res?.data || {};
    const pageItems = Array.isArray(payload.items) ? payload.items : [];
    allItems.value = reset ? pageItems : [...allItems.value, ...pageItems];
    totalBuildingCount.value = Number(payload.total_count || 0);
    hasMoreItems.value = Boolean(payload.has_more);
    nextOffset.value = Number(payload.offset ?? targetOffset) + Number(payload.limit || PAGE_SIZE);
    if (reset) {
      await nextTick();
      const container = facilityListRef.value;
      if (container instanceof HTMLElement) {
        container.scrollTop = 0;
      }
    }
    reconcileSelectedWithCurrentList();
  } catch {
    listError.value = "시설 목록을 가져오지 못했습니다. 잠시 후 다시 시도해 주세요.";
    playUiTone("error");
  } finally {
    listLoading.value = false;
    listLoadingMore.value = false;
  }
}

async function maybeLoadMoreOnScroll() {
  if (!hasMoreItems.value || listLoading.value || listLoadingMore.value) return;
  const container = facilityListRef.value;
  if (!container) return;
  const threshold = container.scrollHeight - container.clientHeight - 180;
  if (container.scrollTop >= Math.max(threshold, 0)) {
    await fetchItemsPage({ reset: false });
  }
}

function setFacilityItemRef(key, el) {
  if (!key) return;
  if (el instanceof HTMLElement) {
    facilityItemElements.set(key, el);
  } else {
    facilityItemElements.delete(key);
  }
}

function facilityItemStyle(key) {
  if (viewportWidth.value < 1280) return undefined;
  const span = Number(itemSpanMap.value[key] || 0);
  return span > 0 ? { gridRowEnd: `span ${span}` } : undefined;
}

function ensureFacilityResizeObserver() {
  if (typeof window === "undefined" || typeof ResizeObserver === "undefined" || facilityResizeObserver) return;
  facilityResizeObserver = new ResizeObserver(() => {
    scheduleFacilityLayout();
  });
}

function observeFacilityItems() {
  if (!facilityResizeObserver) return;
  facilityResizeObserver.disconnect();
  facilityItemElements.forEach((element) => {
    facilityResizeObserver.observe(element);
  });
}

function scheduleFacilityLayout() {
  if (typeof window === "undefined") return;
  if (facilityLayoutFrame) {
    window.cancelAnimationFrame(facilityLayoutFrame);
  }
  facilityLayoutFrame = window.requestAnimationFrame(() => {
    facilityLayoutFrame = 0;
    recalculateFacilityItemSpans();
  });
}

async function scrollToFacilityCard(item) {
  const key = getBuildingGroupKey(item);
  await nextTick();
  const element = facilityItemElements.get(key);
  if (element instanceof HTMLElement) {
    element.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}

function recalculateFacilityItemSpans() {
  if (typeof window === "undefined") return;
  if (viewportWidth.value < 1280) {
    itemSpanMap.value = {};
    return;
  }
  const container = facilityListRef.value;
  if (!(container instanceof HTMLElement)) return;

  const computed = window.getComputedStyle(container);
  const rowSize = Number.parseFloat(computed.gridAutoRows || "0");
  const rowGap = Number.parseFloat(computed.rowGap || computed.gap || "0");
  if (!rowSize) return;

  const nextSpans = {};
  facilityItemElements.forEach((element, key) => {
    const height = element.getBoundingClientRect().height;
    const span = Math.max(1, Math.ceil((height + rowGap) / (rowSize + rowGap)));
    nextSpans[key] = span;
  });
  itemSpanMap.value = nextSpans;
}

async function fetchOfficeOptions() {
  try {
    const res = await api.get(INET_OFFICES_PATH);
    officeOptionsFromServer.value = Array.isArray(res.data)
      ? res.data.map((v) => normalizeText(v)).filter(Boolean)
      : [];
  } catch {
    officeOptionsFromServer.value = [];
  }
}

async function fetchComments(facilityId) {
  const targetId = Number(facilityId || 0);
  if (targetId === 0) {
    clearCommentsState();
    return;
  }

  commentsLoading.value = true;
  commentsError.value = "";

  try {
    const res = await api.get(`/inet/${targetId}/comments`);
    comments.value = Array.isArray(res.data) ? res.data : [];
  } catch {
    comments.value = [];
    commentsError.value = "댓글을 불러오지 못했습니다.";
  } finally {
    commentsLoading.value = false;
  }
}

async function fetchPhotoGroup(targetId, kind) {
  const normalizedTargetId = Number(targetId || 0);
  if (kind === "building") {
    if (normalizedTargetId === 0) {
      buildingPhotos.value = [];
      buildingPhotosLoading.value = false;
      buildingPhotosError.value = "";
      return;
    }
    buildingPhotosLoading.value = true;
    buildingPhotosError.value = "";
    try {
      const res = await api.get(`/inet/${normalizedTargetId}/photos`);
      const rows = Array.isArray(res.data) ? res.data : [];
      if (normalizedTargetId < 0) {
        buildingPhotos.value = selectPhotoRowsByKind(rows, "building");
        facilityPhotos.value = selectPhotoRowsByKind(rows, "facility");
        facilityPhotosError.value = "";
      } else {
        buildingPhotos.value = selectPhotoRowsByKind(rows, "building");
      }
    } catch {
      buildingPhotos.value = [];
      buildingPhotosError.value = "건물 사진을 불러오지 못했습니다.";
    } finally {
      buildingPhotosLoading.value = false;
    }
    return;
  }

  if (kind === "dong") {
    if (normalizedTargetId === 0) {
      dongPhotos.value = [];
      dongPhotosLoading.value = false;
      dongPhotosError.value = "";
      return;
    }
    dongPhotosLoading.value = true;
    dongPhotosError.value = "";
    try {
      const res = await api.get(`/inet/${normalizedTargetId}/photos`, { params: { photo_scope: "dong" } });
      const rows = Array.isArray(res.data) ? res.data : [];
      dongPhotos.value = selectPhotoRowsByKind(rows, "dong");
    } catch {
      dongPhotos.value = [];
      dongPhotosError.value = "동 사진을 불러오지 못했습니다.";
    } finally {
      dongPhotosLoading.value = false;
    }
    return;
  }

  if (normalizedTargetId === 0) {
    facilityPhotos.value = [];
    facilityPhotosLoading.value = false;
    facilityPhotosError.value = "";
    return;
  }
  facilityPhotosLoading.value = true;
  facilityPhotosError.value = "";
  try {
    const photoParams = normalizedTargetId < 0 ? undefined : { photo_scope: "facility" };
    const res = await api.get(`/inet/${normalizedTargetId}/photos`, { params: photoParams });
    const rows = Array.isArray(res.data) ? res.data : [];
    if (normalizedTargetId < 0) {
      buildingPhotos.value = selectPhotoRowsByKind(rows, "building");
      facilityPhotos.value = selectPhotoRowsByKind(rows, "facility");
      buildingPhotosError.value = "";
    } else {
      facilityPhotos.value = selectPhotoRowsByKind(rows, "facility");
    }
  } catch {
    facilityPhotos.value = [];
    facilityPhotosError.value = "시설 사진을 불러오지 못했습니다.";
  } finally {
    facilityPhotosLoading.value = false;
  }
}

function requireCommentAuth() {
  if (hasValidSession()) return true;
  alert("댓글 작성/삭제는 로그인 후 가능합니다. 로그인 화면으로 이동합니다.");
  goToSunghoLogin();
  return false;
}

function isAutoComment(comment) {
  if (comment?.is_auto) return true;
  const text = normalizeText(comment?.comment);
  if (!text) return false;
  return /수정함$/.test(text) || /수정$/.test(text);
}

function parseAutoComment(text) {
  const normalized = normalizeText(text);
  if (!normalized) return null;
  const match = normalized.match(/^(건물|시설)\s+(.+)\s+수정$/);
  if (!match) return null;
  const fields = match[2].split(",").map((value) => normalizeText(value)).filter(Boolean);
  if (!fields.length) return null;
  return {
    scope: `${match[1]} `,
    fields,
  };
}

function canDeleteComment(comment) {
  const loginId = getStoredLoginId().toLowerCase();
  const isAdmin = INET_DELETE_ADMIN_LOGIN_IDS.includes(loginId);
  if (isAutoComment(comment)) return isAdmin;
  const currentUserId = getStoredUserId();
  return isAdmin || (currentUserId > 0 && Number(comment?.user_id || 0) === currentUserId);
}

function canDeletePhoto(photo) {
  const loginId = getStoredLoginId().toLowerCase();
  const isAdmin = INET_DELETE_ADMIN_LOGIN_IDS.includes(loginId);
  const currentUserId = getStoredUserId();
  return isAdmin || (currentUserId > 0 && Number(photo?.user_id || 0) === currentUserId);
}

function canShowSetPrimaryButton(kind, photo, photos) {
  if (kind !== "building") return false;
  const rows = Array.isArray(photos) ? photos : [];
  return rows.length > 1;
}

function photoLabel(kind) {
  if (kind === "building") return "건물사진";
  if (kind === "dong") return "동사진";
  return "시설사진";
}

function formatPhotoSize(sizeBytes) {
  const size = Number(sizeBytes || 0);
  if (size <= 0) return "";
  if (size < 1024 * 1024) return `${Math.max(1, Math.round(size / 1024))}KB`;
  return `${(size / (1024 * 1024)).toFixed(1)}MB`;
}

function uniqPhotoRows(rows) {
  const list = Array.isArray(rows) ? rows : [];
  const seen = new Set();
  return list.filter((photo) => {
    const id = Number(photo?.id || 0);
    const key = id > 0 ? `id:${id}` : JSON.stringify([
      normalizeText(photo?.target_kind),
      normalizeText(photo?.original_url),
      normalizeText(photo?.display_url),
      normalizeText(photo?.thumb_url),
      normalizeText(photo?.file_url),
    ]);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

function selectPhotoRowsByKind(rows, kind) {
  const normalizedKind = kind === "building" ? "building" : (kind === "dong" ? "dong" : "facility");
  return uniqPhotoRows(rows).filter((photo) => {
    const targetKind = normalizeText(photo?.target_kind);
    return !targetKind || targetKind === normalizedKind;
  });
}

function openPhoto(photo) {
  const url = normalizeText(photo?.display_url || photo?.thumb_url || photo?.file_url);
  if (!url) return;
  photoPreviewUrl.value = normalizeInetMediaUrl(url);
  photoPreviewKind.value = normalizeText(photo?.target_kind) || photoModalKind.value || "";
  photoPreviewPhoto.value = photo;
  photoPreviewIsOriginal.value = false;
  photoPreviewOpen.value = true;
}

function openOriginalPhoto(photo) {
  const url = normalizeText(photo?.original_url || photo?.display_url || photo?.file_url);
  if (!url) return;
  photoPreviewUrl.value = normalizeInetMediaUrl(url);
  photoPreviewKind.value = normalizeText(photo?.target_kind) || photoModalKind.value || "";
  photoPreviewPhoto.value = photo;
  photoPreviewIsOriginal.value = true;
  photoPreviewOpen.value = true;
}

function buildPhotoDownloadFileName(photo, useOriginal) {
  const rawName = normalizeText(photo?.original_name) || "inet_photo.jpg";
  const dotIndex = rawName.lastIndexOf(".");
  if (dotIndex <= 0 || dotIndex === rawName.length - 1) {
    return `${rawName}${useOriginal ? "_original" : "_display"}`;
  }
  const name = rawName.slice(0, dotIndex);
  const ext = rawName.slice(dotIndex);
  return `${name}${useOriginal ? "_original" : "_display"}${ext}`;
}

function resolveInetMediaUrl(url) {
  const normalized = normalizeText(url);
  if (!normalized) return "";
  if (/^https?:\/\//i.test(normalized)) return normalized;
  return new URL(normalized, window.location.origin).toString();
}

async function downloadPreviewPhoto(photo) {
  const useOriginal = photoPreviewIsOriginal.value;
  // Keep download target aligned with the current preview mode.
  const sourceUrl = resolveInetMediaUrl(
    useOriginal
      ? (photo?.original_url || photo?.display_url || photo?.file_url)
      : (photo?.display_url || photo?.file_url || photo?.thumb_url),
  );
  if (!sourceUrl || photoDownloadLoading.value) return;

  photoDownloadLoading.value = true;
  try {
    const res = await fetch(sourceUrl, { credentials: "include" });
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
    const blob = await res.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = buildPhotoDownloadFileName(photo, useOriginal);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
    playUiTone("success");
  } catch (error) {
    alert(extractApiErrorMessage(error, "사진 다운로드에 실패했습니다."));
    playUiTone("error");
  } finally {
    photoDownloadLoading.value = false;
  }
}

function resolvePhotoUploadTargetId(kind, item) {
  const sourceItem = item || selected.value;
  if (!sourceItem) return 0;
  if (kind === "building") {
    const buildingId = Number(sourceItem?.building_id || 0);
    return buildingId > 0 ? -Math.abs(buildingId) : 0;
  }
  if (kind === "dong") {
    const targetId = Number(sourceItem?.id || 0);
    return targetId > 0 && normalizeBuildingDong(sourceItem?.building_dong) ? targetId : 0;
  }
  const targetId = Number(sourceItem?.id || 0);
  return targetId !== 0 ? targetId : 0;
}

async function uploadPhotos(kind, event, sourceItem = null) {
  const targetItem = sourceItem || selected.value;
  const targetId = resolvePhotoUploadTargetId(kind, targetItem);
  if (!targetItem || targetId === 0) return;
  if (sourceItem) {
    selected.value = sourceItem;
  }
  const input = event?.target;
  const files = Array.from(input?.files || []);
  if (!files.length) return;

  if (kind === "building") {
    buildingPhotoUploading.value = true;
    buildingPhotosError.value = "";
  } else if (kind === "dong") {
    dongPhotoUploading.value = true;
    dongPhotosError.value = "";
  } else {
    facilityPhotoUploading.value = true;
    facilityPhotosError.value = "";
  }

  try {
    const uploadParams = kind === "facility"
      ? { photo_scope: "facility", source_kind: "picker" }
      : (kind === "dong" ? { photo_scope: "dong", source_kind: "picker" } : { source_kind: "picker" });
    const duplicateFormData = new FormData();
    for (const file of files) {
      duplicateFormData.append("files", file);
    }
    const duplicateRes = await api.post(`/inet/${targetId}/photos/check-duplicate`, duplicateFormData, {
      headers: { "Content-Type": "multipart/form-data" },
      params: uploadParams,
    });
    const duplicateItems = Array.isArray(duplicateRes?.data?.items) ? duplicateRes.data.items : [];
    const exactDuplicate = duplicateItems.find((item) => normalizeText(item?.status) === "exact_duplicate" && Array.isArray(item?.exact_duplicates) && item.exact_duplicates.length);
    if (exactDuplicate) {
      const candidate = exactDuplicate.exact_duplicates[0]?.photo;
      if (candidate?.id && confirm("같은 사진이 이미 있습니다. 새 업로드 대신 기존 사진을 참조할까요?")) {
        const reuseRes = await api.post(`/inet/${targetId}/photos/${candidate.id}/reuse`, null, {
          params: kind === "facility" ? { photo_scope: "facility" } : (kind === "dong" ? { photo_scope: "dong" } : undefined),
        });
        const rows = Array.isArray(reuseRes?.data?.items) ? reuseRes.data.items : [];
        if (kind === "building") {
          buildingPhotos.value = selectPhotoRowsByKind(rows, "building");
        } else if (kind === "dong") {
          dongPhotos.value = selectPhotoRowsByKind(rows, "dong");
        } else {
          facilityPhotos.value = selectPhotoRowsByKind(rows, "facility");
        }
        await Promise.all([fetchItems(), fetchOfficeOptions()]);
        showNotice(normalizeText(reuseRes?.data?.message) || "기존 사진을 참조로 연결했고 목록을 새로고침했습니다.", "success");
        playUiTone("success");
        return;
      }
    }
    const similarDuplicate = duplicateItems.find((item) =>
      (normalizeText(item?.status) === "similar_duplicate" || normalizeText(item?.status) === "building_context") &&
      Array.isArray(item?.similar_candidates) &&
      item.similar_candidates.length
    );
    if (similarDuplicate) {
      duplicateCompareCandidates.value = similarDuplicate.similar_candidates;
      duplicateCompareMode.value = normalizeText(similarDuplicate?.status) || "similar_duplicate";
      duplicatePendingUpload.value = {
        kind,
        targetId,
        sourceItem: targetItem,
        files,
      };
      buildDuplicatePendingPreviews(files);
      duplicateCompareOpen.value = true;
      return;
    }

    const formData = new FormData();
    for (const file of files) {
      formData.append("files", file);
    }
    const res = await api.post(`/inet/${targetId}/photos`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      params: uploadParams,
    });
    const rows = Array.isArray(res.data) ? res.data : [];
    if (kind === "building") {
      buildingPhotos.value = selectPhotoRowsByKind(rows, "building");
    } else if (kind === "dong") {
      dongPhotos.value = selectPhotoRowsByKind(rows, "dong");
    } else {
      facilityPhotos.value = selectPhotoRowsByKind(rows, "facility");
    }
    await Promise.all([fetchItems(), fetchOfficeOptions()]);
    showNotice(`${kind === "building" ? "건물" : (kind === "dong" ? "동" : "시설")} 사진이 반영되었습니다. 목록을 새로고침했습니다.`, "success");
    playUiTone("success");
  } catch (error) {
    const label = kind === "building" ? "건물" : (kind === "dong" ? "동" : "시설");
    const message = extractApiErrorMessage(error, `${label} 사진 업로드에 실패했습니다.`);
    if (kind === "building") {
      buildingPhotosError.value = message;
    } else if (kind === "dong") {
      dongPhotosError.value = message;
    } else {
      facilityPhotosError.value = message;
    }
    showNotice(message, "error", 3200);
    playUiTone("error");
  } finally {
    if (input) {
      input.value = "";
    }
    if (kind === "building") {
      buildingPhotoUploading.value = false;
    } else if (kind === "dong") {
      dongPhotoUploading.value = false;
    } else {
      facilityPhotoUploading.value = false;
    }
    if (input) input.value = "";
  }
}

function closeDuplicateCompare() {
  duplicateCompareOpen.value = false;
  duplicateCompareCandidates.value = [];
  duplicateCompareMode.value = "similar_duplicate";
  duplicatePendingUpload.value = null;
  resetDuplicatePendingPreviews();
}

async function proceedDuplicateUpload() {
  const pending = duplicatePendingUpload.value;
  if (!pending) return;

  const { kind, targetId, files } = pending;
  try {
    const uploadParams = kind === "facility"
      ? { photo_scope: "facility", source_kind: "picker" }
      : (kind === "dong" ? { photo_scope: "dong", source_kind: "picker" } : { source_kind: "picker" });
    const formData = new FormData();
    for (const file of files) {
      formData.append("files", file);
    }
    const res = await api.post(`/inet/${targetId}/photos`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      params: uploadParams,
    });
    const rows = Array.isArray(res.data) ? res.data : [];
    if (kind === "building") {
      buildingPhotos.value = selectPhotoRowsByKind(rows, "building");
    } else if (kind === "dong") {
      dongPhotos.value = selectPhotoRowsByKind(rows, "dong");
    } else {
      facilityPhotos.value = selectPhotoRowsByKind(rows, "facility");
    }
    await Promise.all([fetchItems(), fetchOfficeOptions()]);
    showNotice(`${kind === "building" ? "건물" : (kind === "dong" ? "동" : "시설")} 사진이 반영되었습니다. 목록을 새로고침했습니다.`, "success");
    closeDuplicateCompare();
    playUiTone("success");
  } catch (error) {
    const label = kind === "building" ? "건물" : (kind === "dong" ? "동" : "시설");
    const message = extractApiErrorMessage(error, `${label} 사진 업로드에 실패했습니다.`);
    if (kind === "building") {
      buildingPhotosError.value = message;
    } else if (kind === "dong") {
      dongPhotosError.value = message;
    } else {
      facilityPhotosError.value = message;
    }
    showNotice(message, "error", 3200);
    playUiTone("error");
  }
}

async function replaceDuplicatePrimary(candidate) {
  const pending = duplicatePendingUpload.value;
  const photoId = Number(candidate?.photo?.id || 0);
  if (!pending || photoId <= 0 || !pending.files?.length) return;

  const { kind, targetId, files } = pending;
  try {
    const uploadParams = kind === "facility"
      ? { photo_scope: "facility", source_kind: "picker" }
      : (kind === "dong" ? { photo_scope: "dong", source_kind: "picker" } : { source_kind: "picker" });
    const formData = new FormData();
    formData.append("files", files[0]);
    const res = await api.post(`/inet/${targetId}/photos/${photoId}/replace-primary`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      params: uploadParams,
    });
    const rows = Array.isArray(res?.data?.items) ? res.data.items : [];
    if (kind === "building") {
      buildingPhotos.value = selectPhotoRowsByKind(rows, "building");
    } else if (kind === "dong") {
      dongPhotos.value = selectPhotoRowsByKind(rows, "dong");
    } else {
      facilityPhotos.value = selectPhotoRowsByKind(rows, "facility");
    }
    await Promise.all([fetchItems(), fetchOfficeOptions()]);
    showNotice(normalizeText(res?.data?.message) || "기존 대표 사진을 교체했고 목록을 새로고침했습니다.", "success");
    closeDuplicateCompare();
    playUiTone("success");
  } catch (error) {
    const label = kind === "building" ? "건물" : (kind === "dong" ? "동" : "시설");
    const message = extractApiErrorMessage(error, `${label} 대표 사진 교체에 실패했습니다.`);
    if (kind === "building") {
      buildingPhotosError.value = message;
    } else if (kind === "dong") {
      dongPhotosError.value = message;
    } else {
      facilityPhotosError.value = message;
    }
    showNotice(message, "error", 3200);
    playUiTone("error");
  }
}

async function reuseDuplicateCandidate(candidate) {
  const pending = duplicatePendingUpload.value;
  const photoId = Number(candidate?.photo?.id || 0);
  if (!pending || photoId <= 0) return;
  const { kind, targetId } = pending;
  try {
    const reuseRes = await api.post(`/inet/${targetId}/photos/${photoId}/reuse`, null, {
      params: kind === "facility" ? { photo_scope: "facility" } : (kind === "dong" ? { photo_scope: "dong" } : undefined),
    });
    const rows = Array.isArray(reuseRes?.data?.items) ? reuseRes.data.items : [];
    if (kind === "building") {
      buildingPhotos.value = selectPhotoRowsByKind(rows, "building");
    } else if (kind === "dong") {
      dongPhotos.value = selectPhotoRowsByKind(rows, "dong");
    } else {
      facilityPhotos.value = selectPhotoRowsByKind(rows, "facility");
    }
    await Promise.all([fetchItems(), fetchOfficeOptions()]);
    showNotice(normalizeText(reuseRes?.data?.message) || "기존 사진을 참조했고 목록을 새로고침했습니다.", "success");
    closeDuplicateCompare();
    playUiTone("success");
  } catch (error) {
    showNotice(extractApiErrorMessage(error, "기존 사진 참조에 실패했습니다."), "error", 3200);
    playUiTone("error");
  }
}

function resolvePhotoDeleteTargetId(photo, fallbackTargetId) {
  const normalizedKind = normalizeText(photo?.target_kind);
  if (normalizedKind === "building") {
    const buildingId = Number(photo?.building_id || photo?.target_id || 0);
    if (buildingId > 0) return -Math.abs(buildingId);
  }
  if (normalizedKind === "facility") {
    const spanId = Number(photo?.span_id || photo?.target_id || 0);
    if (spanId > 0) return spanId;
  }
  if (normalizedKind === "dong") {
    const fallback = Number(fallbackTargetId || 0);
    if (fallback !== 0) return fallback;
  }
  const fallback = Number(fallbackTargetId || 0);
  return fallback !== 0 ? fallback : 0;
}

async function removePhoto(kind, photo) {
  const fallbackTargetId = kind === "building"
    ? buildingPhotoTargetId.value
    : (kind === "dong" ? dongPhotoTargetId.value : facilityPhotoTargetId.value);
  const targetId = resolvePhotoDeleteTargetId(photo, fallbackTargetId);
  if (!selected.value || !photo?.id || targetId === 0) return;
  if (!canDeletePhoto(photo)) {
    alert("삭제 권한이 없습니다.");
    return;
  }
  if (!confirm("사진을 삭제하시겠습니까?")) return;

  if (kind === "building") {
    buildingPhotosError.value = "";
  } else if (kind === "dong") {
    dongPhotosError.value = "";
  } else {
    facilityPhotosError.value = "";
  }
  try {
    const res = await api.delete(`/inet/${targetId}/photos/${photo.id}`, {
      params: kind === "dong" ? { photo_scope: "dong" } : undefined,
    });
    if (kind === "building") {
      buildingPhotos.value = buildingPhotos.value.filter((item) => item.id !== photo.id);
    } else if (kind === "dong") {
      dongPhotos.value = dongPhotos.value.filter((item) => item.id !== photo.id);
    } else {
      facilityPhotos.value = facilityPhotos.value.filter((item) => item.id !== photo.id);
    }
    const detachedMessage = normalizeText(res?.data?.message);
    if (detachedMessage) {
      alert(detachedMessage);
    }
    playUiTone("success");
  } catch (error) {
    const label = kind === "building" ? "건물" : (kind === "dong" ? "동" : "시설");
    const message = extractApiErrorMessage(error, `${label} 사진 삭제에 실패했습니다.`);
    if (kind === "building") {
      buildingPhotosError.value = message;
    } else if (kind === "dong") {
      dongPhotosError.value = message;
    } else {
      facilityPhotosError.value = message;
    }
    playUiTone("error");
  }
}

async function setPrimaryPhoto(kind, photo) {
  const fallbackTargetId = kind === "building"
    ? buildingPhotoTargetId.value
    : (kind === "dong" ? dongPhotoTargetId.value : facilityPhotoTargetId.value);
  const targetId = resolvePhotoDeleteTargetId(photo, fallbackTargetId);
  if (!selected.value || !photo?.id || targetId === 0) return;
  if (!canDeletePhoto(photo)) {
    alert("대표 설정 권한이 없습니다.");
    return;
  }

  try {
    const res = await api.post(`/inet/${targetId}/photos/${photo.id}/set-primary`, null, {
      params: kind === "dong" ? { photo_scope: "dong" } : (kind === "facility" ? { photo_scope: "facility" } : undefined),
    });
    const rows = Array.isArray(res?.data?.items) ? res.data.items : [];
    if (kind === "building") {
      buildingPhotos.value = selectPhotoRowsByKind(rows, "building");
    } else if (kind === "dong") {
      dongPhotos.value = selectPhotoRowsByKind(rows, "dong");
    } else {
      facilityPhotos.value = selectPhotoRowsByKind(rows, "facility");
    }
    await Promise.all([fetchItems(), fetchOfficeOptions()]);
    showNotice(normalizeText(res?.data?.message) || "대표 사진으로 설정했습니다.", "success");
    playUiTone("success");
  } catch (error) {
    const label = kind === "building" ? "건물" : (kind === "dong" ? "동" : "시설");
    alert(extractApiErrorMessage(error, `${label} 대표 사진 설정에 실패했습니다.`));
    playUiTone("error");
  }
}

async function addComment() {
  if (!selected.value) return;
  if (!requireCommentAuth()) return;
  if (!canCommentOnSelected.value) return;

  const normalized = normalizeText(commentDraft.value);
  if (!normalized) return;

  commentSubmitting.value = true;
  commentsError.value = "";
  const targetId = selectedCommentTargetId.value;

  try {
    const res = await api.post(`/inet/${targetId}/comments`, { comment: normalized });
    comments.value.push(res.data);
    commentDraft.value = "";
    await refreshScoreboardIfOpen();
    playUiTone("success");
  } catch {
    commentsError.value = "댓글 등록에 실패했습니다.";
    playUiTone("error");
  } finally {
    commentSubmitting.value = false;
  }
}

async function removeComment(comment) {
  if (!selected.value || !comment?.id) return;
  if (!requireCommentAuth()) return;
  if (!canCommentOnSelected.value) return;
  if (!confirm("댓글을 삭제하시겠습니까?")) return;

  commentsError.value = "";
  const targetId = selectedCommentTargetId.value;

  try {
    await api.delete(`/inet/${targetId}/comments/${comment.id}`);
    comments.value = comments.value.filter((item) => item.id !== comment.id);
    await refreshScoreboardIfOpen();
    playUiTone("success");
  } catch {
    commentsError.value = "댓글 삭제에 실패했습니다.";
    playUiTone("error");
  }
}

function getOfficeStorageIdentity() {
  const loginId = normalizeText(getStoredLoginId()).toLowerCase();
  if (loginId) return `login:${loginId}`;
  const userId = Number(getStoredUserId() || 0);
  if (userId > 0) return `uid:${userId}`;
  return "guest";
}

function getDefaultOfficeStorageKey(identity = getOfficeStorageIdentity()) {
  return `${DEFAULT_OFFICE_STORAGE_KEY_PREFIX}:${identity}`;
}

function loadDefaultOfficeName(identity = getOfficeStorageIdentity()) {
  if (typeof window === "undefined") return DEFAULT_OFFICE_NAME;

  const scoped = normalizeText(localStorage.getItem(getDefaultOfficeStorageKey(identity)));
  if (scoped) return scoped;

  const legacy = normalizeText(localStorage.getItem(DEFAULT_OFFICE_STORAGE_LEGACY_KEY));
  if (legacy) {
    localStorage.setItem(getDefaultOfficeStorageKey(identity), legacy);
    return legacy;
  }
  return DEFAULT_OFFICE_NAME;
}

function persistDefaultOfficeName(value, identity = getOfficeStorageIdentity()) {
  if (typeof window === "undefined") return;
  localStorage.setItem(getDefaultOfficeStorageKey(identity), value);
}

function syncDefaultOfficeForCurrentUser() {
  if (typeof window === "undefined") return;
  const identity = getOfficeStorageIdentity();
  if (identity === lastOfficeStorageIdentity) return;

  lastOfficeStorageIdentity = identity;
  const defaultOffice = loadDefaultOfficeName(identity);
  defaultOfficeName.value = defaultOffice;
  selectedOfficeFilter.value = defaultOffice;

  if (modalMode.value === "create") {
    form.value.office_name = defaultOffice;
    form.value.office_id = null;
    form.value.admin_dong_id = null;
  }
}

function setDefaultOffice(nextOfficeName = null) {
  const nextOffice = normalizeText(nextOfficeName || selectedOfficeFilter.value);
  if (!nextOffice) {
    alert("전체는 기본국사로 지정할 수 없습니다.");
    return;
  }

  defaultOfficeName.value = nextOffice;
  selectedOfficeFilter.value = nextOffice;
  persistDefaultOfficeName(nextOffice);

  if (modalMode.value === "create") {
    form.value.office_name = nextOffice;
    form.value.office_id = null;
    form.value.admin_dong_id = null;
  }
}

function handleOfficeSelect(officeName) {
  if (!officeName) {
    selectedOfficeFilter.value = null;
    officeMenuOpen.value = false;
    return;
  }

  const normalized = normalizeText(officeName);
  selectedOfficeFilter.value = normalized;
  if (normalized && normalized !== defaultOfficeName.value) {
    setDefaultOffice(normalized);
  }
  officeMenuOpen.value = false;
}

function handleFormOfficeInput() {
  form.value.office_id = null;
  form.value.admin_dong_id = null;
}

function handleFormAdminDongInput() {
  form.value.admin_dong_id = null;
}

function normalizeFormFromItem(item = null) {
  return {
    office_id: Number(item?.office_id || 0) || null,
    admin_dong_id: Number(item?.admin_dong_id || 0) || null,
    office_name: normalizeText(item?.office_name) || defaultOfficeName.value,
    admin_dong: normalizeAdminDong(item?.admin_dong),
    main_lot: normalizeText(item?.main_lot),
    sub_lot: normalizeText(item?.sub_lot),
    building_name: normalizeText(item?.building_name),
    address: buildAddressFromLot(item?.admin_dong, item?.main_lot, item?.sub_lot),
    building_dong: normalizeBuildingDong(item?.building_dong),
    line: normalizeLineValue(item?.line),
    mdf: normalizeText(item?.mdf),
    management_office: normalizeText(item?.management_office),
    lock_device: normalizeText(item?.lock_device),
    key_location: normalizeText(item?.key_location),
    entrance_door: normalizeText(item?.entrance_door),
    restroom: normalizeText(item?.restroom),
    building_memo: normalizeText(item?.building_memo),
    terminal_box: normalizeText(item?.terminal_box),
    exclusive_provider: normalizeExclusiveProvider(item?.exclusive_provider),
    apply_floor: normalizeApplyFloorValue(item?.apply_floor),
    position: normalizePositionValue(item?.position),
    equipment_location: normalizeEquipmentLocationValue(item?.equipment_location),
    facility: normalizeText(item?.facility),
    phone_facility: normalizeText(item?.phone_facility),
    memo: normalizeText(item?.memo),
  };
}

function clearNonBuildingFieldsForFacilityCreate(baseForm) {
  return {
    ...baseForm,
    building_dong: "",
    line: "",
    mdf: "",
    management_office: "",
    lock_device: "",
    key_location: "",
    entrance_door: "",
    restroom: "",
    building_memo: "",
    terminal_box: "",
    exclusive_provider: "",
    apply_floor: "",
    position: "",
    equipment_location: "",
    facility: "",
    phone_facility: "",
    memo: "",
  };
}

function buildFacilityCreateForm(sourceItem = null, { preserveDong = false, preserveLine = false } = {}) {
  const baseForm = clearNonBuildingFieldsForFacilityCreate(normalizeFormFromItem(sourceItem));
  return {
    ...baseForm,
    building_dong: preserveDong ? normalizeBuildingDong(sourceItem?.building_dong) : "",
    line: preserveLine ? normalizeLineValue(sourceItem?.line) : "",
  };
}

function toNullableText(value) {
  const normalized = normalizeText(value);
  return normalized || null;
}

function toFacilityPayload() {
  const officeName = normalizeText(form.value.office_name) || defaultOfficeName.value || DEFAULT_OFFICE_NAME;

  return {
    office_id: Number(form.value.office_id || 0) || null,
    admin_dong_id: Number(form.value.admin_dong_id || 0) || null,
    office_name: officeName,
    admin_dong: toNullableText(normalizeAdminDong(form.value.admin_dong)),
    main_lot: toNullableText(form.value.main_lot),
    sub_lot: toNullableText(form.value.sub_lot),
    building_name: toNullableText(form.value.building_name),
    address: null,
    building_dong: toNullableText(normalizeBuildingDong(form.value.building_dong)),
    line: toNullableText(normalizeLineValue(form.value.line)),
    mdf: toNullableText(form.value.mdf),
    management_office: toNullableText(form.value.management_office),
    lock_device: toNullableText(form.value.lock_device),
    key_location: toNullableText(form.value.key_location),
    entrance_door: toNullableText(form.value.entrance_door),
    restroom: toNullableText(form.value.restroom),
    building_memo: toNullableText(form.value.building_memo),
    terminal_box: toNullableText(form.value.terminal_box),
    exclusive_provider: toNullableText(normalizeExclusiveProvider(form.value.exclusive_provider)),
    apply_floor: toNullableText(normalizeApplyFloorValue(form.value.apply_floor)),
    position: toNullableText(normalizePositionValue(form.value.position)),
    equipment_location: toNullableText(normalizeEquipmentLocationValue(form.value.equipment_location)),
    facility: toNullableText(form.value.facility),
    phone_facility: toNullableText(form.value.phone_facility),
    memo: toNullableText(form.value.memo),
  };
}

function getBuildingSignatureFromPayload(payload) {
  return [
    normalizeText(payload?.office_name).toLowerCase(),
    normalizeAdminDong(payload?.admin_dong).toLowerCase(),
    normalizeText(payload?.main_lot).toLowerCase(),
    normalizeText(payload?.sub_lot).toLowerCase(),
  ].join("|");
}

function getBuildingSignatureFromItem(item) {
  return [
    normalizeText(item?.office_name).toLowerCase(),
    normalizeAdminDong(item?.admin_dong).toLowerCase(),
    normalizeText(item?.main_lot).toLowerCase(),
    normalizeText(item?.sub_lot).toLowerCase(),
  ].join("|");
}

function extractConflictDetail(error) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") {
    return {
      message: detail,
      existingFacilityId: 0,
      existingBuildingId: 0,
    };
  }
  return {
    message: normalizeText(detail?.message) || "이미 값이 있습니다.",
    existingFacilityId: Number(detail?.existing_facility_id || 0),
    existingBuildingId: Number(detail?.existing_building_id || 0),
  };
}

function extractApiErrorMessage(error, fallbackMessage) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") {
    return normalizeText(detail) || fallbackMessage;
  }
  if (detail && typeof detail === "object") {
    return normalizeText(detail.message) || fallbackMessage;
  }
  return normalizeText(error?.message) || fallbackMessage;
}

async function openExistingBuildingFromConflict(payload, conflictDetail) {
  const targetOffice = normalizeText(payload?.office_name);
  const targetSignature = getBuildingSignatureFromPayload(payload);
  const conflictQuery = buildAddressFromLot(payload?.admin_dong, payload?.main_lot, payload?.sub_lot)
    || [
      normalizeAdminDong(payload?.admin_dong),
      normalizeText(payload?.main_lot),
      normalizeText(payload?.sub_lot),
    ].filter(Boolean).join(" ");
  if (targetOffice) {
    selectedOfficeFilter.value = targetOffice;
  }
  query.value = conflictQuery;
  await Promise.all([fetchItems(), fetchOfficeOptions()]);

  let matched = null;
  if (conflictDetail.existingFacilityId > 0) {
    matched = items.value.find((item) => Number(item?.id || 0) === conflictDetail.existingFacilityId) || null;
    if (!matched) {
      const res = await api.get(`${INET_COLLECTION_PATH}/${conflictDetail.existingFacilityId}`);
      matched = res?.data || null;
    }
  }

  if (!matched && conflictDetail.existingBuildingId > 0) {
    matched = items.value.find((item) => Number(item?.building_id || 0) === conflictDetail.existingBuildingId) || null;
  }

  if (!matched) {
    matched = items.value.find((item) => getBuildingSignatureFromItem(item) === targetSignature) || null;
  }

  if (!matched) {
    alert(conflictDetail.message);
    return;
  }

  selected.value = matched;
  modalMode.value = "";
  createSourceFacilityId.value = null;
  clearCommentsState();
  await scrollToFacilityCard(matched);
}

function getNewRegisterMissingLabels() {
  if (!(modalMode.value === "create" && createEntryType.value === "new")) return [];
  return NEW_REGISTER_REQUIRED_FIELDS
    .filter((field) => !normalizeText(form.value[field.key]))
    .map((field) => field.label);
}

function closeModal() {
  const currentSelected = selected.value;
  modalMode.value = "";
  createSourceFacilityId.value = null;
  facilityCreatePresetScope.value = "building";
  photoModalKind.value = "building";
  if (currentSelected) {
    nextTick(() => {
      scrollToFacilityCard(currentSelected);
    });
  }
}

function closePhotoPreview() {
  photoPreviewOpen.value = false;
  photoPreviewUrl.value = "";
  photoPreviewKind.value = "";
  photoPreviewPhoto.value = null;
  photoPreviewIsOriginal.value = false;
  photoDownloadLoading.value = false;
}

function closePhotoFlow() {
  closePhotoPreview();
  closeModal();
}

function makeBuildingPhotoDetailItem(item) {
  if (!item) return null;
  const buildingId = Number(item.building_id || 0);
  if (buildingId <= 0) return null;
  return {
    ...item,
    id: -Math.abs(buildingId),
    span_id: null,
    comment_target_id: null,
    entity_kind: "building",
    line: null,
    apply_floor: null,
    position: null,
    facility: null,
    memo: null,
    terminal_box: null,
  };
}

function hasBuildingPhotoInGroup(group) {
  const items = Array.isArray(group?.items) ? group.items : [];
  return items.some((item) => Boolean(item?.has_building_photo));
}

function getBuildingPhotoThumbUrl(group) {
  const representativeThumb = normalizeText(group?.representative?.building_photo_thumb_url);
  if (representativeThumb) return representativeThumb;
  const items = Array.isArray(group?.items) ? group.items : [];
  const matched = items.find((item) => normalizeText(item?.building_photo_thumb_url));
  return normalizeText(matched?.building_photo_thumb_url);
}

function hasDongPhotoInDongGroup(dongGroup) {
  const items = Array.isArray(dongGroup?.items) ? dongGroup.items : [];
  return items.some((item) => Boolean(item?.has_dong_photo));
}

function getDongPhotoThumbUrl(dongGroup) {
  const items = Array.isArray(dongGroup?.items) ? dongGroup.items : [];
  const matched = items.find((item) => normalizeText(item?.dong_photo_thumb_url));
  return normalizeText(matched?.dong_photo_thumb_url);
}

function getFacilityPhotoThumbUrl(subGroup) {
  const items = Array.isArray(subGroup?.items) ? subGroup.items : [];
  const matched = items.find((item) => normalizeText(item?.facility_photo_thumb_url));
  return normalizeText(matched?.facility_photo_thumb_url);
}

function hasFacilityPhotoInSubGroup(subGroup) {
  const items = Array.isArray(subGroup?.items) ? subGroup.items : [];
  return items.some((item) => Boolean(item?.has_facility_photo) || Boolean(normalizeText(item?.facility_photo_thumb_url)));
}

function duplicateCandidateScopeLabel(candidate) {
  return normalizeText(candidate?.scope_info?.scope_label) || photoLabel(candidate?.photo?.target_kind) || "사진";
}

function duplicateCandidateScopeSummary(candidate) {
  const scope = candidate?.scope_info || {};
  return [
    normalizeText(scope?.office_name),
    formatAdminDongForDisplay(scope?.admin_dong),
    formatLotFromParts(scope?.main_lot, scope?.sub_lot),
    normalizeText(scope?.building_name),
    formatBuildingDongForDisplay(scope?.building_dong),
    formatLineForDisplay(scope?.line),
    formatPositionForDisplay(scope?.position),
    normalizeText(scope?.facility),
  ].filter(Boolean).join(" / ");
}

function duplicateCandidateReason(candidate) {
  const parts = [];
  if (candidate?.hash_distance != null) {
    parts.push(`해시 유사도 ${candidate.hash_distance}`);
  }
  if (normalizeText(candidate?.photo?.captured_at_source)) {
    parts.push(`시간기준 ${normalizeText(candidate.photo.captured_at_source)}`);
  }
  if (Number(candidate?.photo?.size_bytes || 0) > 0) {
    parts.push(`용량 ${formatBytes(candidate.photo.size_bytes)}`);
  }
  return parts.join(" / ");
}

function formatBytes(value) {
  const bytes = Number(value || 0);
  if (bytes <= 0) return "-";
  if (bytes < 1024) return `${bytes}B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)}KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)}MB`;
}

async function openDetail(item, options = {}) {
  selected.value = item;
  selectedDetailFocus.value = ["building", "dong", "facility"].includes(options?.focus) ? options.focus : "facility";
  modalMode.value = "detail";
  commentsCollapsed.value = true;
  photosCollapsed.value = false;
  await Promise.all([
    fetchComments(item?.comment_target_id || item?.id),
    fetchPhotoGroup(buildingPhotoTargetId.value, "building"),
    fetchPhotoGroup(dongPhotoTargetId.value, "dong"),
    fetchPhotoGroup(facilityPhotoTargetId.value, "facility"),
  ]);
}

async function openPhotoModal(item, kind) {
  if (!item) return;
  const normalizedKind = kind === "facility" ? "facility" : (kind === "dong" ? "dong" : "building");
  selected.value = item;
  modalMode.value = "photo";
  photoModalKind.value = normalizedKind;
  commentsCollapsed.value = true;
  photosCollapsed.value = false;
  clearCommentsState();
  if (normalizedKind === "building") {
    dongPhotos.value = [];
    dongPhotosLoading.value = false;
    dongPhotosError.value = "";
    facilityPhotos.value = [];
    facilityPhotosLoading.value = false;
    facilityPhotosError.value = "";
    await fetchPhotoGroup(buildingPhotoTargetId.value, "building");
    return;
  }
  if (normalizedKind === "dong") {
    buildingPhotos.value = [];
    buildingPhotosLoading.value = false;
    buildingPhotosError.value = "";
    facilityPhotos.value = [];
    facilityPhotosLoading.value = false;
    facilityPhotosError.value = "";
    await fetchPhotoGroup(dongPhotoTargetId.value, "dong");
    return;
  }
  buildingPhotos.value = [];
  buildingPhotosLoading.value = false;
  buildingPhotosError.value = "";
  dongPhotos.value = [];
  dongPhotosLoading.value = false;
  dongPhotosError.value = "";
  await fetchPhotoGroup(facilityPhotoTargetId.value, "facility");
}

async function openBuildingPhotoDetail(item) {
  const detailItem = makeBuildingPhotoDetailItem(item);
  if (!detailItem) return;
  await openPhotoModal(detailItem, "building");
}

async function openFacilityPhotoDetail(item) {
  if (!item) return;
  await openPhotoModal(item, "facility");
}

async function openDongPhotoDetail(item) {
  if (!item) return;
  await openPhotoModal(item, "dong");
}

function openCreate(entryType = "new", sourceItem = null) {
  const resolvedType = resolveCreateEntryType(entryType);
  const sourceItemId = sourceItem?.id ? Number(sourceItem.id) : null;
  if (!requireManageAuth("create", sourceItemId, resolvedType)) return;
  const normalizedForm = normalizeFormFromItem(sourceItem);
  form.value = resolvedType === "facility"
    ? clearNonBuildingFieldsForFacilityCreate(normalizedForm)
    : normalizedForm;
  createSourceFacilityId.value = sourceItemId || null;
  createEntryType.value = resolvedType;
  facilityCreatePresetScope.value = "building";
  modalMode.value = "create";
}

function openFacilityCreate(sourceItem = null) {
  facilityCreatePresetScope.value = "building";
  openCreate("facility", sourceItem);
}

function openFacilityCreateForDong(sourceItem = null) {
  const sourceItemId = sourceItem?.id ? Number(sourceItem.id) : null;
  if (!requireManageAuth("create", sourceItemId, "facility")) return;
  form.value = buildFacilityCreateForm(sourceItem, { preserveDong: true, preserveLine: false });
  createSourceFacilityId.value = sourceItemId || null;
  createEntryType.value = "facility";
  facilityCreatePresetScope.value = "dong";
  modalMode.value = "create";
}

function openFacilityCreateForLine(sourceItem = null) {
  const sourceItemId = sourceItem?.id ? Number(sourceItem.id) : null;
  if (!requireManageAuth("create", sourceItemId, "facility")) return;
  form.value = buildFacilityCreateForm(sourceItem, { preserveDong: true, preserveLine: true });
  createSourceFacilityId.value = sourceItemId || null;
  createEntryType.value = "facility";
  facilityCreatePresetScope.value = "line";
  modalMode.value = "create";
}

function openEdit(entryType = "facility") {
  if (!selected.value) return;
  const resolvedType = resolveCreateEntryType(entryType);
  if (!requireManageAuth("edit", selected.value.id, resolvedType)) return;
  form.value = normalizeFormFromItem(selected.value);
  createEntryType.value = resolvedType;
  facilityCreatePresetScope.value = "building";
  modalMode.value = "edit";
}

function openBuildingEdit() {
  openEdit("new");
}

function openSupplementEdit() {
  openEdit("supplement");
}

function openFacilityEdit() {
  openEdit("facility");
}

async function saveItem() {
  const missingLabels = getNewRegisterMissingLabels();
  if (missingLabels.length) {
    alert(`${missingLabels.join(", ")} 항목은 필수입니다.`);
    return;
  }

  const payload = toFacilityPayload();

  try {
    const isEdit = modalMode.value === "edit" && selected.value;
    const isSupplementCreate = modalMode.value === "create" && createEntryType.value === "supplement";
    const supplementTargetId = isSupplementCreate ? Number(createSourceFacilityId.value || 0) : 0;

    if (isSupplementCreate && supplementTargetId <= 0) {
      alert("부가등록 대상 건물을 찾을 수 없습니다. 시설목록의 해당 건물 버튼에서 다시 시도해 주세요.");
      return;
    }

    const res = isEdit
      ? await api.put(
        `/inet/${selected.value.id}`,
        payload,
        createEntryType.value === "facility"
          ? undefined
          : { params: { scope: "building" } }
      )
      : (isSupplementCreate
        ? await api.put(
          `/inet/${supplementTargetId}`,
          payload,
          { params: { scope: "building" } }
        )
        : await api.post(INET_COLLECTION_PATH, payload));

    const saved = res.data;
    await Promise.all([fetchItems(), fetchOfficeOptions()]);
    let nextSelected = items.value.find((item) => Number(item.id) === Number(saved.id))
      || items.value.find((item) => Number(item?.building_id || 0) > 0 && Number(item?.building_id || 0) === Number(saved?.building_id || 0))
      || items.value.find((item) => getBuildingSignatureFromItem(item) === getBuildingSignatureFromPayload(payload))
      || null;

    if (!nextSelected && Number(saved?.id || 0) > 0) {
      try {
        const detailRes = await api.get(`${INET_COLLECTION_PATH}/${saved.id}`);
        nextSelected = detailRes?.data || null;
      } catch {
        nextSelected = null;
      }
    }

    selected.value = nextSelected || saved;
    modalMode.value = "detail";
    createSourceFacilityId.value = null;
    await Promise.all([
      fetchComments(selected.value?.comment_target_id || selected.value?.id),
      fetchPhotoGroup(buildingPhotoTargetId.value, "building"),
      fetchPhotoGroup(dongPhotoTargetId.value, "dong"),
      fetchPhotoGroup(facilityPhotoTargetId.value, "facility"),
    ]);
    showNotice(
      normalizeText(saved?._save_message) || "저장이 완료되었습니다.",
      normalizeText(saved?._save_status) === "no_change" ? "info" : "success"
    );
    await scrollToFacilityCard(selected.value);
    await refreshScoreboardIfOpen();
    playUiTone("success");
  } catch (error) {
    if (
      modalMode.value === "create" &&
      createEntryType.value === "new" &&
      Number(error?.response?.status || 0) === 409
    ) {
      const conflictDetail = extractConflictDetail(error);
      await openExistingBuildingFromConflict(payload, conflictDetail);
      playUiTone("error");
      return;
    }

    const errorMessage = extractApiErrorMessage(error, "저장에 실패했습니다.");
    showNotice(errorMessage, "error", 3200);
    playUiTone("error");
  }
}

async function removeBuildingInfo() {
  if (!selected.value) return;
  if (!canDeleteSelected.value) {
    alert("삭제 권한이 없습니다. 최초 등록자 또는 관리자만 삭제할 수 있습니다.");
    return;
  }
  if (!confirm("해당 건물의 시설 정보를 모두 삭제하시겠습니까?")) return;

  try {
    await api.delete(`/inet/${selected.value.id}`, { params: { scope: "building" } });
    selected.value = null;
    closeModal();
    clearCommentsState();
    clearPhotosState();
    await Promise.all([fetchItems(), fetchOfficeOptions()]);
    await refreshScoreboardIfOpen();
    playUiTone("success");
  } catch (error) {
    alert(extractApiErrorMessage(error, "건물 삭제에 실패했습니다."));
    playUiTone("error");
  }
}

async function removeItem() {
  if (!selected.value) return;
  if (!canDeleteSelected.value) {
    alert("삭제 권한이 없습니다. 최초 등록자 또는 관리자만 삭제할 수 있습니다.");
    return;
  }
  if (!confirm("정말 삭제하시겠습니까?")) return;

  try {
    await api.delete(`/inet/${selected.value.id}`);
    selected.value = null;
    closeModal();
    clearCommentsState();
    clearPhotosState();
    await Promise.all([fetchItems(), fetchOfficeOptions()]);
    await refreshScoreboardIfOpen();
    playUiTone("success");
  } catch (error) {
    alert(extractApiErrorMessage(error, "삭제에 실패했습니다."));
    playUiTone("error");
  }
}

async function refresh() {
  await Promise.all([fetchItems(), fetchOfficeOptions()]);
  if (selected.value?.id && isDetailModal.value) {
    await Promise.all([
      fetchComments(selected.value?.comment_target_id || selected.value?.id),
      fetchPhotoGroup(buildingPhotoTargetId.value, "building"),
      fetchPhotoGroup(dongPhotoTargetId.value, "dong"),
      fetchPhotoGroup(facilityPhotoTargetId.value, "facility"),
    ]);
  }
  await refreshScoreboardIfOpen();
}

async function clearQueryAndFetch() {
  query.value = "";
  await fetchItems();
}

function syncViewport() {
  viewportWidth.value = window.innerWidth || 0;
  isMobile.value = viewportWidth.value <= 820;
}


function onEscClose(event) {
  if (event.key === "Escape") {
    if (officeMenuOpen.value) {
      officeMenuOpen.value = false;
      return;
    }
    if (accountMenuOpen.value) {
      accountMenuOpen.value = false;
      return;
    }
    if (accountPanelOpen.value) {
      closeAccountPanel();
      return;
    }
    if (scoreModalOpen.value) {
      closeScoreboard();
      return;
    }
    if (isAnyModalOpen.value) closeModal();
  }
}

function onPointerDown(event) {
  const target = event?.target;
  if (!(target instanceof Node)) return;
  if (officeMenuOpen.value && officeFilterRef.value && !officeFilterRef.value.contains(target)) {
    officeMenuOpen.value = false;
  }
  if (accountMenuOpen.value && accountMenuRef.value && !accountMenuRef.value.contains(target)) {
    accountMenuOpen.value = false;
  }
}

function enableForcedLightMode() {
  if (typeof document === "undefined") return;
  document.documentElement.classList.add("inet-force-light");
  document.body.classList.add("inet-force-light");
}

function disableForcedLightMode() {
  if (typeof document === "undefined") return;
  document.documentElement.classList.remove("inet-force-light");
  document.body.classList.remove("inet-force-light");
}

watch(
  groupedItems,
  async () => {
    reconcileSelectedWithCurrentList();
    await nextTick();
    observeFacilityItems();
    scheduleFacilityLayout();
  },
  { flush: "post" }
);

watch(selectedOfficeFilter, async () => {
  await fetchItems();
  if (!scoreModalOpen.value) return;
  await fetchScoreboard();
});

watch(selectedAdminUser, (user) => {
  if (!user) return;
  adminAccountForm.value.login_change_remaining = Number(user.login_change_remaining || 0);
});

watch(
  () => allItems.value.length,
  () => {
    if (typeof window === "undefined") return;
    window.requestAnimationFrame(() => {
      maybeLoadMoreOnScroll();
      observeFacilityItems();
      scheduleFacilityLayout();
    });
  }
);

watch(
  isAnyModalOpen,
  (opened) => {
    if (typeof document !== "undefined") {
      document.body.style.overflow = opened ? "hidden" : "";
    }
  },
  { immediate: true }
);

onMounted(async () => {
  syncViewport();
  startAuthTimer();
  enableForcedLightMode();
  ensureFacilityResizeObserver();

  if (typeof window !== "undefined") {
    successAudio = new Audio("/inet-sounds/success.mp3");
    successAudio.preload = "auto";
    successAudio.volume = 0.9;

    failAudio = new Audio("/inet-sounds/fail.mp3");
    failAudio.preload = "auto";
    failAudio.volume = 0.9;
  }

  window.addEventListener("resize", syncViewport);
  window.addEventListener("storage", onAuthStorageChanged);
  window.addEventListener("keydown", onEscClose);
  window.addEventListener("pointerdown", onPointerDown);

  await Promise.all([fetchItems(), fetchOfficeOptions()]);
  observeFacilityItems();
  scheduleFacilityLayout();
  await runPostLoginAction();
  syncAuthStatus();
});

onUnmounted(() => {
  clearNotice();
  resetDuplicatePendingPreviews();
  window.removeEventListener("resize", syncViewport);
  window.removeEventListener("storage", onAuthStorageChanged);
  window.removeEventListener("keydown", onEscClose);
  window.removeEventListener("pointerdown", onPointerDown);
  stopAuthTimer();
  if (facilityLayoutFrame && typeof window !== "undefined") {
    window.cancelAnimationFrame(facilityLayoutFrame);
  }
  facilityResizeObserver?.disconnect();
  facilityResizeObserver = null;
  facilityItemElements.clear();

  if (typeof document !== "undefined") {
    document.body.style.overflow = "";
  }
  disableForcedLightMode();

  if (successAudio) {
    successAudio.pause();
    successAudio.src = "";
    successAudio = null;
  }
  if (failAudio) {
    failAudio.pause();
    failAudio.src = "";
    failAudio = null;
  }
});
</script>

<style scoped>
.inet-notice {
  position: sticky;
  top: 12px;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 auto 12px;
  padding: 12px 16px;
  border-radius: 14px;
  border: 1px solid var(--line);
  background: rgba(251, 253, 255, 0.98);
  color: var(--ink);
  box-shadow: 0 12px 28px rgba(17, 34, 48, 0.12);
  backdrop-filter: blur(8px);
}

.inet-notice-success {
  border-color: #8fc4b7;
  background: #eef9f5;
}

.inet-notice-info {
  border-color: #b9c9d7;
  background: #f5f9fc;
}

.inet-notice-error {
  border-color: #d8a7a1;
  background: #fff2f1;
}

.inet-notice-close {
  border: 0;
  background: transparent;
  color: var(--muted);
  font-weight: 700;
  cursor: pointer;
}

.notice-fade-enter-active,
.notice-fade-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.notice-fade-enter-from,
.notice-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

:global(html.inet-force-light),
:global(body.inet-force-light),
:global(body.inet-force-light #app) {
  color-scheme: light !important;
  background: #e7edf3 !important;
  --teal: #0e7b74;
  --teal-soft: #d6efe9;
  --blue-gray: #244f64;
  --bg: #e7edf3;
  --surface: #fbfdff;
  --surface-soft: #f2f7fb;
  --line: #b9c9d7;
  --ink: #152230;
  --muted: #4f6478;
  --danger: #b13a2f;
  --chip-building: #5f419c;
  --even-card-bg: #eef6fb;
  --odd-card-bg: #fafdff;
  --sub-card-bg: #f4f8fb;
  --sub-card-even-bg: #edf3f8;
}

.inet-page {
  --teal: #0e7b74;
  --teal-soft: #d6efe9;
  --blue-gray: #244f64;
  --bg: #e7edf3;
  --surface: #fbfdff;
  --surface-soft: #f2f7fb;
  --line: #b9c9d7;
  --ink: #152230;
  --muted: #4f6478;
  --danger: #b13a2f;
  --chip-building: #5f419c;
  --even-card-bg: #eef6fb;
  --odd-card-bg: #fafdff;
  --sub-card-bg: #f4f8fb;
  --sub-card-even-bg: #edf3f8;

  min-height: 100vh;
  padding: 18px;
  display: grid;
  align-content: start;
  grid-auto-rows: max-content;
  gap: 14px;
  background:
    radial-gradient(1200px 380px at 4% -8%, rgba(14, 123, 116, 0.18), rgba(14, 123, 116, 0)),
    radial-gradient(900px 300px at 100% 0%, rgba(95, 65, 156, 0.14), rgba(95, 65, 156, 0)),
    linear-gradient(180deg, #edf3f8 0%, var(--bg) 56%);
  color: var(--ink);
  color-scheme: light;
  font-family: "Pretendard", "Noto Sans KR", "Apple SD Gothic Neo", sans-serif;
}

.inet-page > header,
.inet-page > section {
  margin: 0;
}

.panel {
  background: linear-gradient(180deg, #ffffff 0%, var(--surface) 100%);
  border: 1px solid #c5d3de;
  border-radius: 22px;
  box-shadow: 0 10px 30px rgba(30, 55, 80, 0.08);
}

.hero-card {
  padding: 12px 16px;
}

.hero-top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 18px;
}

.hero-eyebrow {
  margin: 0;
  font-size: 0.95rem;
  letter-spacing: 0.04em;
  color: #224858;
  font-weight: 800;
  white-space: nowrap;
}

.hero-brand-block {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
}

.hero-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.hero-brand-mark {
  width: 28px;
  height: 28px;
  object-fit: contain;
  flex: 0 0 auto;
}

.hero-brand-name {
  font-size: 1.75rem;
  font-weight: 900;
  color: #1f2c27;
  line-height: 1;
}

.hero-brand-by {
  font-size: 0.9rem;
  font-weight: 700;
  color: #7a7a7a;
  line-height: 1;
}

.hero-control-row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.hero-office-row {
  flex: 0 1 auto;
  min-width: 0;
}

.score-open-btn {
  height: 42px;
  border: 1px solid #b8c8d4;
  background: #ffffff;
  color: #264558;
  border-radius: 999px;
  padding: 0 18px;
  font-size: 0.9rem;
  font-weight: 800;
  cursor: pointer;
  white-space: nowrap;
  flex: 0 0 auto;
}

.auth-pill {
  border: 1px solid rgba(15, 118, 110, 0.25);
  border-radius: 999px;
  min-height: 42px;
  padding: 6px 10px;
  background: #f6fbfa;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 230px;
  margin-left: 0;
  flex: 0 0 auto;
  position: relative;
}

.auth-pill.offline {
  border-color: rgba(141, 79, 0, 0.25);
  background: #fff8ef;
}

.auth-account-btn {
  flex: 1 1 auto;
  min-width: 0;
  border: 0;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: left;
  cursor: pointer;
}

.auth-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #e9f5f2;
  color: var(--teal);
  display: grid;
  place-items: center;
  font-weight: 800;
  font-size: 0.85rem;
  flex: 0 0 auto;
}

.auth-meta {
  min-width: 0;
  display: grid;
  gap: 1px;
}

.auth-meta strong,
.auth-meta span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.auth-meta strong {
  font-size: 0.78rem;
}

.auth-meta span {
  font-size: 0.72rem;
  color: var(--muted);
}

.auth-caret {
  flex: 0 0 auto;
  color: #5a7184;
  font-size: 0.78rem;
  font-weight: 900;
}

.account-menu {
  position: absolute;
  right: 8px;
  top: calc(100% + 8px);
  z-index: 20;
  min-width: 180px;
  padding: 8px;
  border-radius: 16px;
  border: 1px solid #c7d6e1;
  background: #ffffff;
  box-shadow: 0 18px 40px rgba(24, 42, 56, 0.18);
  display: grid;
  gap: 6px;
}

.account-menu-item {
  border: 1px solid #d7e3ec;
  background: #f9fcff;
  color: #28465a;
  border-radius: 12px;
  min-height: 38px;
  padding: 0 12px;
  text-align: left;
  font-size: 0.82rem;
  font-weight: 800;
  cursor: pointer;
}

.account-menu-item:hover {
  background: #edf6fb;
}

.btn {
  border: 0;
  border-radius: 999px;
  height: 42px;
  padding: 0 15px;
  font-weight: 700;
  font-size: 0.86rem;
  cursor: pointer;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.btn:disabled {
  opacity: 0.58;
  cursor: not-allowed;
}

.btn-primary {
  background: linear-gradient(180deg, #11867f 0%, var(--teal) 100%);
  color: #fff;
  box-shadow: 0 4px 10px rgba(14, 123, 116, 0.24);
}

.btn-secondary {
  background: #e6f5f2;
  color: #27495d;
}

.btn-ghost {
  border: 1px solid var(--line);
  background: #fff;
  color: var(--muted);
}

.btn-danger {
  border: 1px solid rgba(195, 57, 42, 0.25);
  background: rgba(195, 57, 42, 0.12);
  color: var(--danger);
}

.btn-mini {
  height: 42px;
  padding: 0 14px;
  font-size: 0.82rem;
}

.search-card {
  padding: 14px;
  display: grid;
  gap: 11px;
}

.office-filter-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.office-filter-wrap {
  position: relative;
  flex: 0 1 auto;
  min-width: 0;
}

.office-filter-btn {
  width: auto;
  min-width: 180px;
  max-width: 240px;
  height: 42px;
  border: 1px solid #b6c5d1;
  border-radius: 999px;
  background: #f8fbfd;
  color: #1a3342;
  font-size: 1.02rem;
  font-weight: 800;
  cursor: pointer;
  display: grid;
  place-items: center;
  text-align: center;
  padding: 0 12px;
}

.office-filter-btn span {
  display: inline-flex;
  text-align: center;
}

.office-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 20;
  border: 1px solid #b8c8d4;
  border-radius: 14px;
  background: var(--surface);
  overflow: hidden;
  box-shadow: 0 12px 24px rgba(10, 20, 30, 0.22);
}

.office-option {
  width: 100%;
  border: 0;
  background: transparent;
  color: var(--ink);
  font-size: 1.04rem;
  font-weight: 700;
  text-align: center;
  padding: 15px 12px;
  cursor: pointer;
}

.office-option:hover {
  background: rgba(15, 118, 110, 0.08);
}

.default-office-option {
  color: #d92d20;
  font-weight: 800;
}

.office-filter-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.office-filter-label strong {
  color: #d92d20;
}

.search-line {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
}

.search-line input {
  border: 1px solid #c5d2dd;
  border-radius: 12px;
  padding: 0 12px;
  height: 42px;
  font-size: 0.86rem;
  min-width: 0;
}

.search-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.error-text {
  margin: 0;
  color: var(--danger);
  font-size: 0.78rem;
}

.list-card {
  padding: 16px;
  display: grid;
  gap: 10px;
  background: linear-gradient(180deg, var(--surface) 0%, var(--surface-soft) 100%);
}

.list-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.list-head h2 {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 800;
  text-align: left;
}

.btn-edge {
  border: 1.4px solid rgba(15, 118, 110, 0.78);
  background: #ffffff;
  color: var(--teal);
  border-radius: 12px;
  height: 40px;
  padding: 0 14px;
  font-size: 0.86rem;
  font-weight: 800;
  box-shadow: 0 2px 0 rgba(15, 118, 110, 0.16);
}

.facility-list {
  display: grid;
  grid-template-columns: 1fr;
  max-height: calc(100vh - 330px);
  overflow: auto;
}

.list-more-status {
  padding: 6px 4px 2px;
  color: #567287;
  font-size: 0.84rem;
  font-weight: 700;
  text-align: center;
}

.facility-item {
  border: 1px solid #c2d1dc;
  border-radius: 14px;
  padding: 11px;
  background: var(--odd-card-bg);
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 8px;
  color: var(--ink);
}

.facility-item:not(.even-row):not(.active) {
  border-color: #c2d1dc;
}

.facility-item.even-row:not(.active) {
  border-color: #6f95ad;
  background: var(--even-card-bg);
  box-shadow: inset 0 0 0 1px rgba(36, 79, 100, 0.12);
}

.facility-main {
  border: 0;
  background: transparent;
  margin: 0;
  padding: 0;
  width: 100%;
  text-align: left;
  display: grid;
  gap: 6px;
  color: inherit;
  cursor: pointer;
}

.facility-main-group {
  display: grid;
  gap: 8px;
}

.facility-sub-list {
  display: grid;
  gap: 6px;
}

.facility-dong-group {
  border: 1px solid #b9ccd9;
  border-radius: 13px;
  background: #f1f8fc;
  padding: 9px 10px;
  display: grid;
  gap: 7px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.5);
}

.facility-item.even-row .facility-dong-group:not(.active) {
  background: #e8f2f8;
}

.facility-dong-group.active {
  border-color: #2f8f89;
  background: #e1f1ed;
}

.facility-dong-head {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.facility-sub-head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.facility-dong-main {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  min-height: 30px;
  padding: 0 11px;
  border-radius: 9px;
  background: #d7e7f1;
  font-size: 0.84rem;
  font-weight: 800;
  color: #244c63;
  letter-spacing: -0.01em;
}

.facility-dong-group.active .facility-dong-main {
  background: #2a8a84;
  color: #ffffff;
}

.facility-sub-group {
  border: 1px solid #9fb9cb;
  border-radius: 11px;
  background: #eef7fc;
  padding: 7px 8px;
  display: grid;
  gap: 5px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.45);
}

.facility-item.even-row .facility-sub-group:not(.active) {
  background: #e2eef7;
}

.facility-sub-group.active {
  border-color: #2f8f89;
  background: #d8eee8;
}

.facility-sub-item {
  border: 1px solid #cad8e2;
  border-radius: 10px;
  background: var(--sub-card-bg);
  color: #36546a;
  margin-left: 12px;
  padding: 7px 9px;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 50px;
}

.facility-sub-item-content {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 auto;
  min-width: 0;
}

.photo-presence-btn-inline.facility-row-photo-view {
  margin-left: 0;
}

.photo-presence-btn-inline.facility-header-photo-view,
.photo-presence-btn-inline.title-photo-view {
  margin-left: 6px;
}

.facility-header-photo-view {
  margin-right: 2px;
}

.facility-item.even-row .facility-sub-item:not(.active) {
  background: var(--sub-card-even-bg);
}

.facility-sub-item.active {
  border-color: #2c958d;
  background: #d9f1ec;
}

.facility-sub-item-main {
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 3px;
  align-content: center;
  flex: 0 1 auto;
  min-width: 0;
  cursor: pointer;
}

.facility-sub-main {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  margin-left: 12px;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 8px;
  background: #d7eaf4;
  font-size: 0.82rem;
  font-weight: 800;
  color: #244c63;
  letter-spacing: -0.01em;
}

.facility-sub-group.active .facility-sub-main {
  background: #2a8a84;
  color: #ffffff;
}

.facility-sub-meta {
  display: inline-flex;
  gap: 6px;
  flex-wrap: wrap;
  padding-left: 8px;
  min-height: 1.1rem;
  align-items: center;
  font-size: 0.79rem;
  color: #586f81;
  font-weight: 700;
}

.photo-presence-btn {
  border: 1px solid #a8bbca;
  background: linear-gradient(180deg, #ffffff 0%, #eaf2f7 100%);
  color: #355266;
  border-radius: 10px;
  min-width: 34px;
  height: 34px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 2px 0 rgba(168, 187, 202, 0.95);
}

.photo-presence-btn-inline {
  margin-left: auto;
  min-width: 30px;
  height: 30px;
  padding: 0 6px;
  border-radius: 9px;
  font-size: 0.92rem;
  flex: 0 0 auto;
}

.building-photo-thumb-btn {
  margin-left: auto;
  width: 34px;
  height: 34px;
  padding: 2px;
  border-radius: 999px;
  border: 1px solid #b7c8d5;
  background: linear-gradient(180deg, #ffffff 0%, #edf4f8 100%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 0 rgba(168, 187, 202, 0.72);
}

.building-photo-thumb-frame {
  position: relative;
  width: 100%;
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.building-photo-thumb-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  border-radius: 999px;
}

.facility-item.active {
  border-color: #2f8f89;
  background: #d8eeea;
  box-shadow: inset 0 0 0 1px rgba(14, 123, 116, 0.22);
}

.facility-item-actions {
  display: grid;
  gap: 6px;
  justify-items: end;
}

.mini-register-btn {
  border: 1px solid #c9d4de;
  background: linear-gradient(180deg, #ffffff 0%, #eef4f8 100%);
  color: #3e576a;
  border-radius: 11px;
  height: 34px;
  padding: 0 12px;
  font-size: 0.72rem;
  font-weight: 800;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 2px 0 rgba(165, 184, 198, 0.88), 0 6px 14px rgba(120, 144, 160, 0.14);
  transition: transform 120ms ease, box-shadow 120ms ease;
}

.mini-register-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 0 rgba(165, 184, 198, 0.92), 0 8px 16px rgba(120, 144, 160, 0.18);
}

.mini-register-btn:active {
  transform: translateY(1px);
  box-shadow: 0 1px 0 rgba(165, 184, 198, 0.88), 0 3px 8px rgba(120, 144, 160, 0.12);
}

.mini-register-btn.edit {
  border-color: #7cab95;
  background: linear-gradient(180deg, #fbfffc 0%, #e3f5e9 100%);
  color: #1f6a48;
  box-shadow: 0 2px 0 rgba(124, 171, 149, 0.94), 0 7px 14px rgba(88, 145, 114, 0.16);
}

.facility-inline-actions {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 86px;
  justify-content: flex-end;
  margin-right: 18px;
}

.mini-photo-upload-label {
  min-width: 42px;
  height: 42px;
  padding: 0 10px;
  border-radius: 12px;
  border: 1px solid #7f9db4;
  background: linear-gradient(180deg, #ffffff 0%, #edf4f8 100%);
  color: #244d67;
  box-shadow: 0 2px 0 rgba(127, 157, 180, 0.9), 0 7px 14px rgba(98, 130, 155, 0.16);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  user-select: none;
}

.mini-photo-upload-label-inline {
  min-width: 38px;
  height: 38px;
  border-radius: 10px;
}

.facility-sub-item-actions {
  margin-left: auto;
  margin-right: -6px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 86px;
}

.facility-sub-head .facility-inline-actions {
  margin-right: -6px;
}

.mini-photo-upload-label input {
  display: none;
}

.mini-register-icon-btn {
  appearance: none;
  -webkit-appearance: none;
  font-size: 18px;
  line-height: 1;
  color: inherit;
}

.mini-photo-upload-label:hover {
  transform: translateY(-1px);
}

.mini-register-btn.danger {
  border-color: #da9991;
  color: #b3473b;
  background: linear-gradient(180deg, #fffaf9 0%, #fde8e4 100%);
  box-shadow: 0 2px 0 rgba(218, 153, 145, 0.9), 0 7px 14px rgba(199, 98, 84, 0.12);
}

.facility-top-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px;
}

.chip {
  border-radius: 11px;
  padding: 6px 12px;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1;
}

.chip-admin {
  background: #1b7f6c;
  color: #fff;
}

.chip-building {
  background: var(--chip-building);
  color: #fff;
}

.recent-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
  padding: 1px 6px;
  border-radius: 999px;
  background: #d92d20;
  color: #fff;
  font-size: 0.58em;
  font-style: italic;
  font-weight: 900;
  line-height: 1.1;
  letter-spacing: 0.04em;
  vertical-align: middle;
}

.standalone-recent-badge {
  margin-left: 0;
}

.plain-text {
  font-size: 1.02rem;
  color: #637180;
  font-weight: 600;
}

.supplement-flag {
  width: 28px;
  height: 28px;
  border-radius: 9px;
  border: 1px solid #c7d4de;
  background: linear-gradient(180deg, #ffffff 0%, #eef5fa 100%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  font-size: 14px;
  line-height: 1;
}

.supplement-logo-flag {
  padding: 0;
}

.supplement-logo-image {
  width: 18px;
  height: 18px;
  object-fit: contain;
  display: block;
}

.dong-text {
  font-size: 0.94rem;
  color: #788694;
}

.facility-summary {
  margin: 0;
  font-size: 1.01rem;
  color: #5b6e7f;
  font-weight: 600;
}

.facility-summary-memo {
  margin-left: 6px;
  color: #7b8794;
  font-size: 0.93rem;
  font-weight: 500;
}

.facility-sub-meta-muted {
  color: #6e8698;
}

.empty {
  padding: 18px 0;
  text-align: center;
  color: var(--muted);
}

.modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 500;
  background: rgba(11, 18, 24, 0.52);
  backdrop-filter: blur(4px);
  display: grid;
  place-items: center;
  padding: 16px;
}

.modal-shell {
  width: min(980px, 100%);
  max-height: calc(100vh - 32px);
  overflow: auto;
  box-sizing: border-box;
  border-radius: 24px;
  border: 1px solid #c4d3de;
  background: linear-gradient(180deg, #fbfdff 0%, #f2f7fb 100%);
  box-shadow: 0 24px 54px rgba(23, 39, 55, 0.28);
  padding: 16px;
  display: grid;
  gap: 10px;
}

.score-shell {
  width: min(1160px, 100%);
}

.account-shell {
  width: min(760px, 100%);
  display: grid;
  grid-template-rows: auto auto minmax(0, 1fr);
  overflow: hidden;
}

.account-header {
  border-radius: 20px;
  padding: 12px 14px;
  background: #fcfeff;
  border: 1px solid #c7d6e1;
}

.account-title-wrap h3 {
  margin: 0;
}

.account-subtitle {
  margin: 4px 0 0;
  color: var(--muted);
  font-size: 0.84rem;
  font-weight: 700;
}

.account-tab-row {
  display: flex;
  gap: 8px;
}

.account-tab-btn {
  border: 1px solid #c7d6e1;
  background: #f4f8fb;
  color: #3d566a;
  border-radius: 999px;
  min-height: 38px;
  padding: 0 16px;
  font-size: 0.82rem;
  font-weight: 800;
  cursor: pointer;
}

.account-tab-btn.active {
  background: linear-gradient(180deg, #11867f 0%, var(--teal) 100%);
  color: #fff;
  border-color: #0f726c;
}

.account-content-scroll {
  padding-right: 4px;
}

.account-card {
  border: 1px solid #c7d6e1;
  border-radius: 16px;
  background: #fcfeff;
  padding: 14px;
  display: grid;
  gap: 12px;
}

.account-card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.account-card-head h4 {
  margin: 0;
  font-size: 0.95rem;
}

.account-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.account-info-grid > div,
.account-form-grid {
  display: grid;
  gap: 8px;
}

.account-info-grid strong {
  color: #4f6478;
  font-size: 0.76rem;
}

.account-info-grid span {
  color: #1f3342;
  font-weight: 800;
}

.account-form-grid input,
.account-form-grid select {
  width: 100%;
  min-height: 42px;
  border: 1px solid #c9d7e2;
  border-radius: 12px;
  background: #fff;
  padding: 0 12px;
  box-sizing: border-box;
  font-size: 0.86rem;
  color: #203544;
}

.account-card-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.option-list-actions > .btn {
  flex: 1 1 160px;
}

.admin-list-grid {
  display: grid;
  gap: 10px;
}

.admin-list-item {
  border: 1px solid #d5e0e8;
  border-radius: 14px;
  background: #f9fcfe;
  padding: 12px;
  display: grid;
  gap: 10px;
}

.admin-list-main {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.admin-list-main strong {
  color: #213545;
  font-size: 0.95rem;
}

.admin-list-main span {
  color: #60778a;
  font-size: 0.82rem;
  font-weight: 700;
}

.score-header h3 {
  margin: 2px 0 0;
}

.score-content {
  display: grid;
  gap: 8px;
}

.score-result {
  display: grid;
  gap: 10px;
}

.score-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 10px;
}

.score-card {
  border: 1px solid #d7e1ea;
  border-radius: 16px;
  background: #fff;
  padding: 10px;
  display: grid;
  gap: 8px;
}

.score-card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.score-card-head h4 {
  margin: 0;
  font-size: 0.92rem;
}

.score-card-head span {
  font-size: 0.78rem;
  color: #5d7080;
  font-weight: 700;
}

.score-pie-wrap {
  display: grid;
  gap: 10px;
}

.score-pie {
  width: 188px;
  height: 188px;
  border-radius: 50%;
  margin: 2px auto 0;
  position: relative;
  border: 1px solid #d5e1ec;
}

.score-pie::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 96px;
  height: 96px;
  margin-left: -48px;
  margin-top: -48px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #e1e9f1;
}

.score-legend {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 6px;
}

.score-legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  font-size: 0.82rem;
}

.score-rank {
  min-width: 52px;
  font-weight: 900;
  font-size: 0.78rem;
  letter-spacing: -0.01em;
}

.score-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex: 0 0 auto;
}

.score-name {
  min-width: 0;
  flex: 1;
  color: #1f3342;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.score-percent {
  color: #4f6578;
  font-weight: 700;
}

.score-count {
  color: #607282;
  font-weight: 700;
}

.my-score-wrap {
  padding: 12px;
  gap: 10px;
}

.my-score-title {
  margin: 0;
  font-size: 1rem;
  color: #1f3342;
}

.my-score-lines {
  display: grid;
  gap: 8px;
}

.my-score-lines p {
  margin: 0;
  border: 1px solid #e3ebf2;
  border-radius: 12px;
  background: #fbfdff;
  padding: 9px 11px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  color: #445a6d;
  font-size: 0.9rem;
}

.my-score-lines strong {
  color: #1f3342;
  font-weight: 900;
}

.my-score-lines span {
  color: #1f6f63;
  font-weight: 800;
}

.detail-shell {
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  overflow: hidden;
}

.detail-content-scroll {
  min-height: 0;
  overflow: auto;
  display: grid;
  gap: 10px;
  padding-right: 2px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.detail-header {
  border-radius: 20px;
  padding: 10px 12px;
  background: #fcfeff;
  border: 1px solid #c7d6e1;
}

.detail-title-row {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.chip-detail-building {
  background: var(--chip-building);
  color: #fff;
  max-width: min(72vw, 600px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detail-dong {
  font-size: 1.02rem;
  color: var(--muted);
  font-weight: 700;
}

.detail-empty {
  font-size: 1.02rem;
  color: var(--ink);
  font-weight: 700;
}

.detail-title-actions {
  display: inline-flex;
  gap: 10px;
  margin-left: 10px;
}

.detail-mini-btn {
  height: 31px;
  padding: 0 10px;
  font-size: 0.73rem;
  border-radius: 12px;
}

.modal-kicker {
  margin: 0;
  font-size: 0.72rem;
  color: var(--blue-gray);
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.modal-header h3 {
  margin: 2px 0 4px;
  font-size: clamp(1rem, 2vw, 1.3rem);
}

.editor-linked-title-row {
  margin-top: 2px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.editor-linked-mode {
  color: #4b5f71;
  background: transparent;
  font-size: 0.95rem;
  font-weight: 800;
  line-height: 1;
}

.close-btn {
  height: 34px;
  border: 1px solid var(--line);
  background: #fff;
  color: var(--muted);
  border-radius: 999px;
  padding: 0 12px;
  font-size: 0.76rem;
  font-weight: 700;
  cursor: pointer;
}

.detail-table-wrap,
.photo-box,
.comment-box {
  border: 1px solid #c7d6e1;
  border-radius: 16px;
  background: #fcfeff;
  overflow: hidden;
}

.detail-info-grid {
  display: grid;
  gap: 10px;
}

.detail-section-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid #e4edf3;
  background: #f8fbfe;
}

.detail-section-title {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.detail-section-title-inline {
  gap: 6px;
}

.detail-section-title-stack {
  display: grid;
  gap: 4px;
  align-items: start;
}

.detail-section-subtitle-block {
  padding-left: 1px;
}

.detail-section-head h4 {
  margin: 0;
  font-size: 0.95rem;
  color: #29495d;
}

.detail-section-subtitle {
  font-size: 0.76rem;
  color: #748698;
  font-weight: 600;
  white-space: nowrap;
}

.detail-section-actions {
  display: inline-flex;
  gap: 10px;
  align-items: center;
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
}

.detail-table tr:nth-child(odd) {
  background: #f8fbfc;
}

.detail-table th,
.detail-table td {
  border-bottom: 1px solid #e7edf2;
  padding: 10px 12px;
  text-align: left;
  font-size: 0.83rem;
  vertical-align: top;
}

.detail-table th {
  width: 110px;
  color: var(--muted);
  font-weight: 800;
}

.detail-table td {
  white-space: pre-wrap;
}

.detail-empty-cell {
  color: var(--muted);
  text-align: center;
  font-weight: 600;
}

.photo-box,
.comment-box {
  padding: 10px;
  display: grid;
  gap: 8px;
}

.photo-action-btn,
.photo-upload-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: auto;
  height: 31px;
  padding: 0 10px;
  border: 1px solid #7f9db4;
  border-radius: 10px;
  background: linear-gradient(180deg, #f9fcff 0%, #dfeefa 100%);
  color: #234c67;
  font-size: 0.74rem;
  font-weight: 800;
  cursor: pointer;
  overflow: hidden;
}

.photo-action-btn input,
.photo-upload-btn input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.photo-stack {
  display: grid;
  gap: 10px;
}

.photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(88px, 1fr));
  gap: 6px;
}

.photo-card {
  border: 1px solid #e3eaf0;
  border-radius: 12px;
  background: #fbfdff;
  padding: 5px;
  display: grid;
  gap: 4px;
}

.photo-thumb-btn {
  position: relative;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
}

.photo-kind-label {
  position: absolute;
  left: 6px;
  top: 6px;
  z-index: 1;
  padding: 1px 5px;
  border-radius: 6px;
  background: rgba(238, 242, 246, 0.92);
  color: #7d8b97;
  font-size: 0.52rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  pointer-events: none;
}

.photo-thumb {
  width: 100%;
  aspect-ratio: 0.92 / 1;
  display: block;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #dde7ef;
  background: #eef4f8;
}

.photo-meta {
  display: grid;
  gap: 2px;
}

.photo-card-actions {
  display: flex;
  gap: 6px;
  flex-wrap: nowrap;
  align-items: center;
}

.photo-inline-btn {
  border: 1px solid #bfcddd;
  background: linear-gradient(180deg, #ffffff 0%, #edf4f8 100%);
  color: #355266;
  border-radius: 10px;
  height: 26px;
  padding: 0 8px;
  font-size: 0.62rem;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
}

.photo-inline-btn-danger {
  border-color: #da9991;
  color: #b3473b;
  background: linear-gradient(180deg, #fffaf9 0%, #fde8e4 100%);
}

.photo-meta strong {
  font-size: 0.68rem;
  color: #223d50;
}

.photo-meta span {
  font-size: 0.63rem;
  color: #6f8394;
}

.photo-reuse-label {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 2px 7px;
  border-radius: 999px;
  background: #edf4f8;
  color: #4f6c7e;
  font-size: 0.58rem;
  font-weight: 800;
  line-height: 1.2;
}

.photo-reuse-label-reused {
  background: #fff1df;
  color: #8a5a1f;
}

.comment-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.comment-head h4 {
  margin: 0;
  font-size: 0.95rem;
}

.text-toggle {
  border: 0;
  background: transparent;
  color: #2e5f73;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
}

.comment-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 8px;
}

.comment-item {
  border: 1px solid #e3eaf0;
  border-radius: 12px;
  padding: 8px 9px;
  background: #fbfdff;
  display: grid;
  gap: 5px;
}

.comment-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.comment-meta strong {
  font-size: 0.78rem;
}

.comment-meta span {
  font-size: 0.72rem;
  color: var(--muted);
}

.comment-text {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.42;
  white-space: pre-wrap;
}

.comment-text.auto {
  font-size: 0.72rem;
  line-height: 1.35;
  color: #687b8b;
  font-weight: 600;
}

.auto-comment-prefix,
.auto-comment-suffix,
.auto-comment-sep {
  color: #6d7f8f;
}

.auto-comment-field {
  font-weight: 800;
}

.auto-comment-field-0 {
  color: #0f766e;
}

.auto-comment-field-1 {
  color: #9a5a18;
}

.auto-comment-field-2 {
  color: #325ea8;
}

.auto-comment-field-3 {
  color: #8a3f73;
}

.comment-editor {
  display: grid;
  gap: 6px;
}

.comment-editor textarea {
  width: 100%;
  min-height: 72px;
  resize: vertical;
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 8px 10px;
  font-size: 0.82rem;
}

.modal-actions {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
}

.detail-shell .modal-actions {
  position: sticky;
  bottom: 0;
  padding-top: 8px;
  background: linear-gradient(180deg, rgba(249, 251, 252, 0), rgba(249, 251, 252, 1) 24%);
}

.photo-only-shell {
  width: min(760px, 100%);
}

.photo-only-header {
  align-items: center;
}

.photo-preview-backdrop {
  background: rgba(18, 28, 39, 0.72);
}

.photo-preview-shell {
  width: min(92vw, 980px);
  background: #101820;
  border-color: rgba(216, 229, 240, 0.22);
}

.photo-preview-header {
  padding-bottom: 0;
  border-bottom: 0;
  background: transparent;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
}

.photo-preview-head-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
}

.photo-preview-title-row {
  min-width: 0;
  flex-wrap: nowrap;
  overflow: hidden;
}

.photo-preview-stage {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: min(72vh, 820px);
  padding: 10px 10px 18px;
}

.photo-preview-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  padding: 0 10px 10px;
}

.photo-preview-stage-frame {
  position: relative;
  display: inline-block;
  max-width: 100%;
}

.photo-preview-stage-image {
  max-width: 100%;
  max-height: 72vh;
  width: auto;
  height: auto;
  display: block;
  border-radius: 14px;
  background: #0b1218;
}

.photo-preview-kind-label {
  left: 10px;
  top: 10px;
  z-index: 2;
  padding: 3px 8px;
  border-radius: 999px;
  background: rgba(245, 247, 250, 0.9);
  color: #6e7b87;
  font-size: 0.72rem;
  font-weight: 800;
}

.photo-only-title-row {
  display: flex;
  align-items: center;
  min-width: 0;
}

.photo-only-title-row h3 {
  margin: 0;
  font-size: clamp(1.05rem, 2.2vw, 1.35rem);
  color: #1f3447;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.photo-only-content {
  padding-top: 2px;
}

.photo-only-box {
  min-height: 260px;
  padding: 14px;
  background: #f8fbfe;
}

.photo-grid-photo-only {
  grid-template-columns: repeat(2, minmax(0, 160px));
  gap: 12px;
  align-items: start;
  justify-content: start;
}

.photo-grid-photo-only-single {
  grid-template-columns: minmax(0, 160px);
}

.photo-preview-card {
  padding: 6px;
}

.photo-preview-card .photo-kind-label {
  left: 6px;
  top: 6px;
  padding: 1px 6px;
  border-radius: 999px;
  background: rgba(245, 247, 250, 0.92);
  color: #7b8894;
  font-size: 0.5rem;
  font-weight: 800;
}

@media (max-width: 768px) {
  .photo-grid-photo-only {
    grid-template-columns: repeat(2, minmax(0, 132px));
    gap: 10px;
  }

  .photo-grid-photo-only-single {
    grid-template-columns: minmax(0, 132px);
  }

  .photo-only-box {
    padding: 10px;
  }
}

.editor-shell {
  width: min(900px, 100%);
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  overflow: hidden;
  min-height: 0;
  gap: 8px;
}

.editor-shell .modal-header {
  padding: 2px 2px 0;
}

.editor-shell .modal-kicker {
  font-size: 0.95rem;
  color: #4b5f71;
  letter-spacing: 0;
  text-transform: none;
}

.editor-shell .modal-header h3 {
  margin: 1px 0 2px;
  font-size: clamp(0.96rem, 1.8vw, 1.2rem);
}

.modal-actions.sticky {
  position: sticky;
  bottom: 0;
  padding-top: 8px;
  background: linear-gradient(180deg, rgba(249, 251, 252, 0), rgba(249, 251, 252, 1) 24%);
}

.duplicate-shell {
  max-width: 640px;
}

.duplicate-content {
  display: grid;
  gap: 12px;
}

.duplicate-candidate-card {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 12px;
  padding: 12px;
  border-radius: 14px;
  border: 1px solid #c7d6e1;
  background: #f9fcff;
}

.duplicate-compare-card-new {
  border-style: dashed;
  background: #f1fbf7;
}

.duplicate-candidate-thumb-wrap {
  width: 110px;
  height: 110px;
  border-radius: 12px;
  overflow: hidden;
  background: #e7eff6;
}

.duplicate-candidate-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.duplicate-candidate-meta {
  display: grid;
  gap: 4px;
}

.duplicate-candidate-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 4px;
}

.editor-shell .modal-actions.sticky {
  position: static;
  bottom: auto;
  padding-top: 10px;
  background: #f4f8fb;
  border-top: 1px solid #c8d7e2;
}

.editor-grid {
  border: 1px solid #c8d7e2;
  border-radius: 16px;
  background: #f8fbfe;
  padding: 8px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  min-height: 0;
  overflow: auto;
}

.group-card {
  border: 1px solid #cad9e3;
  border-radius: 13px;
  background: #fdfefe;
  padding: 8px;
  display: grid;
  gap: 8px;
}

.group-card.full {
  grid-column: 1 / -1;
}

.group-card-required {
  background: #ffffff;
}

.group-card-subtle {
  background: #edf4f9;
  border-color: #c4d4e2;
}

.group-card-subtle .field {
  background: #eaf2f8;
  border-color: #c3d3e2;
}

.group-card-subtle .field input,
.group-card-subtle .field textarea {
  background: #f6fbfe;
  border-color: #bccdde;
}

.group-card-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.field {
  display: grid;
  gap: 3px;
  border: 1px solid #cad9e3;
  border-radius: 12px;
  padding: 7px 9px;
  background: #f9fcff;
}

.field.full {
  grid-column: 1 / -1;
}

.field span {
  font-size: 0.72rem;
  color: var(--muted);
  font-weight: 700;
}

.label-title {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.req {
  color: #c3392a;
  font-style: normal;
  font-weight: 900;
}

.field input,
.field textarea {
  border: 1px solid var(--line);
  border-radius: 11px;
  padding: 8px 9px;
  font-size: 0.8rem;
}

.field-hint {
  font-size: 0.66rem;
  color: var(--muted);
}

.office-line {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
}

.text-danger {
  justify-self: flex-end;
  border: 0;
  background: transparent;
  color: var(--danger);
  font-size: 0.75rem;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
}

.muted {
  margin: 0;
  color: var(--muted);
  font-size: 0.78rem;
}

@media (max-width: 920px) {
  .inet-page {
    padding: 12px;
  }

  .auth-pill {
    width: auto;
    min-width: 0;
    max-width: 100%;
    border-radius: 999px;
  }

  .default-office-pill {
    padding: 8px 15px;
  }

  .search-line {
    grid-template-columns: minmax(0, 1fr) auto;
  }

  .facility-list {
    max-height: none;
  }

  .facility-item {
    grid-template-columns: 1fr;
  }

  .modal-shell {
    width: min(760px, 100%);
    padding: 12px;
  }

  .score-grid {
    grid-template-columns: 1fr;
  }

  .score-pie {
    width: 168px;
    height: 168px;
  }

  .modal-actions {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .editor-shell .modal-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .group-card-grid {
    grid-template-columns: 1fr;
  }

  .office-line {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .hero-card,
  .search-card,
  .list-card {
    border-radius: 16px;
  }

  .hero-top {
    gap: 8px;
    flex-direction: column;
    align-items: flex-start;
  }

  .hero-control-row {
    gap: 8px;
    width: 100%;
  }

  .hero-brand-block {
    display: none;
  }

  .hero-office-row {
    gap: 8px;
  }

  .office-filter-wrap {
    min-width: 0;
  }

  .score-open-btn {
    width: 96px;
    margin-left: 0;
    padding: 0 12px;
    font-size: 0.86rem;
  }

  .auth-pill {
    min-width: 0;
    flex: 1 1 0;
    padding: 5px 8px;
    gap: 6px;
    border-radius: 999px;
  }

  .auth-avatar {
    display: none;
  }

  .auth-meta {
    flex: 1 1 auto;
    min-width: 0;
  }

  .auth-meta strong {
    font-size: 0.8rem;
  }

  .auth-meta span {
    display: none;
  }

  .office-filter-row {
    gap: 6px;
  }

  .office-filter-btn {
    height: 40px;
    font-size: 0.94rem;
    padding: 0 10px;
  }

  .office-filter-label {
    gap: 4px;
  }

  .btn-mini {
    height: 36px;
    padding: 0 12px;
    font-size: 0.8rem;
    border-radius: 16px;
    flex: 0 0 auto;
  }

  .search-line {
    grid-template-columns: 1fr;
  }

  .search-actions {
    grid-template-columns: 1fr;
  }

  .list-head h2 {
    font-size: 1.4rem;
  }

  .office-option {
    text-align: center;
  }

  .modal-backdrop {
    padding: 0;
  }

  .modal-shell {
    width: 100%;
    height: 100dvh;
    max-height: 100dvh;
    min-height: 100dvh;
    padding: 10px 10px calc(10px + env(safe-area-inset-bottom));
    border-radius: 0;
    border: 0;
  }

  .detail-table th,
  .detail-table td {
    padding: 8px 9px;
    font-size: 0.8rem;
  }

  .detail-table th {
    width: 88px;
  }
}

@media (min-width: 1280px) {
  .facility-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-rows: 8px;
    gap: 10px;
    align-items: start;
  }

  .list-more-status {
    grid-column: 1 / -1;
  }

  .facility-item {
    align-self: start;
  }
}

/* === 2026-03 Calm Full Redesign === */
.inet-page {
  background:
    radial-gradient(880px 320px at -8% -10%, rgba(15, 118, 110, 0.18), rgba(15, 118, 110, 0)),
    radial-gradient(760px 260px at 108% -6%, rgba(95, 65, 156, 0.14), rgba(95, 65, 156, 0)),
    linear-gradient(180deg, #eef3f7 0%, #e6edf3 55%, #e3ebf2 100%);
}

.panel {
  border-radius: 22px;
  border: 1px solid #c5d2dd;
  box-shadow: 0 10px 22px rgba(29, 55, 76, 0.08);
}

.hero-card,
.search-card,
.list-card {
  background: #f9fcff;
}

.hero-eyebrow {
  color: #214a60;
}

.score-open-btn {
  border-color: #a4bbc9;
  background: #f6fbff;
  color: #28556d;
}

.auth-pill {
  border-color: #b4c8d5;
  background: #f4fbfd;
}

.auth-avatar {
  background: #e3f2ee;
}

.btn {
  border-radius: 12px;
  height: 42px;
}

.btn-primary {
  background: #0f766e;
  box-shadow: 0 6px 14px rgba(15, 118, 110, 0.22);
}

.btn-secondary {
  background: #dceef6;
  color: #224c63;
}

.btn-ghost {
  border-color: #bfd0dc;
  background: #fbfdff;
}

.office-filter-btn {
  border-color: #b2c5d3;
  background: #f7fbff;
  color: #254f65;
}

.default-office-pill {
  border-color: #bfd0dc;
  background: #f7fbff;
}

.search-line input {
  border-color: #bfd0dc;
  border-radius: 12px;
  background: #fcfeff;
}

.list-head h2 {
  color: #1c3d52;
}

.facility-item {
  border-radius: 14px;
  border-color: #c4d3de;
  background: #fafdff;
  box-shadow: 0 4px 10px rgba(41, 71, 92, 0.06);
}

.facility-item.even-row:not(.active) {
  border-color: #8daabd;
  background: #edf4fa;
}

.facility-item.active {
  border-color: #2d8f89;
  background: #dcefea;
}

.facility-sub-group {
  border-color: #c4d5e1;
  background: #f4f9fd;
}

.facility-item.even-row .facility-sub-group:not(.active) {
  background: #eaf2f8;
}

.facility-sub-group.active {
  border-color: #2f8f89;
  background: #e0efe9;
}

.facility-sub-item {
  border-radius: 10px;
  border-color: #c8d6e0;
  background: #f4f8fc;
  color: #3a5569;
}

.facility-item.even-row .facility-sub-item:not(.active) {
  background: #edf2f7;
}

.facility-sub-item.active {
  border-color: #2f8f89;
  background: #d9eee8;
}

.chip {
  border-radius: 12px;
  padding: 6px 12px;
}

.chip-admin {
  background: #157a73;
}

.chip-building {
  background: #6547a0;
}

.mini-register-btn {
  border-radius: 10px;
  height: 32px;
}

.mini-register-btn.register {
  border-color: #7f9db4;
  color: #234c67;
  background: linear-gradient(180deg, #f1f8ff 0%, #d9eafb 100%);
}

.mini-register-btn.register.facility-register-btn-building {
  border-color: #3d6f98;
  color: #143f62;
  background: linear-gradient(180deg, #edf6ff 0%, #b9d5ef 100%);
}

.mini-register-btn.register.facility-register-btn-dong {
  border-color: #5f8db3;
  color: #204e72;
  background: linear-gradient(180deg, #e6f3ff 0%, #c4ddf2 100%);
}

.mini-register-btn.register.facility-register-btn-line {
  border-color: #89aec9;
  color: #3d637d;
  background: linear-gradient(180deg, #f7fcff 0%, #dcecf8 100%);
}

.mini-register-btn.edit {
  border-color: #6ea58d;
  color: #1f6a48;
  background: #f1fbf5;
}

.modal-shell {
  border-radius: 24px;
  border-color: #c3d2dd;
  background: #f7fbff;
}

.detail-header {
  border-radius: 16px;
  background: #fcfeff;
  border-color: #c8d6e1;
}

.detail-table-wrap,
.comment-box {
  border-color: #c7d5e0;
  border-radius: 14px;
}

.detail-table tr:nth-child(odd) {
  background: #f5f9fd;
}

.editor-grid {
  border-color: #c4d3de;
  border-radius: 16px;
  background: #f6fbff;
}

.group-card {
  border-color: #c8d5df;
  border-radius: 13px;
  background: #fbfdff;
}

.group-card-subtle {
  background: #edf4fa;
  border-color: #bfd0dd;
}

.group-card-subtle .field {
  background: #eaf2f8;
  border-color: #c1d1dd;
}

.field {
  border-radius: 12px;
  border-color: #c6d4de;
  background: #f9fcff;
}

.field input,
.field textarea {
  border-color: #bfd0dc;
  border-radius: 11px;
  background: #fcfeff;
}


/* Compact detail header actions with desktop-inline layout */
.detail-title-row {
  flex: 1 1 auto;
  gap: 6px;
  align-items: center;
}

.detail-title-actions {
  display: inline-flex;
  flex-wrap: wrap;
  flex: 0 0 auto;
  gap: 4px;
  margin: 0 0 0 2px;
}

.detail-mini-btn {
  flex: 0 0 auto;
  height: 27px;
  padding: 0 8px;
  font-size: 0.66rem;
  border-radius: 10px;
  line-height: 1;
}

.detail-header .close-btn {
  flex: 0 0 auto;
  height: 30px;
  padding: 0 10px;
  font-size: 0.72rem;
}

@media (max-width: 980px) {
  .detail-title-actions {
    flex: 0 0 100%;
    margin-left: 0;
  }
}

@media (max-width: 640px) {
  .panel {
    border-radius: 16px;
  }

  .modal-shell {
    border-radius: 0;
  }
}
</style>
